import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AppDownloadSection from '../../components/AppDownloadSection/AppDownloadSection';
import {
  FaUtensils, FaMoon, FaClipboardList,
  FaWallet, FaLeaf, FaMotorcycle, FaCalendarAlt, FaPauseCircle, FaUserTie,
  FaPlus, FaMinus, FaTrash, FaEdit, FaPause, FaPlay,
  FaCheckCircle, FaBan, FaListUl, FaCalendarCheck, FaTimes, FaInfoCircle,
  FaChevronLeft, FaChevronRight, FaChevronDown, FaMapMarkerAlt,
  FaCheck, FaArrowRight, FaPercent,
} from 'react-icons/fa';
import plan1MonthImg from '../../assets/images/plan-card-1month.svg';
import plan2MonthImg from '../../assets/images/plan-card-2months.svg';
import plan3MonthImg from '../../assets/images/plan-card-3months.svg';
import beetrootImg from '../../assets/images/beetroot-detox.jpg';
import chapatiImg from '../../assets/images/chapati-product.jpg';
import methiImg from '../../assets/images/methi-paratha.jpg';
import southThaliMenuImg from '../../assets/images/south-thali-menu.png';
import biryaniImg from '../../assets/images/biryani-raita.jpg';
import masalaDosaImg from '../../assets/images/masala-dosa.jpg';
import SpecialtyPlansSection from '../../components/SpecialtyPlans/SpecialtyPlansSection';
import SpecialtyPlanDetailModal from '../../components/SpecialtyPlans/SpecialtyPlanDetailModal';
import AddItemsPickerModal from '../../components/SpecialtyPlans/AddItemsPickerModal';
import SubscriptionSummaryPreviewModal from '../../components/SubscriptionSummary/SubscriptionSummaryPreviewModal';
import SubscriptionReceiptModal from '../../components/SubscriptionReceipt/SubscriptionReceiptModal';
import { buildBuilderSubscriptionMeta, isBuilderSubscriptionPayload } from '../../components/SubscriptionSummary/builderSubscriptionMeta';
import { formatDisplayDate, formatDisplayDateTime } from '../../utils/dateFormat';
import { formatMoneyInr } from '../../utils/moneyFormat';
import {
  buildSlotPatternRows,
  formatSpecialtyWithRegion,
  OUR_MENU_SELECTION_LABEL,
  REGION_DISPLAY_LABELS,
  resolveDietLabel,
  filterItemSchedulesForRange,
  resolvePlanLabel,
  resolveRegionLabel,
  weekdaysInSubscriptionRange,
} from '../../utils/subscriptionDisplay';
import {
  USE_API_MEAL_PLANS,
  buildWebSubscriptionBodyFromPayload,
  createWebMealPlanSubscription,
  dayDiscountFactorFromPercent,
  fetchDayDiscounts,
  fetchSpecialtyCatalogPlans,
} from '../../api/mealPlansApi';
import {
  apiGetProfile,
  DIGIRASA_AUTH_UPDATED_EVENT,
  profilePayloadToForm,
  readStoredAuth,
  buildAuthRequiredRedirectUrl,
} from '../Account/profileFormUtils';
import { findSelectedDeliveryAddress } from '../Account/Addresses/addressManagementUtils';
import { fetchUserAddresses } from '../Cart/addressesApi';
import {
  distanceKmFromKitchen,
  formatKitchenDistance,
  storeSelectedAddressId,
} from '../Cart/cartDistanceUtils';
import {
  computeSubscriptionPeriodCharges,
  countDeliveryTripsAcrossDays,
  countDeliveryWindowsForSlots,
  buildCalendarSlotRows,
  deliveryChargePerTrip,
  getSubscriptionFreeDeliveryRadiusKm,
} from './subscriptionChargesUtils';
import {
  DAY_BAND_SNAPSHOT_PLAN_ID,
  DEFAULT_DAY_BAND_ID,
  SUBSCRIPTION_DAY_BANDS,
  SUBSCRIPTION_MIN_DAYS,
  dayBandCardDiscountPercent,
  countUniqueDeliveryDays,
  endDateForMinDays,
  endDateForMinDeliveryDays,
  getDayBandById,
  inclusiveCalendarDays,
  mergeVisibleDayBandDiscounts,
  resolveDayBandForDays,
  formatSubscriptionPlanLabel,
} from './subscriptionDayBands';
import {
  BUILDER_PLAN_CARD_COPY,
  BUILDER_SLOT_SHORT_NAME,
  builderAddressTypeMeta,
  builderCuisineLabel,
  formatSavedAddressCard,
  resolveBuilderSpecialtyTheme,
} from '../../utils/builderWizardUi';
import CheckoutAddressSection from '../Checkout/CheckoutAddressSection';
import {
  contactFromProfilePayload,
  contactFromStoredUser,
  mergeCheckoutContact,
} from '../Checkout/checkoutContactUtils';
import '../Checkout/Checkout.css';
import WeeklyMenuTable from '../../components/SpecialtyPlans/WeeklyMenuTable';
import MealSlotBadge from '../../components/SpecialtyPlans/MealSlotBadge';
import { MEAL_SLOT_TYPES } from '../../data/mealSlotTypes';
import '../../components/SpecialtyPlans/SpecialtyPlans.css';
import {
  EXTENDED_MEAL_SLOTS,
  FULL_DAY_INTERNAL_SLOT_IDS,
  FULL_DAY_UI_SLOT_ID,
  SELECTABLE_BUILDER_SLOTS,
  GENERAL_REGION_KEYS,
  getSpecialtyPlanById,
  getSpecialtyBundleProducts,
  getPlanMenuSlotIds,
  getSpecialtySlotProductId,
  isSpecialtySlotProductId,
  parseSpecialtySlotProductId,
  SPECIALTY_PLAN_CATALOG,
  collectFullDayPackageGroups,
  computeUiSlotCodes,
  makeFullDayGroupId,
  resolveAddedSlotsChargePerDay,
  resolveFullPackageDayPricing,
  resolveSpecialtyPerDayPrice,
  resolveSpecialtyPlanForRegion,
  slotsToLabel,
  syncLegacyPresetFromSlots,
  uiSlotCodeLabel,
  FULL_DAY_MEAL_DISCOUNT_PERCENT,
  getFullDayMealDiscountPercent,
} from '../../data/specialtyMealPlans';
import {
  computeBuilderDayCharge,
  computeBuilderPeriodDiscountTotals,
  resolveBuilderAppliedDayDiscount,
  USE_MAX_PLAN_UNIFORM_DISCOUNT,
} from './subscriptionDiscountCalc';
import { roundMoney } from '../../utils/moneyFormat';
import { api } from '../../api/client';
import { API_BASE_URL } from '../../config/api';
import {
  flattenActiveMenuWithItems,
  formatMenuItem,
  isMenuItemOrderable,
} from '../OurMenu/ourMenuUtils';
import { useSubscriptionCart } from '../../context/SubscriptionCartContext';
import {
  applySubscriptionCartToSlotDrafts,
  expandCartItemToDraftProducts,
  isOurMenuOnlyProductList,
  planMetaFromCartItems,
  SUBSCRIPTION_CART_KIND,
} from '../../utils/subscriptionCartItems';
import './MealPlans.css';
import './SubscriptionBuilderPreview.css';
import { sanitizePhoneDigitsInput, validatePhoneDigitsValue } from '../../utils/phone';

const plans = [
  {
    id: 1,
    name: '1 MONTH PLAN',
    duration: '30 Days',
    mealSlotLine: 'Lunch / Dinner (or both)',
    features: [
      'Seamless doorstep delivery',
      'Flexible pause/cancellation',
      'Free delivery within 2 km',
    ],
    price: 300,
    image: plan1MonthImg,
    tag: null,
  },
  {
    id: 2,
    name: '2 MONTHS PLAN',
    duration: '60 Days',
    mealSlotLine: 'Lunch / Dinner (or both)',
    features: [
      'Seamless doorstep delivery',
      'Flexible pause/cancellation',
      'Free delivery within 5 km',
    ],
    price: 275,
    image: plan2MonthImg,
    featured: true,
    savings: 'Save upto 5%',
    tag: 'MOST POPULAR',
  },
  {
    id: 3,
    name: '3 MONTHS PLAN',
    duration: '90 Days',
    mealSlotLine: 'Lunch / Dinner (or both)',
    features: [
      'Seamless doorstep delivery',
      'Flexible pause/cancellation',
      'Free delivery within 5 km + priority support',
    ],
    price: 250,
    image: plan3MonthImg,
    savings: 'Save upto 10%',
    tag: 'BEST VALUE',
  },
];

const allBuilderPlans = SUBSCRIPTION_DAY_BANDS.map((band) => ({
  id: band.id,
  name: band.title,
  duration: band.note,
  minDays: band.minDays,
  price: 300,
  band,
}));

const mealTypes = [
  { id: 'lunch',  label: 'Lunch',          icon: <FaUtensils />,     time: '12:00 PM – 2:00 PM' },
  { id: 'dinner', label: 'Dinner',         icon: <FaMoon />,         time: '7:00 PM – 9:00 PM' },
  { id: 'both',   label: 'Lunch + Dinner', icon: <FaClipboardList />, time: 'Both slots' },
];

const scheduleModes = [
  {
    id: 'daily',
    label: 'Daily',
    desc: 'Every day from your start date.',
  },
  {
    id: 'alternate_days',
    label: 'Alternative Days',
    desc: 'Delivery on every alternate day.',
  },
  {
    id: 'weekdays',
    label: 'Week Days',
    desc: 'Monday to Friday only.',
  },
  {
    id: 'specific_days',
    label: 'Specific Days',
    desc: 'Pick exactly the days you want.',
  },
];

const daysOfWeek = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

const createDefaultSlotSchedules = () => (
  EXTENDED_MEAL_SLOTS.reduce((acc, slot) => {
    acc[slot.id] = { scheduleId: 'specific_days', days: [...daysOfWeek] };
    return acc;
  }, {})
);

const resolveScheduleDays = (scheduleId, days = []) => {
  if (scheduleId === 'weekdays') return daysOfWeek.slice(0, 5);
  if (scheduleId === 'daily') return daysOfWeek;
  if (scheduleId === 'alternate_days') return ['Monday', 'Wednesday', 'Friday', 'Sunday'];
  return days;
};

const FALLBACK_SUBSCRIPTION_PRODUCTS = [
  { id: 1,  name: 'BEETROOT DETOX DRINK – 200ML',     price: 30,  category: 'Drinks',    image: beetrootImg },
  { id: 2,  name: 'CHAPATHI',                           price: 54,  category: 'Bread',     image: chapatiImg },
  { id: 3,  name: 'METHI PARATHA',                      price: 99,  category: 'Bread',     image: methiImg },
  { id: 4,  name: 'SOUTH INDIA THALI',                  price: 267, category: 'Thali',     image: southThaliMenuImg },
  { id: 5,  name: 'BIRYANI WITH RAITA',                 price: 229, category: 'Rice',      image: biryaniImg },
  { id: 6,  name: 'MASALA DOSA',                        price: 89,  category: 'Breakfast', image: masalaDosaImg },
  { id: 7,  name: 'EXECUTIVE LUNCH (NORTH INDIAN)',     price: 267, category: 'Thali',     image: masalaDosaImg },
  { id: 8,  name: 'LACHHA PARATHA',                     price: 50,  category: 'Bread',     image: methiImg },
  { id: 9,  name: 'PREMIUM LUNCH (NORTH INDIAN)',       price: 267, category: 'Thali',     image: biryaniImg },
  { id: 10, name: 'RAGI JAVA – 300ML',                  price: 55,  category: 'Drinks',    image: beetrootImg },
  { id: 11, name: 'RAGI JAVA – 200ML',                  price: 30,  category: 'Drinks',    image: beetrootImg },
  { id: 12, name: 'UPMA PESARATTU',                     price: 151, category: 'Breakfast', image: masalaDosaImg },
];

const OTHER_SLOT_PRODUCT_MAP = {
  breakfast: ['Breakfast', 'Drinks'],
  lunch: ['Thali', 'Rice', 'Bread'],
  dinner: ['Thali', 'Rice', 'Bread', 'Drinks'],
};

const createEmptySlotProducts = () => (
  EXTENDED_MEAL_SLOTS.reduce((acc, slot) => {
    acc[slot.id] = [];
    return acc;
  }, {})
);

const DEFAULT_MEAL_PRODUCT_ID = 4;
const CUSTOM_BASE_PRODUCT_ID = 400;

const isBasePlanProductId = (productId) => (
  productId === DEFAULT_MEAL_PRODUCT_ID || productId === CUSTOM_BASE_PRODUCT_ID
);

const getDefaultPlanProduct = (planId) => {
  const selectedPlan = allBuilderPlans.find((plan) => plan.id === planId);
  if (!selectedPlan) return null;

  const thali = FALLBACK_SUBSCRIPTION_PRODUCTS.find((product) => product.id === DEFAULT_MEAL_PRODUCT_ID);

  // Day-band plans are date-driven (same base product treatment as legacy custom).
  return {
    id: CUSTOM_BASE_PRODUCT_ID,
    name: thali?.name || 'SOUTH INDIA THALI',
    price: selectedPlan.price,
    category: 'Plan Base',
    image: thali?.image || southThaliMenuImg,
    quantity: 1,
    includedInPlan: true,
    isPlanBase: true,
  };
};

const DAY_INDEX = { Monday:1, Tuesday:2, Wednesday:3, Thursday:4, Friday:5, Saturday:6, Sunday:0 };
const DAY_NAMES_BY_INDEX = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

/**
 * Returns array of { date: 'YYYY-MM-DD', label: 'Mon 7 Apr', dayName } for all
 * delivery slots between startDate and endDate (inclusive) that fall on the
 * specified days array.
 */
const computeSlots = (sub) => {
  if (!sub.startDate) return [];
  const activeDays = sub.days || [];
  if (activeDays.length === 0) return [];
  
  // Parse dates as UTC to avoid timezone issues
  const parts = sub.startDate.split('-');
  const start = new Date(Date.UTC(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2])));
  let end;
  if (sub.endDate) {
    const endParts = sub.endDate.split('-');
    end = new Date(Date.UTC(parseInt(endParts[0]), parseInt(endParts[1]) - 1, parseInt(endParts[2])));
  } else {
    end = new Date(start);
    end.setUTCDate(end.getUTCDate() + 90);
  }
  
  const slots = [];
  const cur = new Date(start);
  const allowedIndices = new Set(activeDays.map(d => DAY_INDEX[d]));
  while (cur <= end) {
    if (allowedIndices.has(cur.getUTCDay())) {
      const iso = cur.toISOString().split('T')[0];
      slots.push({
        date: iso,
        label: formatDisplayDate(iso, iso),
        dayName: activeDays.find(d => DAY_INDEX[d] === cur.getUTCDay()),
      });
    }
    cur.setUTCDate(cur.getUTCDate() + 1);
  }
  return slots;
};

const faqs = [
  {
    q: 'Can I pause or cancel my subscription?',
    a: 'Yes. After your plan is approved and paid, you can pause specific future meal slots from Account → Subscriptions. When you pause, you choose whether to auto-assign a makeup day at the end of the plan, pick a particular makeup day, or leave it open and choose later. The plan end date extends when a makeup day is assigned.',
  },
  {
    q: 'How is delivery handled?',
    a: 'Breakfast travels with mid-morning snack, and lunch travels with evening snack; dinner is a separate delivery. One-month plans have free delivery within 2 km; two- and three-month plans have free delivery within 5 km. Charges apply beyond the applicable radius.',
  },
  {
    q: 'Are meals customizable?',
    a: 'Our menu rotates with 52 curated dishes every month. Special dietary requirements can be discussed with our team via the Contact page.',
  },
  {
    q: 'What areas do you deliver to?',
    a: 'We currently cover Hyderabad and surrounding areas. Check the app for live coverage at your location.',
  },
  {
    q: 'How do I subscribe?',
    a: 'Download the DigiRasa app from Google Play or App Store, select your plan, choose your meal type, and complete the payment. Delivery starts the next business day.',
  },
];

const USER_ID_KEY = 'digirasa_user_id';

const getOrCreateUserId = () => {
  const existing = localStorage.getItem(USER_ID_KEY);
  if (existing) {
    return existing;
  }
  const generated = `guest_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  localStorage.setItem(USER_ID_KEY, generated);
  return generated;
};

/** Prefer authenticated account id for summary / reference display. */
const resolvePreviewUserId = (guestLocalId = '') => {
  const { token, user } = readStoredAuth();
  if (!token) {
    if (!guestLocalId || String(guestLocalId).startsWith('guest_')) return 'Guest';
    return String(guestLocalId);
  }
  const id = user?.id ?? user?.userId ?? user?.user_id;
  if (id != null && String(id).trim() !== '') return String(id);
  const phone = user?.phone_number || user?.phone || user?.mobile;
  if (phone) return String(phone);
  if (user?.email) return String(user.email);
  return 'Signed in';
};

/** Merge profile identity fields without forcing a delivery address. */
const mergeProfileIntoCustomerDetails = (prev, fromProfile) => ({
  ...prev,
  firstName: prev.firstName || fromProfile.firstName || '',
  lastName: prev.lastName || fromProfile.lastName || '',
  phone: prev.phone || fromProfile.phone || '',
  email: prev.email || fromProfile.email || '',
  city: prev.city || fromProfile.city || 'Hyderabad',
  country: prev.country || fromProfile.country || 'India',
  state: prev.state || fromProfile.state || 'Telangana',
  pincode: prev.pincode || fromProfile.pincode || '',
});

const serializeDraftProducts = (products = []) => (
  products.map((product) => ({
    id: product.id,
    name: product.name,
    price: product.price,
    category: product.category,
    quantity: product.quantity,
    includedInPlan: Boolean(product.includedInPlan),
    slotId: product.slotId,
    days: product.days,
    planId: product.planId || undefined,
    regionKey: product.regionKey || undefined,
    isOrganic: typeof product.isOrganic === 'boolean' ? product.isOrganic : undefined,
    isFullDayPackage: Boolean(product.isFullDayPackage) || undefined,
    fullDayGroupId: product.fullDayGroupId || undefined,
  }))
);

const buildEmptyCustomerDetails = () => ({
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  locationArea: '',
  city: 'Hyderabad',
  country: 'India',
  pincode: '',
  address: '',
  latitude: null,
  longitude: null,
  state: 'Telangana',
});

/** Prefill name/phone/email (+ city/pincode when present) from getProfile / stored auth. */
const customerDetailsFromProfileSources = ({ storedUser, profileData }) => {
  const stored = contactFromStoredUser(storedUser);
  const profileContact = contactFromProfilePayload(profileData);
  const merged = mergeCheckoutContact({ stored, profile: profileContact });
  const mapped = profileData ? profilePayloadToForm(profileData) : null;
  const first = String(mapped?.form?.first_name || '').trim();
  const last = String(mapped?.form?.last_name || '').trim();
  let firstName = first;
  let lastName = last;
  if (!firstName && !lastName && merged.fullName) {
    const parts = merged.fullName.trim().split(/\s+/);
    firstName = parts[0] || '';
    lastName = parts.slice(1).join(' ');
  }
  return {
    firstName,
    lastName,
    phone: merged.phone || '',
    email: merged.email || '',
    city: String(mapped?.form?.city || '').trim() || 'Hyderabad',
    country: String(mapped?.form?.country || '').trim() || 'India',
    pincode: String(mapped?.form?.pincode || '').trim(),
    state: String(mapped?.form?.state || '').trim() || 'Telangana',
  };
};

const customerDetailsFromSavedAddress = (address) => {
  if (!address) return {};
  return {
    address: String(address.address || '').trim(),
    locationArea: String(address.name || '').trim(),
    city: String(address.city || '').trim() || 'Hyderabad',
    country: String(address.country || '').trim() || 'India',
    pincode: String(address.postalCode || '').trim(),
    state: String(address.state || '').trim() || 'Telangana',
    latitude: Number.isFinite(address.latitude) ? address.latitude : null,
    longitude: Number.isFinite(address.longitude) ? address.longitude : null,
  };
};

/** Find address by id even when lat/lng are missing (selection still applies). */
const findAddressById = (list, id) => {
  if (id == null) return null;
  const targetId = Number(id);
  if (!Number.isFinite(targetId)) return null;
  return (list || []).find((a) => Number(a.id) === targetId) || null;
};

const formatDateForDisplay = (value = '') => formatDisplayDate(value, value || '');

const parseIsoDateUtc = (value = '') => {
  if (!value || !value.includes('-')) return null;
  const [year, month, day] = value.split('-').map(Number);
  if (!year || !month || !day) return null;
  const date = new Date(Date.UTC(year, month - 1, day));
  return Number.isNaN(date.getTime()) ? null : date;
};

const toLocalIsoDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/** Earliest start: next local calendar day (24h lead time; same day is not allowed). */
const getMinSubscriptionStartDateIso = () => {
  const min = new Date();
  min.setDate(min.getDate() + 1);
  return toLocalIsoDate(min);
};

const isSubscriptionStartDateAllowed = (value, { allowPast = false } = {}) => {
  if (!value) return false;
  if (allowPast) return true;
  return value >= getMinSubscriptionStartDateIso();
};

const formatMonthLabel = (date) => date.toLocaleDateString('en-IN', { month: 'long', year: 'numeric', timeZone: 'UTC' });

const buildSummaryMonths = (startValue, endValue) => {
  const start = parseIsoDateUtc(startValue);
  const end = parseIsoDateUtc(endValue);
  if (!start || !end || end < start) return [];

  const months = [];
  const cursor = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), 1));
  const finish = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), 1));

  while (cursor <= finish) {
    months.push({
      key: `${cursor.getUTCFullYear()}-${String(cursor.getUTCMonth() + 1).padStart(2, '0')}`,
      label: formatMonthLabel(cursor),
      year: cursor.getUTCFullYear(),
      month: cursor.getUTCMonth(),
    });
    cursor.setUTCMonth(cursor.getUTCMonth() + 1);
  }

  return months;
};

const formatCurrency = formatMoneyInr;
const getItemScheduleScope = (product) => (
  product?.isFullDayPackage && product?.fullDayGroupId
    ? String(product.fullDayGroupId)
    : 'solo'
);

const getItemScheduleKey = (slotId, productId, scheduleScope = 'solo') => (
  `${slotId}::${productId}::${scheduleScope}`
);

const getItemScheduleKeyForItem = (slotId, product) => (
  getItemScheduleKey(slotId, product.id, getItemScheduleScope(product))
);

const getItemScheduleDays = (schedules, slotId, product, fallbackDays = daysOfWeek) => {
  const scopedKey = getItemScheduleKeyForItem(slotId, product);
  if (schedules[scopedKey]) return schedules[scopedKey];
  const legacyKey = `${slotId}::${product.id}`;
  return schedules[legacyKey] || [...fallbackDays];
};

const getProductRegionKey = (product) => {
  const regionKey = String(product?.regionKey || '').toLowerCase();
  return GENERAL_REGION_KEYS.includes(regionKey) ? regionKey : null;
};

const resolveGeneralCuisineLabel = (product, planId, fallbackRegionKey = 'south') => {
  const resolvedPlanId = planId || product?.planId;
  if (resolvedPlanId !== 'general') return null;
  const regionKey = getProductRegionKey(product) || fallbackRegionKey;
  return builderCuisineLabel(regionKey);
};

const BUILDER_STEP_LABELS = [
  ['Choose meals', 'What’s on your plate'],
  ['Set schedule', 'Plan length & dates'],
  ['Delivery address', 'Where we deliver'],
  ['Review', 'Price & confirm'],
];

const BUILDER_CONTINUE_LABELS = {
  1: 'Continue to schedule',
  2: 'Continue to address',
  3: 'Continue to review',
  4: 'On review step',
};

function BuilderStepFooter({
  showBack = false,
  onBack,
  continueLabel,
  continueDisabled = false,
  onContinue,
}) {
  return (
    <div className="sbp-step__footer">
      {showBack ? (
        <button type="button" className="sbp-btn sbp-btn--outline" onClick={onBack}>
          Back
        </button>
      ) : (
        <span className="sbp-step__footer-spacer" />
      )}
      <button
        type="button"
        className="sbp-btn sbp-btn--primary sbp-step-continue"
        disabled={continueDisabled}
        onClick={onContinue}
      >
        {continueLabel} <FaArrowRight />
      </button>
    </div>
  );
}

function BuilderThaliProgress({ filledSlotIds = [] }) {
  const shortLabelById = {
    breakfast: 'Brk',
    mid_morning: 'Mid',
    lunch: 'Lunch',
    evening_snack: 'Eve',
    dinner: 'Din',
  };
  const center = 60;
  const outer = 50;
  const inner = 24;
  const labelRadius = (outer + inner) / 2;
  const filledSet = new Set(filledSlotIds);
  const slots = EXTENDED_MEAL_SLOTS.slice(0, 5);

  const wedges = slots.map((slot, index) => {
    const startAngle = (-90 + index * 72) * (Math.PI / 180);
    const endAngle = (-90 + (index + 1) * 72) * (Math.PI / 180);
    const midAngle = (startAngle + endAngle) / 2;
    const outerStart = [center + outer * Math.cos(startAngle), center + outer * Math.sin(startAngle)];
    const outerEnd = [center + outer * Math.cos(endAngle), center + outer * Math.sin(endAngle)];
    const innerStart = [center + inner * Math.cos(startAngle), center + inner * Math.sin(startAngle)];
    const innerEnd = [center + inner * Math.cos(endAngle), center + inner * Math.sin(endAngle)];
    const labelX = center + labelRadius * Math.cos(midAngle);
    const labelY = center + labelRadius * Math.sin(midAngle);
    const isFilled = filledSet.has(slot.id);
    const path = [
      `M${outerStart[0]},${outerStart[1]}`,
      `A${outer},${outer} 0 0 1 ${outerEnd[0]},${outerEnd[1]}`,
      `L${innerEnd[0]},${innerEnd[1]}`,
      `A${inner},${inner} 0 0 0 ${innerStart[0]},${innerStart[1]} Z`,
    ].join(' ');
    return (
      <g key={slot.id}>
        <path
          d={path}
          className={`sbp-thali__wedge sbp-thali__wedge--${slot.id}${isFilled ? ' is-filled' : ''}`}
          stroke="#fff"
          strokeWidth="2"
        >
          <title>{slot.label}</title>
        </path>
        <text
          x={labelX}
          y={labelY}
          textAnchor="middle"
          dominantBaseline="middle"
          className={isFilled ? 'sbp-thali__label is-filled' : 'sbp-thali__label'}
        >
          {shortLabelById[slot.id] || slot.label.slice(0, 3)}
        </text>
      </g>
    );
  });

  return (
    <div className="sbp-thali-wrap">
      <svg className="sbp-thali" viewBox="0 0 120 120" role="img" aria-label={`${filledSlotIds.length} meal slots selected`}>
        <circle cx="60" cy="60" r="53" fill="none" stroke="#e0e0e0" />
        {wedges}
        <circle cx="60" cy="60" r="20" fill="var(--primary-dark)" />
        <text x="60" y="60" textAnchor="middle" dominantBaseline="middle" className="sbp-thali__center">
          {filledSlotIds.length}/5
        </text>
      </svg>
      <ul className="sbp-thali-legend" aria-label="Meal slot legend">
        {slots.map((slot) => {
          const isFilled = filledSet.has(slot.id);
          return (
            <li
              key={slot.id}
              className={`sbp-thali-legend__item sbp-thali-legend__item--${slot.id}${isFilled ? ' is-filled' : ''}`}
            >
              <i aria-hidden="true" />
              <span>{slot.label}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
const MEAL_TYPE_SUFFIX_RE = /\s*\((Regular|Organic)\)\s*$/i;

const getSubscriptionItemDisplay = (item) => {
  if (item?.isOrganic != null) {
    return {
      name: String(item.name || '').replace(MEAL_TYPE_SUFFIX_RE, '').trim(),
      isOrganic: Boolean(item.isOrganic),
    };
  }
  const match = String(item?.name || '').match(MEAL_TYPE_SUFFIX_RE);
  if (match) {
    return {
      name: item.name.replace(MEAL_TYPE_SUFFIX_RE, '').trim(),
      isOrganic: match[1].toLowerCase() === 'organic',
    };
  }
  return { name: item?.name || '', isOrganic: null };
};

const SubscriptionMealTypeBadge = ({ isOrganic, className = '' }) => (
  <span
    className={`mp-subscription-calendar__meal-type mp-subscription-calendar__meal-type--${isOrganic ? 'organic' : 'regular'}${className ? ` ${className}` : ''}`}
    title={isOrganic ? 'Organic' : 'Regular'}
    aria-label={isOrganic ? 'Organic' : 'Regular'}
  >
    {isOrganic ? <FaLeaf aria-hidden /> : <FaUtensils aria-hidden />}
  </span>
);

const getSpecialtyMealForDay = (plan, slotId, dayName) => {
  if (!plan?.weeklyMenu?.length || !dayName) return null;
  const dayRow = plan.weeklyMenu.find((row) => row.day === dayName);
  if (!dayRow?.meals?.length) return null;
  return dayRow.meals.find((meal) => meal.slotId === slotId) || null;
};

const getCalendarItemTooltipLines = (item, { slotId, dayName, regionKey = 'south', getPlanById }) => {
  const { name } = getSubscriptionItemDisplay(item);
  const specialtyRef = parseSpecialtySlotProductId(item.id);

  if (specialtyRef) {
    const resolvePlan = getPlanById || getSpecialtyPlanById;
    const plan = resolvePlan(specialtyRef.planId);
    const resolvedPlan = plan?.regionalMenus?.[regionKey]
      ? { ...plan, weeklyMenu: plan.regionalMenus[regionKey].weeklyMenu }
      : plan;
    const meal = getSpecialtyMealForDay(resolvedPlan, specialtyRef.slotId, dayName);
    if (meal) {
      const lines = [meal.item || name];
      if (meal.portion) lines.push(meal.portion);
      if (meal.calories) lines.push(meal.calories);
      return lines;
    }
  }

  const lines = [name];
  if (item.category) lines.push(item.category);
  if (item.description) lines.push(item.description);
  lines.push(formatCurrency(Number(item.price || 0) * Number(item.quantity || 1)));
  return lines;
};

const MealPlans = ({ builderOnly = false }) => {
  const [openFaq, setOpenFaq] = useState(null);
  const [userId] = useState(() => getOrCreateUserId());
  const [previewUserId, setPreviewUserId] = useState(() => resolvePreviewUserId(getOrCreateUserId()));
  const [selectedPlanId, setSelectedPlanId] = useState(DEFAULT_DAY_BAND_ID);
  const [selectedMealType, setSelectedMealType] = useState('lunch');
  const [selectedSlotIds, setSelectedSlotIds] = useState(['lunch']);
  const [selectedSpecialtyPlanId, setSelectedSpecialtyPlanId] = useState(null);
  const [useOrganicPricing, setUseOrganicPricing] = useState(false);
  const [specialtyRegionKey, setSpecialtyRegionKey] = useState('south');
  const [specialtyDetailPlan, setSpecialtyDetailPlan] = useState(null);
  const [slotSampleModal, setSlotSampleModal] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = useState('daily');
  const [selectedDays, setSelectedDays] = useState([]);
  const [slotSchedules, setSlotSchedules] = useState(() => createDefaultSlotSchedules());
  const [itemSchedules, setItemSchedules] = useState({});
  const [subscriptionTitle, setSubscriptionTitle] = useState('');
  const [customerDetails, setCustomerDetails] = useState(() => buildEmptyCustomerDetails());
  const [startDate, setStartDate] = useState(() => getMinSubscriptionStartDateIso());
  const [draftProducts, setDraftProducts] = useState(() => {
    const defaultProduct = getDefaultPlanProduct(DEFAULT_DAY_BAND_ID);
    return defaultProduct ? [defaultProduct] : [];
  });
  const [slotDraftProducts, setSlotDraftProducts] = useState(() => createEmptySlotProducts());
  const {
    subscriptionCartItems,
    addToSubscriptionCart,
    removeFromSubscriptionCart,
    updateSubscriptionCartQty,
    clearSubscriptionCart,
  } = useSubscriptionCart();
  const [editingSubscriptionId, setEditingSubscriptionId] = useState(null);
  const [loadingSubscriptions, setLoadingSubscriptions] = useState(true);
  const [dayDiscounts, setDayDiscounts] = useState([]);
  const [specialtyCatalogPlans, setSpecialtyCatalogPlans] = useState(SPECIALTY_PLAN_CATALOG);
  const [subscriptionProducts, setSubscriptionProducts] = useState(FALLBACK_SUBSCRIPTION_PRODUCTS);
  const [ourMenuProductsLoading, setOurMenuProductsLoading] = useState(true);
  const [apiBusy, setApiBusy] = useState(false);
  const [apiMessage, setApiMessage] = useState('');
  const [subscriptionSuccess, setSubscriptionSuccess] = useState(null);
  const [subError, setSubError] = useState('');
  const [customerFieldErrors, setCustomerFieldErrors] = useState({});
  const [subscriptions, setSubscriptions] = useState([]);
  const [endDate, setEndDate] = useState(() => (
    endDateForMinDays(getMinSubscriptionStartDateIso(), getDayBandById(DEFAULT_DAY_BAND_ID).minDays)
  ));
  const [productModalOpen, setProductModalOpen] = useState(false);
  const [builderPickerMode, setBuilderPickerMode] = useState('plan');
  const [builderPickerPlanId, setBuilderPickerPlanId] = useState(SPECIALTY_PLAN_CATALOG[0]?.id || 'general');
  const [builderPickerSlotId, setBuilderPickerSlotId] = useState('breakfast');
  const [builderPickerIntent, setBuilderPickerIntent] = useState('full-day');
  const [builderPickerEntryId, setBuilderPickerEntryId] = useState(null);
  const [builderItemDetail, setBuilderItemDetail] = useState(null);
  const [expandedFullDayGroupIds, setExpandedFullDayGroupIds] = useState(() => new Set());
  const [deleteConfirmItem, setDeleteConfirmItem] = useState(null);
  const [clearAllConfirmOpen, setClearAllConfirmOpen] = useState(false);
  const [summaryPreviewOpen, setSummaryPreviewOpen] = useState(false);
  const [planOverviewOpen, setPlanOverviewOpen] = useState(false);
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [detailsPrefillBusy, setDetailsPrefillBusy] = useState(false);
  const [acceptSubscriptionTerms, setAcceptSubscriptionTerms] = useState(false);
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [addressesLoading, setAddressesLoading] = useState(false);
  const [showManualAddress, setShowManualAddress] = useState(true);
  const [addressPickerOpen, setAddressPickerOpen] = useState(false);
  const [pendingAddressId, setPendingAddressId] = useState(null);
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [productFilter, setProductFilter] = useState('All');
  // Slot management
  const [slotModalSub, setSlotModalSub]   = useState(null);   // subscription whose slots are shown
  const [pausedSlots,  setPausedSlots]    = useState({});     // { [subId]: Set<'YYYY-MM-DD'> }
  const [slotFilter,   setSlotFilter]     = useState('upcoming'); // 'all'|'upcoming'|'paused'|'delivered'
  const [pauseDowPick, setPauseDowPick]   = useState('');     // day-of-week for bulk DOW pause
  const [activeDateField, setActiveDateField] = useState('');
  const [summaryMonthIndex, setSummaryMonthIndex] = useState(0);
  const [builderStep, setBuilderStep] = useState(1);
  const [highestBuilderStep, setHighestBuilderStep] = useState(1);
  const [titleEditing, setTitleEditing] = useState(false);
  const [reviewCalendarOpen, setReviewCalendarOpen] = useState(false);
  const builderNavRef = useRef(null);
  const titleChipInputRef = useRef(null);
  const builderSectionRef = useRef(null);
  const builderTitleRef = useRef(null);
  const startDateInputRef = useRef(null);
  const endDateInputRef = useRef(null);
  const successSectionRef = useRef(null);
  const location = useLocation();
  const BUILDER_SCROLL_NAV_OFFSET = 168;

  useEffect(() => {
    if (!builderOnly) return undefined;
    window.scrollTo(0, 0);
  }, [builderOnly, location.pathname]);

  useEffect(() => {
    const shouldScrollToBuilder = !builderOnly && location.hash === '#subscription-builder';
    if (!shouldScrollToBuilder) return undefined;
    if (subscriptionSuccess) return undefined;

    const scrollToBuilder = () => {
      const target = builderSectionRef.current;
      if (!target) return;

      const top = target.getBoundingClientRect().top + window.scrollY - BUILDER_SCROLL_NAV_OFFSET;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    };

    const timer = window.setTimeout(scrollToBuilder, 100);
    return () => window.clearTimeout(timer);
  }, [builderOnly, location.hash, location.pathname, subscriptionSuccess]);

  useEffect(() => {
    if (!subscriptionSuccess) return undefined;
    const timer = window.setTimeout(() => {
      successSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
    return () => window.clearTimeout(timer);
  }, [subscriptionSuccess]);

  /** Prefill signed-in profile into customer details (address stays blank until selected). */
  useEffect(() => {
    let cancelled = false;

    const loadSignedInCustomer = async () => {
      setPreviewUserId(resolvePreviewUserId(userId));
      const { token, user: storedUser } = readStoredAuth();
      if (!token) {
        setSavedAddresses([]);
        setSelectedAddressId(null);
        setShowManualAddress(true);
        return;
      }

      let profileData = null;
      try {
        const { res, data } = await apiGetProfile(token);
        if (res.ok) profileData = data;
      } catch {
        /* stored-user fallback */
      }
      if (cancelled) return;

      const fromProfile = customerDetailsFromProfileSources({ storedUser, profileData });
      const mapped = profileData ? profilePayloadToForm(profileData) : null;
      const accountId = mapped?.id ?? storedUser?.id ?? storedUser?.userId ?? null;
      if (accountId != null && String(accountId).trim() !== '') {
        setPreviewUserId(String(accountId));
      } else {
        setPreviewUserId(resolvePreviewUserId(userId));
      }

      setCustomerDetails((prev) => {
        if (editingSubscriptionId) {
          return mergeProfileIntoCustomerDetails(prev, fromProfile);
        }
        return mergeProfileIntoCustomerDetails(
          {
            ...buildEmptyCustomerDetails(),
            address: prev.address,
            locationArea: prev.locationArea,
            latitude: prev.latitude,
            longitude: prev.longitude,
            pincode: prev.pincode,
          },
          fromProfile,
        );
      });
    };

    loadSignedInCustomer();
    const onAuth = () => {
      loadSignedInCustomer();
    };
    window.addEventListener(DIGIRASA_AUTH_UPDATED_EVENT, onAuth);
    return () => {
      cancelled = true;
      window.removeEventListener(DIGIRASA_AUTH_UPDATED_EVENT, onAuth);
    };
  }, [userId, editingSubscriptionId]);

  useEffect(() => {
    if (!USE_API_MEAL_PLANS) return undefined;
    let cancelled = false;
    fetchDayDiscounts()
      .then((rows) => {
        if (!cancelled) setDayDiscounts(Array.isArray(rows) ? rows : []);
      })
      .catch(() => {
        if (!cancelled) setDayDiscounts([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!USE_API_MEAL_PLANS) return undefined;
    let cancelled = false;
    fetchSpecialtyCatalogPlans()
      .then(({ plans }) => {
        if (cancelled || !plans?.length) return;
        setSpecialtyCatalogPlans(plans);
        setBuilderPickerPlanId((prev) => (
          plans.some((plan) => plan.id === prev) ? prev : (plans[0]?.id || prev)
        ));
      })
      .catch((err) => {
        console.warn('CREATE YOUR PLAN specialty catalog API failed; using local catalog.', err);
        if (!cancelled) setSpecialtyCatalogPlans(SPECIALTY_PLAN_CATALOG);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    setOurMenuProductsLoading(true);
    api.get(`${API_BASE_URL}/menu/activeMenuWithItems?includeAvailabilityStatus=true`)
      .then(({ data }) => {
        if (cancelled) return;
        const rows = flattenActiveMenuWithItems(data)
          .map(formatMenuItem)
          .filter(isMenuItemOrderable);
        if (!rows.length) {
          setSubscriptionProducts(FALLBACK_SUBSCRIPTION_PRODUCTS);
          return;
        }
        const byId = new Map(rows.map((item) => [item.id, item]));
        FALLBACK_SUBSCRIPTION_PRODUCTS.forEach((item) => {
          if (!byId.has(item.id)) byId.set(item.id, item);
        });
        setSubscriptionProducts(
          [...byId.values()].sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''))),
        );
      })
      .catch(() => {
        if (!cancelled) setSubscriptionProducts(FALLBACK_SUBSCRIPTION_PRODUCTS);
      })
      .finally(() => {
        if (!cancelled) setOurMenuProductsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const getCatalogSpecialtyPlanById = useCallback(
    (id) => specialtyCatalogPlans.find((plan) => plan.id === id) || getSpecialtyPlanById(id),
    [specialtyCatalogPlans],
  );

  const selectedPlan = useMemo(
    () => allBuilderPlans.find((plan) => plan.id === selectedPlanId) || allBuilderPlans[0],
    [selectedPlanId]
  );

  const effectiveDays = useMemo(() => {
    return resolveScheduleDays(selectedSchedule, selectedDays);
  }, [selectedSchedule, selectedDays]);

  const slotScheduleRows = useMemo(() => (
    EXTENDED_MEAL_SLOTS.map((slot) => {
      const schedule = slotSchedules[slot.id] || { scheduleId: 'daily', days: [] };
      return {
        slotId: slot.id,
        scheduleId: schedule.scheduleId,
        days: resolveScheduleDays(schedule.scheduleId, schedule.days),
      };
    })
  ), [slotSchedules]);

  const selectedSlotScheduleRows = useMemo(
    () => slotScheduleRows.filter((row) => selectedSlotIds.includes(row.slotId)),
    [slotScheduleRows, selectedSlotIds],
  );
  const itemScheduleRows = useMemo(() => (
    Object.entries(slotDraftProducts).flatMap(([slotId, products]) => (
      (products || []).map((product) => {
        const key = getItemScheduleKeyForItem(slotId, product);
        return {
          key,
          slotId,
          productId: product.id,
          scheduleScope: getItemScheduleScope(product),
          days: getItemScheduleDays(itemSchedules, slotId, product),
        };
      })
    ))
  ), [slotDraftProducts, itemSchedules]);
  const hasEmptySlotSpecificSchedule = itemScheduleRows.some((row) => row.days.length === 0);

  const deliveryScheduleRows = useMemo(() => {
    if (builderOnly) {
      return itemScheduleRows.filter((row) => row.days.length > 0);
    }
    return effectiveDays.length ? [{ days: effectiveDays }] : [];
  }, [builderOnly, itemScheduleRows, effectiveDays]);

  const resolveBandEndDate = useCallback((startIso, bandMinDays) => {
    if (!startIso) return '';
    if (deliveryScheduleRows.length) {
      return endDateForMinDeliveryDays(startIso, bandMinDays, deliveryScheduleRows);
    }
    return endDateForMinDays(startIso, bandMinDays);
  }, [deliveryScheduleRows]);

  const countDeliveryDaysForRange = useCallback((startIso, endIso) => {
    if (!startIso || !endIso) return 0;
    if (deliveryScheduleRows.length) {
      return countUniqueDeliveryDays(startIso, endIso, deliveryScheduleRows);
    }
    return inclusiveCalendarDays(startIso, endIso);
  }, [deliveryScheduleRows]);

  const selectedDayBand = useMemo(
    () => getDayBandById(selectedPlanId),
    [selectedPlanId],
  );

  const computedEndDate = useMemo(() => {
    if (!startDate) return '';
    return resolveBandEndDate(startDate, selectedDayBand.minDays);
  }, [startDate, selectedDayBand.minDays, resolveBandEndDate]);

  /**
   * Weekdays that fall inside a short date range (< 7 days).
   * Used only for visual hints — does not change the user's day selection.
   */
  const inRangeWeekdays = useMemo(() => {
    if (!startDate || !endDate) return null;

    const start = parseIsoDateUtc(startDate);
    const finish = parseIsoDateUtc(endDate);

    if (!start || !finish || finish < start) return null;

    const rangeDays = inclusiveCalendarDays(startDate, endDate);
    if (rangeDays >= 7) return null;

    const allowed = new Set();
    const cursor = new Date(start);
    while (cursor <= finish) {
      allowed.add(DAY_NAMES_BY_INDEX[cursor.getUTCDay()]);
      cursor.setUTCDate(cursor.getUTCDate() + 1);
    }
    return allowed;
  }, [startDate, endDate]);

  const activeEndDate = endDate || computedEndDate;
  const planCalendarDays = useMemo(
    () => inclusiveCalendarDays(startDate, activeEndDate),
    [startDate, activeEndDate],
  );
  const inferredSpecialtyPlanId = useMemo(() => {
    const sources = builderOnly
      ? Object.values(slotDraftProducts).flat()
      : draftProducts;
    for (const item of sources || []) {
      if (!item) continue;
      if (item.planId) return item.planId;
      const ref = parseSpecialtySlotProductId(item.id);
      if (ref?.planId) return ref.planId;
    }
    // Reuse the picker specialty only for packaged specialty / Full Day lines.
    // Our menu (à la carte) drafts must not inherit the picker default.
    if (builderOnly && builderPickerPlanId) {
      const hasPackaged = (sources || []).some((item) => (
        item
        && (
          item.planId
          || item.isFullDayPackage
          || item.kind === SUBSCRIPTION_CART_KIND.specialty
          || item.kind === SUBSCRIPTION_CART_KIND.fullDay
          || Boolean(parseSpecialtySlotProductId(item.id)?.planId)
        )
      ));
      if (hasPackaged) return builderPickerPlanId;
    }
    return null;
  }, [builderOnly, slotDraftProducts, draftProducts, builderPickerPlanId]);
  const effectiveSpecialtyPlanId = selectedSpecialtyPlanId || inferredSpecialtyPlanId;
  const specialtyPlan = useMemo(
    () => (effectiveSpecialtyPlanId ? getCatalogSpecialtyPlanById(effectiveSpecialtyPlanId) : null),
    [effectiveSpecialtyPlanId, getCatalogSpecialtyPlanById],
  );
  const activeSpecialtyPlan = useMemo(() => {
    if (!specialtyPlan) return null;
    if (!specialtyPlan.regionalMenus?.[specialtyRegionKey]) {
      return specialtyPlan;
    }
    const region = specialtyPlan.regionalMenus[specialtyRegionKey];
    return { ...specialtyPlan, weeklyMenu: region.weeklyMenu };
  }, [specialtyPlan, specialtyRegionKey]);
  const specialtyPerDayPrice = useMemo(() => {
    if (!specialtyPlan || selectedSlotIds.length === 0) return null;
    const menuSlotIds = getPlanMenuSlotIds(specialtyPlan);
    return resolveAddedSlotsChargePerDay(specialtyPlan, selectedSlotIds, menuSlotIds, useOrganicPricing);
  }, [specialtyPlan, selectedSlotIds, useOrganicPricing]);
  /** Standard plans bill per slot; specialty bundle price is already all-in for the selection. */
  const slotMultiplier = specialtyPerDayPrice != null
    ? 1
    : Math.max(1, selectedSlotIds.length);
  const builderSlotProductsFlat = useMemo(
    () => Object.entries(slotDraftProducts).flatMap(([slotId, products]) => (
      (products || []).map((product) => ({
        ...product,
        slotId,
        days: getItemScheduleDays(itemSchedules, slotId, product),
      }))
    )),
    [slotDraftProducts, itemSchedules],
  );
  const activeDraftProducts = builderOnly ? builderSlotProductsFlat : draftProducts;
  const hasBasePlanItem = builderOnly
    ? false
    : draftProducts.some((item) => isBasePlanProductId(item.id));
  const deliveriesPerWeek = effectiveDays.length;
  const deliverySlotCount = useMemo(() => {
    if (!startDate || !activeEndDate || effectiveDays.length === 0) return 0;
    if (builderOnly) {
      return itemScheduleRows.reduce((sum, row) => {
        if (!row.days.length) return sum;
        return sum + computeSlots({ startDate, endDate: activeEndDate, days: row.days }).length;
      }, 0);
    }
    return computeSlots({ startDate, endDate: activeEndDate, days: effectiveDays }).length * slotMultiplier;
  }, [builderOnly, startDate, activeEndDate, effectiveDays, slotMultiplier, itemScheduleRows]);
  const deliveryDayCount = useMemo(() => {
    if (!builderOnly) {
      return deliverySlotCount > 0 ? Math.round(deliverySlotCount / slotMultiplier) : 0;
    }
    if (!startDate || !activeEndDate) return 0;
    const uniqueDates = new Set();
    itemScheduleRows.forEach((row) => {
      computeSlots({ startDate, endDate: activeEndDate, days: row.days }).forEach((slot) => uniqueDates.add(slot.date));
    });
    return uniqueDates.size;
  }, [builderOnly, deliverySlotCount, slotMultiplier, startDate, activeEndDate, itemScheduleRows]);
  // Delivery trip windows: breakfast+mid-morning, lunch+evening snack, dinner.
  // Multiple products in the same window on the same day still count as one trip.
  const deliveryTripCount = useMemo(() => {
    if (!startDate || !activeEndDate) return 0;
    if (builderOnly) {
      const slotsByDate = new Map();
      itemScheduleRows.forEach((row) => {
        if (!(slotDraftProducts[row.slotId] || []).length) return;
        computeSlots({
          startDate,
          endDate: activeEndDate,
          days: row.days,
        }).forEach((slot) => {
          if (!slotsByDate.has(slot.date)) slotsByDate.set(slot.date, new Set());
          slotsByDate.get(slot.date).add(row.slotId);
        });
      });
      return countDeliveryTripsAcrossDays(
        [...slotsByDate.values()].map((slotIds) => ({ slotIds: [...slotIds] })),
      );
    }
    const tripsPerDay = countDeliveryWindowsForSlots(selectedSlotIds);
    if (!tripsPerDay) return 0;
    return computeSlots({ startDate, endDate: activeEndDate, days: effectiveDays }).length
      * tripsPerDay;
  }, [
    builderOnly,
    startDate,
    activeEndDate,
    slotDraftProducts,
    itemScheduleRows,
    effectiveDays,
    selectedSlotIds,
  ]);
  const visibleDayDiscounts = useMemo(() => mergeVisibleDayBandDiscounts(
    (dayDiscounts || []).filter((row) => String(row.status || 'active').toLowerCase() === 'active'),
  ), [dayDiscounts]);
  const appliedDayDiscount = useMemo(
    () => resolveBuilderAppliedDayDiscount({
      visibleDayDiscounts,
      deliveryDayCount,
      selectedDayBand,
    }),
    [visibleDayDiscounts, deliveryDayCount, selectedDayBand],
  );
  const packageDiscountFactor = dayDiscountFactorFromPercent(appliedDayDiscount.discountPercent);
  const selectedBandDiscountPercent = useMemo(
    () => dayBandCardDiscountPercent(selectedDayBand, visibleDayDiscounts),
    [selectedDayBand, visibleDayDiscounts],
  );
  const draftProductPerDeliveryCost = activeDraftProducts.reduce((sum, item) => {
    const billableQty = item.includedInPlan ? Math.max(0, item.quantity - 1) : item.quantity;
    const itemPrice = builderOnly ? Math.round(item.price * packageDiscountFactor) : item.price;
    return sum + itemPrice * billableQty;
  }, 0);
  const basePlanPrice = specialtyPerDayPrice != null
    ? specialtyPerDayPrice
    : (hasBasePlanItem ? selectedPlan.price : 0);
  const estimatedPerDelivery = activeDraftProducts.length === 0
    ? 0
    : basePlanPrice + draftProductPerDeliveryCost;
  const builderSubscriptionTotals = useMemo(() => {
    if (!builderOnly || !startDate || !activeEndDate) {
      return {
        actual: 0,
        saving: 0,
        final: 0,
        packageSaving: 0,
        volumeSaving: 0,
        discountSaving: 0,
        discountLabel: null,
        discountPercent: 0,
      };
    }

    if (USE_MAX_PLAN_UNIFORM_DISCOUNT) {
      return computeBuilderPeriodDiscountTotals({
        startDate,
        endDate: activeEndDate,
        products: activeDraftProducts,
        getPlanById: getCatalogSpecialtyPlanById,
        volumeDiscountFactor: packageDiscountFactor,
        volumeDiscountPercent: appliedDayDiscount.discountPercent,
      });
    }

    const start = parseIsoDateUtc(startDate);
    const end = parseIsoDateUtc(activeEndDate);
    if (!start || !end) {
      return {
        actual: 0,
        saving: 0,
        final: 0,
        packageSaving: 0,
        volumeSaving: 0,
        discountSaving: 0,
        discountLabel: null,
        discountPercent: 0,
      };
    }

    let actual = 0;
    let finalPrecise = 0;
    let packageSaving = 0;
    let volumeSaving = 0;
    const discountLabels = new Set();
    const discountPercents = new Set();
    const cursor = new Date(start);
    while (cursor <= end) {
      const dayName = DAY_NAMES_BY_INDEX[cursor.getUTCDay()];
      const dayCharge = computeBuilderDayCharge({
        dayName,
        products: activeDraftProducts,
        getPlanById: getCatalogSpecialtyPlanById,
        volumeDiscountFactor: packageDiscountFactor,
      });
      actual += dayCharge.actual;
      finalPrecise += dayCharge.final;
      packageSaving += dayCharge.packageSaving;
      volumeSaving += dayCharge.volumeSaving;
      if (dayCharge.discountLabel) discountLabels.add(dayCharge.discountLabel);
      if (dayCharge.discountPercent) discountPercents.add(Number(dayCharge.discountPercent));
      cursor.setUTCDate(cursor.getUTCDate() + 1);
    }

    const final = roundMoney(finalPrecise);
    const discountSaving = roundMoney(actual - final);

    return {
      actual,
      saving: discountSaving,
      final,
      packageSaving: roundMoney(packageSaving),
      volumeSaving: roundMoney(volumeSaving),
      discountSaving,
      discountLabel: discountLabels.size === 1 ? [...discountLabels][0] : null,
      discountPercent: discountPercents.size === 1 ? [...discountPercents][0] : 0,
    };
  }, [
    builderOnly,
    startDate,
    activeEndDate,
    activeDraftProducts,
    packageDiscountFactor,
    appliedDayDiscount.discountPercent,
    getCatalogSpecialtyPlanById,
  ]);

  const planLengthMonths = useMemo(() => {
    const days = Math.max(
      SUBSCRIPTION_MIN_DAYS,
      deliveryDayCount || selectedDayBand.minDays || SUBSCRIPTION_MIN_DAYS,
    );
    return Math.max(1, days / 30);
  }, [deliveryDayCount, selectedDayBand.minDays]);

  const fallbackTotalEstimate = Math.round(estimatedPerDelivery * deliveriesPerWeek * slotMultiplier * 4.3 * planLengthMonths);
  const estimatedTotalRaw = builderOnly
    ? builderSubscriptionTotals.actual
    : deliverySlotCount > 0
    ? Math.round(estimatedPerDelivery * deliverySlotCount)
    : fallbackTotalEstimate;
  const estimatedTotal = builderOnly
    ? builderSubscriptionTotals.final
    : Math.round(estimatedTotalRaw * packageDiscountFactor);

  const selectedProductCount = activeDraftProducts.reduce((sum, item) => sum + item.quantity, 0);
  const selectedBuilderSlotIds = useMemo(
    () => Object.entries(slotDraftProducts)
      .filter(([, products]) => (products || []).length > 0)
      .map(([slotId]) => slotId),
    [slotDraftProducts],
  );

  const builderUiSlotCodes = useMemo(
    () => computeUiSlotCodes(slotDraftProducts),
    [slotDraftProducts],
  );

  const fullDayPackageGroups = useMemo(
    () => collectFullDayPackageGroups(slotDraftProducts),
    [slotDraftProducts],
  );
  const hasFullDaySelection = fullDayPackageGroups.length > 0
    || builderUiSlotCodes.includes(FULL_DAY_UI_SLOT_ID);
  const fullDayPlanDiscountPercent = useMemo(() => {
    const fromCatalog = Number(getFullDayMealDiscountPercent(specialtyPlan));
    if (Number.isFinite(fromCatalog) && fromCatalog > 0) return fromCatalog;
    return FULL_DAY_MEAL_DISCOUNT_PERCENT;
  }, [specialtyPlan]);

  /** Top chip + plan overview — match charge calculation, not just the selected day band. */
  const summaryDiscountPercent = useMemo(() => {
    const fromTotals = Number(builderSubscriptionTotals.discountPercent);
    if (fromTotals > 0) return fromTotals;
    return Number(appliedDayDiscount.discountPercent) || 0;
  }, [builderSubscriptionTotals.discountPercent, appliedDayDiscount.discountPercent]);

  const summaryDeliveryDaysLabel = useMemo(() => {
    if (deliveryDayCount > 0) {
      return `${deliveryDayCount} delivery day${deliveryDayCount === 1 ? '' : 's'}`;
    }
    return selectedDayBand?.title || selectedPlan?.name || null;
  }, [deliveryDayCount, selectedDayBand?.title, selectedPlan?.name]);

  const subscriptionDistanceKm = useMemo(() => {
    const selected = selectedAddressId != null
      ? (findSelectedDeliveryAddress(savedAddresses, selectedAddressId)
        || findAddressById(savedAddresses, selectedAddressId))
      : null;
    const lat = selected && Number.isFinite(selected.latitude)
      ? selected.latitude
      : customerDetails.latitude;
    const lng = selected && Number.isFinite(selected.longitude)
      ? selected.longitude
      : customerDetails.longitude;
    return distanceKmFromKitchen({ latitude: lat, longitude: lng });
  }, [
    selectedAddressId,
    savedAddresses,
    customerDetails.latitude,
    customerDetails.longitude,
  ]);

  const liveCharges = useMemo(() => {
    const days = Math.max(1, deliveryDayCount || 1);
    const freeDeliveryRadiusKm = getSubscriptionFreeDeliveryRadiusKm({
      planId: selectedPlanId,
      deliveryDays: days,
    });
    return computeSubscriptionPeriodCharges({
      periodSubtotal: estimatedTotal,
      days,
      deliveryTripCount: Math.max(1, deliveryTripCount),
      distanceKm: subscriptionDistanceKm,
      freeDeliveryRadiusKm,
      // Prefer distance-based delivery once coords exist; avoid flat fallback then.
      allowFallbackDelivery: subscriptionDistanceKm == null,
    });
  }, [
    estimatedTotal,
    deliveryDayCount,
    deliveryTripCount,
    subscriptionDistanceKm,
    selectedPlanId,
  ]);

  const builderSlotItemCount = useMemo(
    () => Object.values(slotDraftProducts).reduce((sum, products) => sum + (products?.length || 0), 0),
    [slotDraftProducts],
  );
  const selectedDaysLabel = effectiveDays.length > 0
    ? `${effectiveDays.length} day${effectiveDays.length === 1 ? '' : 's'} / week`
    : 'Not selected';
  const dateRangeLabel = startDate
    ? `${formatDateForDisplay(startDate)}${activeEndDate ? ` → ${formatDateForDisplay(activeEndDate)}` : ''}`
    : 'Not selected';
  const summaryMonths = useMemo(
    () => buildSummaryMonths(startDate, activeEndDate),
    [startDate, activeEndDate],
  );
  const activeSummaryMonth = summaryMonths[Math.min(summaryMonthIndex, Math.max(0, summaryMonths.length - 1))] || null;
  const summaryDays = useMemo(() => {
    if (!activeSummaryMonth) return [];
    const start = parseIsoDateUtc(startDate);
    const end = parseIsoDateUtc(activeEndDate);
    if (!start || !end) return [];

    const monthStart = new Date(Date.UTC(activeSummaryMonth.year, activeSummaryMonth.month, 1));
    const monthEnd = new Date(Date.UTC(activeSummaryMonth.year, activeSummaryMonth.month + 1, 0));
    const cursor = new Date(Math.max(start.getTime(), monthStart.getTime()));
    const finish = new Date(Math.min(end.getTime(), monthEnd.getTime()));
    const days = [];

    while (cursor <= finish) {
      const iso = cursor.toISOString().split('T')[0];
      days.push({
        iso,
        date: cursor.getUTCDate(),
        dayShort: cursor.toLocaleDateString('en-IN', { weekday: 'short', timeZone: 'UTC' }),
        dateLabel: formatDisplayDate(iso),
        dateShort: `${String(cursor.getUTCDate()).padStart(2, '0')} ${cursor.toLocaleDateString('en-IN', { month: 'short', timeZone: 'UTC' })}`,
        dayName: DAY_NAMES_BY_INDEX[cursor.getUTCDay()],
      });
      cursor.setUTCDate(cursor.getUTCDate() + 1);
    }

    return days;
  }, [activeSummaryMonth, startDate, activeEndDate]);
  const summarySlotRows = useMemo(() => (
    EXTENDED_MEAL_SLOTS.map((slot) => ({
      ...slot,
      products: slotDraftProducts[slot.id] || [],
    }))
  ), [slotDraftProducts]);
  const calendarSlotRows = useMemo(
    () => buildCalendarSlotRows(slotDraftProducts, { hasFullDayPackages: hasFullDaySelection })
      .map((row) => ({
        ...row,
        label: row.slotIds.length > 1
          ? row.label
          : (BUILDER_SLOT_SHORT_NAME[row.id] || row.label),
      })),
    [slotDraftProducts, hasFullDaySelection],
  );
  const summaryDayTotals = useMemo(() => (
    summaryDays.map((day) => {
      if (builderOnly) {
        const dayCharge = computeBuilderDayCharge({
          dayName: day.dayName,
          products: activeDraftProducts,
          getPlanById: getCatalogSpecialtyPlanById,
          volumeDiscountFactor: packageDiscountFactor,
        });
        return {
          iso: day.iso,
          actual: dayCharge.actual,
          packageSaving: dayCharge.packageSaving,
          volumeSaving: dayCharge.volumeSaving,
          discountSaving: dayCharge.discountSaving,
          discountLabel: dayCharge.discountLabel,
          saving: dayCharge.saving,
          final: dayCharge.final,
        };
      }

      let actual = 0;
      let final = 0;
      summarySlotRows.forEach((slot) => {
        slot.products.forEach((product) => {
          const productDays = getItemScheduleDays(itemSchedules, slot.id, product);
          if (!productDays.includes(day.dayName)) return;
          const quantity = Number(product.quantity || 1);
          const price = Number(product.price || 0);
          const billable = price * (product.includedInPlan ? Math.max(0, quantity - 1) : quantity);
          const lineActual = billable;
          actual += lineActual;
          final += Math.round(lineActual * packageDiscountFactor);
        });
      });
      const discountSaving = Math.max(0, actual - final);
      return {
        iso: day.iso,
        actual,
        packageSaving: 0,
        volumeSaving: discountSaving,
        discountSaving,
        discountLabel: discountSaving > 0 ? 'Day subscription' : null,
        saving: discountSaving,
        final,
      };
    })
  ), [
    summaryDays,
    summarySlotRows,
    itemSchedules,
    builderOnly,
    packageDiscountFactor,
    activeDraftProducts,
    getCatalogSpecialtyPlanById,
  ]);

  const summaryDiscountLabel = useMemo(() => {
    const labels = new Set(
      (summaryDayTotals || [])
        .map((day) => day.discountLabel)
        .filter(Boolean),
    );
    return labels.size === 1 ? [...labels][0] : null;
  }, [summaryDayTotals]);

  /** Full plan period (start→end), not the visible calendar month slice. */
  const subscriptionPeriodTotals = useMemo(() => {
    if (!startDate || !activeEndDate) {
      return {
        actual: 0,
        saving: 0,
        final: 0,
        dayCount: 0,
        packageSaving: 0,
        volumeSaving: 0,
        discountSaving: 0,
        discountLabel: null,
        discountPercent: 0,
      };
    }
    if (builderOnly) {
      return {
        ...builderSubscriptionTotals,
        dayCount: deliveryDayCount,
      };
    }

    const periodDays = [];
    const start = parseIsoDateUtc(startDate);
    const end = parseIsoDateUtc(activeEndDate);
    if (!start || !end) return { actual: 0, saving: 0, final: 0, dayCount: 0 };
    const cursor = new Date(start);
    while (cursor <= end) {
      periodDays.push({
        dayName: DAY_NAMES_BY_INDEX[cursor.getUTCDay()],
      });
      cursor.setUTCDate(cursor.getUTCDate() + 1);
    }

    let actual = 0;
    let final = 0;
    periodDays.forEach((day) => {
      summarySlotRows.forEach((slot) => {
        slot.products.forEach((product) => {
          const productDays = getItemScheduleDays(itemSchedules, slot.id, product);
          if (!productDays.includes(day.dayName)) return;
          const quantity = Number(product.quantity || 1);
          const price = Number(product.price || 0);
          const billable = price * (product.includedInPlan ? Math.max(0, quantity - 1) : quantity);
          actual += billable;
          final += Math.round(billable * packageDiscountFactor);
        });
      });
    });
    return {
      actual,
      saving: Math.max(0, actual - final),
      final,
      dayCount: deliveryDayCount,
      packageSaving: 0,
      volumeSaving: Math.max(0, actual - final),
      discountSaving: Math.max(0, actual - final),
      discountLabel: Math.max(0, actual - final) > 0 ? 'Day subscription' : null,
      discountPercent: Math.max(0, actual - final) > 0
        ? (Number(appliedDayDiscount.discountPercent) || 0)
        : 0,
    };
  }, [
    startDate,
    activeEndDate,
    builderOnly,
    builderSubscriptionTotals,
    deliveryDayCount,
    summarySlotRows,
    itemSchedules,
    packageDiscountFactor,
    appliedDayDiscount.discountPercent,
  ]);

  const slotLabelById = useMemo(
    () => Object.fromEntries(EXTENDED_MEAL_SLOTS.map((slot) => [slot.id, slot.label])),
    [],
  );

  useEffect(() => {
    setSummaryMonthIndex(0);
  }, [startDate, activeEndDate]);

  const buildInvoice = ({ payload, responseData, isEditing }) => {
    const invoiceDays = Number(payload.deliveryDayCount || 0) || 1;
    const charges = payload.charges || computeSubscriptionPeriodCharges({
      periodSubtotal: Number(payload.estimatedTotal || 0),
      days: invoiceDays,
      deliveryTripCount: Math.max(
        1,
        Number(payload.deliveryTripCount)
          || invoiceDays * Math.max(1, countDeliveryWindowsForSlots(payload.mealSlots || [])),
      ),
      distanceKm: payload.distanceKm,
      freeDeliveryRadiusKm: getSubscriptionFreeDeliveryRadiusKm({
        planId: payload.planId,
        deliveryDays: invoiceDays,
      }),
      allowFallbackDelivery: true,
    });
    const referenceId = (responseData?.subscriptionId || responseData?.id && String(responseData.id)) || `DGMS-${Date.now().toString(36).toUpperCase()}`;

    const lineItems = (payload.products || []).map((product) => {
      const quantity = Number(product.quantity || 0);
      const price = Number(product.price || 0);
      const includedInPlan = Boolean(product.includedInPlan);
      const billableQty = includedInPlan ? Math.max(0, quantity - 1) : quantity;
      const lineTotal = quantity * price;
      return {
        name: product.name || 'Item',
        quantity,
        price,
        billableQty,
        includedInPlan,
        lineTotal,
      };
    });

    return {
      referenceId,
      lookupCode: responseData?.lookupCode || '',
      lookupUrl: responseData?.lookupUrl || '',
      qrCodeUrl: responseData?.qrCodeUrl || '',
      generatedAt: formatDisplayDateTime(new Date()),
      title: payload.title,
      planLabel: resolvePlanLabel(payload, payload.planLabel),
      specialtyLabel: formatSpecialtyWithRegion(payload),
      regionLabel: resolveRegionLabel(payload),
      mealTypeLabel: resolveDietLabel(payload) || (payload.specialtyOrganic ? 'Organic' : 'Regular'),
      mealLabel: payload.mealLabel,
      scheduleLabel: payload.scheduleLabel,
      scheduleId: payload.scheduleId,
      itemSchedules: payload.itemSchedules,
      slotPatternRows: buildSlotPatternRows(payload),
      dateRange: `${formatDateForDisplay(payload.startDate)}${payload.endDate ? ` → ${formatDateForDisplay(payload.endDate)}` : ''}`,
      customerName: `${payload.customer?.firstName || ''} ${payload.customer?.lastName || ''}`.trim(),
      customerPhone: payload.customer?.phone || '',
      customerArea: payload.customer?.locationArea || '',
      lineItems,
      subtotal: charges.subtotal,
      gstAmount: charges.totalTax,
      packagingCharges: charges.totalPackagingCharge,
      deliveryCharges: charges.totalDeliveryCharge,
      grandTotal: charges.totalPrice,
      perDayPrice: Number(charges.perDayPrice) || Math.round((Number(charges.totalPrice || 0) / invoiceDays) * 100) / 100,
      actualSubtotal: payload.pricing?.actualSubtotal ?? null,
      discountAmount: payload.pricing?.discountAmount ?? null,
      discountPercent: Number(payload.pricing?.discountPercent) || 0,
      deliveryDayCount: Number(payload.deliveryDayCount || charges.days || 0),
      isFreeDeliveryPlan: charges.isFreeDeliveryPlan,
      usedFallbackDelivery: charges.usedFallbackDelivery,
      distanceKm: charges.distanceKm,
      gstPercent: charges.gstPercent,
      isEditing,
    };
  };

  const resetBuilder = () => {
    setSelectedPlanId(DEFAULT_DAY_BAND_ID);
    setSelectedMealType('lunch');
    setSelectedSlotIds(['lunch']);
    setSelectedSpecialtyPlanId(null);
    setUseOrganicPricing(false);
    setSpecialtyRegionKey('south');
    setSelectedSchedule('daily');
    setSelectedDays([]);
    setSlotSchedules(createDefaultSlotSchedules());
    setItemSchedules({});
    setSlotDraftProducts(createEmptySlotProducts());
    setSubscriptionTitle('');
    setCustomerDetails(buildEmptyCustomerDetails());
    setSavedAddresses([]);
    setSelectedAddressId(null);
    setShowManualAddress(true);
    const nextStart = getMinSubscriptionStartDateIso();
    setStartDate(nextStart);
    setEndDate(endDateForMinDays(nextStart, getDayBandById(DEFAULT_DAY_BAND_ID).minDays));
    setDetailsModalOpen(false);
    setAcceptSubscriptionTerms(false);
    const defaultProduct = getDefaultPlanProduct(DEFAULT_DAY_BAND_ID);
    setDraftProducts(defaultProduct ? [defaultProduct] : []);
    setEditingSubscriptionId(null);
    setSubError('');
    setBuilderStep(1);
    setHighestBuilderStep(1);
    setTitleEditing(false);
    setReviewCalendarOpen(false);
    setPlanOverviewOpen(false);
    setSummaryPreviewOpen(false);
    setClearAllConfirmOpen(false);
    setExpandedFullDayGroupIds(new Set());
  };

  useEffect(() => {
    // Subscriptions for manage/edit live under Account → Subscriptions (DigiRasa API).
    setSubscriptions([]);
    setLoadingSubscriptions(false);
  }, [userId]);

  useEffect(() => {
    if (!builderOnly) return;
    setSlotDraftProducts((prev) => applySubscriptionCartToSlotDrafts(prev, subscriptionCartItems));
    setItemSchedules((schedules) => {
      let next = schedules;
      let changed = false;
      subscriptionCartItems.forEach((item) => {
        expandCartItemToDraftProducts(item).forEach(({ slotId, product }) => {
          const key = getItemScheduleKeyForItem(slotId, product);
          if (!next[key]) {
            if (!changed) next = { ...schedules };
            changed = true;
            next[key] = [...daysOfWeek];
          }
        });
      });
      return changed ? next : schedules;
    });
    const meta = planMetaFromCartItems(subscriptionCartItems);
    if (meta?.planId) {
      setSelectedSpecialtyPlanId(meta.planId);
      setUseOrganicPricing(meta.isOrganic);
      if (meta.regionKey) setSpecialtyRegionKey(meta.regionKey);
    }
  }, [builderOnly, subscriptionCartItems]);

  const toSubscriptionPayload = () => {
    const planLabel = deliveryDayCount > 0
      ? formatSubscriptionPlanLabel(deliveryDayCount)
      : (
        selectedDayBand.title
        || BUILDER_PLAN_CARD_COPY[selectedPlanId]?.title
        || allBuilderPlans.find((plan) => plan.id === selectedPlanId)?.name
        || 'Plan'
      );
    const payloadSlotIds = builderOnly ? selectedBuilderSlotIds : selectedSlotIds;
    const payloadSlotScheduleRows = builderOnly
      ? slotScheduleRows.filter((row) => payloadSlotIds.includes(row.slotId))
      : selectedSlotScheduleRows;
    const selectedSlotSchedulePayload = payloadSlotScheduleRows.map((row) => ({
      slotId: row.slotId,
      scheduleId: row.scheduleId,
      scheduleLabel: scheduleModes.find((mode) => mode.id === row.scheduleId)?.label || row.scheduleId,
      days: row.days,
    }));
    const itemSchedulesPayload = filterItemSchedulesForRange(
      itemScheduleRows.map((row) => ({
        slotId: row.slotId,
        productId: row.productId,
        scheduleScope: row.scheduleScope,
        days: row.days,
      })),
      startDate,
      activeEndDate,
    );

    const ourMenuOnly = isOurMenuOnlyProductList(activeDraftProducts);
    const regionKeys = ourMenuOnly
      ? []
      : (specialtyPlan?.regionalMenus ? Object.keys(specialtyPlan.regionalMenus) : []);
    const supportsRegion = !ourMenuOnly && Boolean(
      specialtyPlan?.supportsRegion
      || regionKeys.length,
    );
    const activeRegionKey = supportsRegion
      ? (specialtyRegionKey && specialtyPlan?.regionalMenus?.[specialtyRegionKey]
        ? specialtyRegionKey
        : (regionKeys[0] || specialtyRegionKey || null))
      : null;
    const regionLabel = activeRegionKey
      ? (REGION_DISPLAY_LABELS[activeRegionKey]
        || specialtyPlan?.regionalMenus?.[activeRegionKey]?.label?.replace(/\s+Meal$/i, '')
        || null)
      : null;
    // Catalog code is still required by the API; display name is Our menu for à la carte only.
    const specialtyPlanId = effectiveSpecialtyPlanId
      || specialtyPlan?.id
      || (ourMenuOnly ? 'general' : null);
    const specialtyName = ourMenuOnly
      ? OUR_MENU_SELECTION_LABEL
      : (specialtyPlan?.name || null);

    let mealLabel;
    let mealType;
    let scheduleId;
    let scheduleLabel;
    let days;

    if (builderOnly) {
      const builderMeta = buildBuilderSubscriptionMeta({
        selectedBuilderSlotIds: payloadSlotIds,
        itemScheduleRows,
        startDate,
        endDate: activeEndDate,
      });
      mealLabel = builderMeta.mealLabel;
      mealType = builderMeta.mealType;
      scheduleId = builderMeta.scheduleId;
      scheduleLabel = builderMeta.scheduleLabel;
      days = builderMeta.days;
    } else {
      const legacyPreset = syncLegacyPresetFromSlots(selectedSlotIds);
      mealLabel = specialtyPlan
        ? `${specialtyPlan.name}${supportsRegion && regionLabel
          ? ` · ${regionLabel}`
          : ''} · ${slotsToLabel(selectedSlotIds)} · ${useOrganicPricing ? 'Organic' : 'Regular'}`
        : (mealTypes.find((meal) => meal.id === (legacyPreset || selectedMealType))?.label
          || slotsToLabel(selectedSlotIds));
      mealType = legacyPreset || selectedMealType;
      scheduleId = selectedSchedule;
      scheduleLabel = scheduleModes.find((mode) => mode.id === selectedSchedule)?.label || selectedSchedule;
      days = effectiveDays;
    }

    return {
      title: subscriptionTitle.trim(),
      planId: DAY_BAND_SNAPSHOT_PLAN_ID,
      dayBandId: selectedDayBand.id,
      dayBandMinDays: selectedDayBand.minDays,
      planLabel,
      planCalendarDays,
      mealType,
      mealSlots: payloadSlotIds,
      specialtyPlanId,
      specialtyOrganic: ourMenuOnly ? false : useOrganicPricing,
      specialtySupportsRegion: supportsRegion,
      specialtyRegionKey: activeRegionKey || undefined,
      regionLabel: regionLabel || undefined,
      specialtyName: specialtyName || undefined,
      mealLabel,
      scheduleId,
      scheduleLabel,
      days,
      slotSchedules: builderOnly ? selectedSlotSchedulePayload : undefined,
      itemSchedules: builderOnly ? itemSchedulesPayload : undefined,
      startDate,
      endDate: activeEndDate,
      customer: {
        firstName: customerDetails.firstName.trim(),
        lastName: customerDetails.lastName.trim(),
        phone: customerDetails.phone.trim(),
        email: customerDetails.email.trim(),
        locationArea: customerDetails.locationArea.trim(),
        city: customerDetails.city.trim() || 'Hyderabad',
        country: customerDetails.country.trim() || 'India',
        pincode: customerDetails.pincode.trim(),
        address: customerDetails.address.trim(),
        state: customerDetails.state.trim() || 'Telangana',
        latitude: customerDetails.latitude,
        longitude: customerDetails.longitude,
      },
      products: serializeDraftProducts(activeDraftProducts),
      deliveryDayCount,
      deliverySlotCount,
      deliveryTripCount,
      estimatedPerDelivery,
      estimatedTotal,
      estimatedMonthly: estimatedTotal,
      distanceKm: subscriptionDistanceKm,
      charges: liveCharges,
      pricing: {
        actualSubtotal: subscriptionPeriodTotals.actual,
        discountAmount: subscriptionPeriodTotals.saving,
        discountPercent: Number(subscriptionPeriodTotals.discountPercent) || 0,
        finalSubtotal: subscriptionPeriodTotals.final,
        discountLabel: subscriptionPeriodTotals.discountLabel || null,
      },
      status: 'active',
      uiSlotCodes: builderOnly ? builderUiSlotCodes : undefined,
      uiSlotLabels: builderOnly
        ? builderUiSlotCodes.map((code) => uiSlotCodeLabel(code))
        : undefined,
      selectionMode: builderOnly
        ? (builderUiSlotCodes.includes(FULL_DAY_UI_SLOT_ID) ? 'mixed_or_full_day' : 'a_la_carte')
        : undefined,
    };
  };

  const toggleSpecificDay = (day) => {
    setSelectedDays((prev) => (
      prev.includes(day)
        ? prev.filter((d) => d !== day)
        : [...prev, day]
    ));
  };

  const toggleItemScheduleDay = (slotId, product, day) => {
    const key = getItemScheduleKeyForItem(slotId, product);
    setItemSchedules((prev) => {
      const currentDays = getItemScheduleDays(prev, slotId, product);
      const nextDays = currentDays.includes(day)
        ? currentDays.filter((d) => d !== day)
        : [...currentDays, day];
      return {
        ...prev,
        [key]: nextDays,
      };
    });
  };

  const toggleDeliverySlot = (slotId) => {
    setSelectedSlotIds((prev) => {
      const next = prev.includes(slotId)
        ? prev.filter((id) => id !== slotId)
        : [...prev, slotId];
      const sorted = next.length ? next : ['lunch'];
      const legacy = syncLegacyPresetFromSlots(sorted);
      if (legacy) setSelectedMealType(legacy);
      return sorted;
    });
  };

  const handleSelectSpecialtyPlan = (plan, { organic = false, regionKey = 'south', slotIds } = {}) => {
    const slots = slotIds?.length
      ? [...slotIds]
      : ['breakfast', 'mid_morning', 'lunch', 'evening_snack', 'dinner'];
    setSelectedSpecialtyPlanId(plan.id);
    setUseOrganicPricing(organic);
    if (plan.id === 'general' && regionKey) {
      setSpecialtyRegionKey(regionKey);
    }
    // Do not auto-fill subscription title — user must enter a name.
    setSelectedSlotIds(slots);
    const legacy = syncLegacyPresetFromSlots(slots);
    setSelectedMealType(legacy || 'lunch');
    setDraftProducts((prev) => prev.filter((item) => !item.isSpecialtyBundle));
    window.setTimeout(() => {
      builderSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
  };

  const clearSpecialtyPlan = () => {
    setSelectedSpecialtyPlanId(null);
    setUseOrganicPricing(false);
    setSpecialtyRegionKey('south');
    setDraftProducts((prev) => prev.filter((item) => !item.isSpecialtyBundle));
  };

  const openSlotSampleModal = (slotId) => {
    if (!activeSpecialtyPlan?.weeklyMenu?.length) return;
    const slotMeta = MEAL_SLOT_TYPES.find((s) => s.id === slotId)
      || EXTENDED_MEAL_SLOTS.find((s) => s.id === slotId);
    setSlotSampleModal({ slotId, slotLabel: slotMeta?.label || slotId });
  };

  const allSpecialtyBundleProducts = useMemo(
    () => specialtyCatalogPlans.flatMap((plan) => getSpecialtyBundleProducts(plan)),
    [specialtyCatalogPlans],
  );

  const productCatalog = useMemo(
    () => [...subscriptionProducts, ...allSpecialtyBundleProducts],
    [allSpecialtyBundleProducts],
  );

  const productCategories = useMemo(() => {
    const cats = new Set(productCatalog.map((p) => p.category));
    return ['All', ...Array.from(cats)];
  }, [productCatalog]);

  const addProductToDraft = (product) => {
    if (product.isSpecialtyBundle) {
      if (product.planId) setSelectedSpecialtyPlanId(product.planId);
      if (product.slotIds?.length) {
        setSelectedSlotIds([...product.slotIds]);
        const legacy = syncLegacyPresetFromSlots(product.slotIds);
        if (legacy) setSelectedMealType(legacy);
      }
    }
    setDraftProducts((prev) => {
      const existing = prev.find((item) => item.id === product.id);
      const price = product.isSpecialtyBundle && useOrganicPricing ? product.priceOrganic : product.price;
      if (existing) {
        return prev.map((item) => (
          item.id === product.id ? { ...item, quantity: item.quantity + 1, price } : item
        ));
      }
      return [...prev, { ...product, price, quantity: 1 }];
    });
  };

  const changeDraftQty = (productId, quantity) => {
    if (quantity < 1) {
      setDraftProducts((prev) => prev.filter((item) => item.id !== productId));
      return;
    }
    setDraftProducts((prev) => prev.map((item) => (
      item.id === productId ? { ...item, quantity } : item
    )));
  };

  const removeDraftProduct = (productId) => {
    setDraftProducts((prev) => prev.filter((item) => item.id !== productId));
  };

  const addAlacarteProductToSlot = (slotId, product) => {
    addToSubscriptionCart(
      { ...product, slotId, isOrganic: false, kind: SUBSCRIPTION_CART_KIND.alacarte },
      { quantity: 1, slotId, showToast: false },
    );
  };

  const addProductToSlotDraft = (slotId, product) => {
    const specialtyRef = parseSpecialtySlotProductId(product?.id);
    const planId = specialtyRef?.planId || product?.planId || null;
    if (planId) {
      setSelectedSpecialtyPlanId(planId);
      if (typeof product?.isOrganic === 'boolean') {
        setUseOrganicPricing(product.isOrganic);
      }
    }
    setSlotDraftProducts((prev) => {
      const current = prev[slotId] || [];
      const existing = current.find((item) => item.id === product.id);
      const nextItem = {
        ...product,
        slotId,
        quantity: existing ? existing.quantity + 1 : 1,
      };
      const key = getItemScheduleKeyForItem(slotId, nextItem);
      setItemSchedules((schedules) => (
        schedules[key] ? schedules : { ...schedules, [key]: [...daysOfWeek] }
      ));
      return {
        ...prev,
        [slotId]: existing
          ? current.map((item) => (item.id === product.id ? nextItem : item))
          : [...current, nextItem],
      };
    });
  };

  const applySpecialtySlotToDraft = (slotId, product, replaceId = null) => {
    if (replaceId && replaceId !== product.id) {
      removeSlotDraftProduct(slotId, replaceId);
    }
    const specialtyRef = parseSpecialtySlotProductId(product?.id);
    const planId = specialtyRef?.planId || product?.planId || null;
    if (planId) {
      setSelectedSpecialtyPlanId(planId);
      if (typeof product?.isOrganic === 'boolean') {
        setUseOrganicPricing(product.isOrganic);
      }
    }
    if (builderOnly) {
      addToSubscriptionCart(
        {
          ...product,
          slotId,
          planId: planId || product?.planId,
          kind: SUBSCRIPTION_CART_KIND.specialty,
        },
        { quantity: product?.quantity || 1, slotId, showToast: false, mode: 'upsert' },
      );
      return;
    }
    setSlotDraftProducts((prev) => {
      const current = prev[slotId] || [];
      const existing = current.find((item) => item.id === product.id && !item.isFullDayPackage);
      const nextItem = {
        ...product,
        slotId,
        quantity: existing ? existing.quantity : 1,
        isFullDayPackage: false,
        fullDayGroupId: undefined,
      };
      delete nextItem.fullDayGroupId;
      const key = getItemScheduleKeyForItem(slotId, nextItem);
      setItemSchedules((schedules) => (
        schedules[key] ? schedules : { ...schedules, [key]: [...daysOfWeek] }
      ));
      return {
        ...prev,
        [slotId]: existing
          ? current.map((item) => (
            item.id === product.id && !item.isFullDayPackage ? nextItem : item
          ))
          : [...current, nextItem],
      };
    });
  };

  const openAddItemsPicker = () => {
    setBuilderPickerSlotId(null);
    setBuilderPickerMode('plan');
    setBuilderPickerIntent('full-day');
    setBuilderPickerEntryId(null);
    setProductModalOpen(true);
  };

  const openAddItemsPickerForSlot = (slotId, productId = null) => {
    if (slotId === FULL_DAY_UI_SLOT_ID) {
      openAddItemsPicker();
      return;
    }
    if (productId) {
      const item = (slotDraftProducts[slotId] || []).find((row) => (
        row.id === productId && !row.isFullDayPackage
      ));
      if (item?.planId) setBuilderPickerPlanId(item.planId);
      if (typeof item?.isOrganic === 'boolean') setUseOrganicPricing(item.isOrganic);
      const regionKey = getProductRegionKey(item);
      if (regionKey) setSpecialtyRegionKey(regionKey);
      const isAlacarteItem = Boolean(item)
        && !item.planId
        && !parseSpecialtySlotProductId(item.id);
      setBuilderPickerMode(isAlacarteItem ? 'others' : 'plan');
    } else {
      setBuilderPickerMode('plan');
    }
    setBuilderPickerSlotId(slotId);
    setBuilderPickerIntent('slot');
    setBuilderPickerEntryId(productId);
    setProductModalOpen(true);
  };

  const removeSlotDraftProduct = (slotId, productId, fullDayGroupId = null) => {
    const current = (slotDraftProducts[slotId] || []).find((item) => {
      if (item.id !== productId) return false;
      if (fullDayGroupId) return item.fullDayGroupId === fullDayGroupId;
      return !item.isFullDayPackage;
    });
    if (builderOnly && current && !fullDayGroupId && !current.isFullDayPackage) {
      removeFromSubscriptionCart(productId, slotId);
      return;
    }
    setSlotDraftProducts((prev) => {
      const removedItem = (prev[slotId] || []).find((item) => {
        if (item.id !== productId) return false;
        if (fullDayGroupId) return item.fullDayGroupId === fullDayGroupId;
        return !item.isFullDayPackage;
      });
      const scheduleKey = removedItem ? getItemScheduleKeyForItem(slotId, removedItem) : null;
      const nextSlot = (prev[slotId] || []).filter((item) => {
        if (item.id !== productId) return true;
        if (fullDayGroupId) return item.fullDayGroupId !== fullDayGroupId;
        return Boolean(item.isFullDayPackage);
      });
      const stillHasSameScope = removedItem
        ? nextSlot.some((item) => (
          item.id === productId && getItemScheduleScope(item) === getItemScheduleScope(removedItem)
        ))
        : nextSlot.some((item) => item.id === productId);
      setItemSchedules((schedules) => {
        if (!scheduleKey || stillHasSameScope || !schedules[scheduleKey]) return schedules;
        const next = { ...schedules };
        delete next[scheduleKey];
        return next;
      });
      return {
        ...prev,
        [slotId]: nextSlot,
      };
    });
  };

  const changeSlotDraftQty = (slotId, productId, quantity, fullDayGroupId = null) => {
    const current = (slotDraftProducts[slotId] || []).find((item) => {
      if (item.id !== productId) return false;
      if (fullDayGroupId) return item.fullDayGroupId === fullDayGroupId;
      return !item.isFullDayPackage;
    });
    if (builderOnly && current && !fullDayGroupId && !current.isFullDayPackage) {
      updateSubscriptionCartQty(productId, slotId, quantity);
      return;
    }
    if (quantity < 1) {
      removeSlotDraftProduct(slotId, productId, fullDayGroupId);
      return;
    }
    setSlotDraftProducts((prev) => ({
      ...prev,
      [slotId]: (prev[slotId] || []).map((item) => {
        if (item.id !== productId) return item;
        if (fullDayGroupId) {
          return item.fullDayGroupId === fullDayGroupId ? { ...item, quantity } : item;
        }
        if (item.isFullDayPackage) return item;
        return { ...item, quantity };
      }),
    }));
  };

  const requestRemoveSlotDraftProduct = (slotId, productId, fullDayGroupId = null) => {
    const item = (slotDraftProducts[slotId] || []).find((product) => {
      if (product.id !== productId) return false;
      if (fullDayGroupId) return product.fullDayGroupId === fullDayGroupId;
      return !product.isFullDayPackage;
    });
    const slot = EXTENDED_MEAL_SLOTS.find((s) => s.id === slotId)
      || SELECTABLE_BUILDER_SLOTS.find((s) => s.id === slotId);
    if (!item) return;
    setDeleteConfirmItem({
      slotId,
      productId,
      fullDayGroupId: fullDayGroupId || item.fullDayGroupId || null,
      itemName: item.isFullDayPackage ? `${item.name?.replace(/\s*-\s*.+$/, '') || 'Meal'} Full Day` : item.name,
      slotLabel: (fullDayGroupId || item.isFullDayPackage) ? 'Full Day' : (slot?.label || 'this slot'),
    });
  };

  const confirmRemoveSlotDraftProduct = () => {
    if (!deleteConfirmItem) return;
    if (deleteConfirmItem.fullDayGroupId) {
      removeFullDayPackageGroup(deleteConfirmItem.fullDayGroupId);
    } else {
      removeSlotDraftProduct(deleteConfirmItem.slotId, deleteConfirmItem.productId);
    }
    setDeleteConfirmItem(null);
  };

  const clearAllSlotDraftItems = () => {
    if (builderOnly) clearSubscriptionCart();
    setSlotDraftProducts(createEmptySlotProducts());
    setItemSchedules({});
    setClearAllConfirmOpen(false);
  };

  const buildSpecialtySlotDraftProduct = (plan, slotId, organic, regionKey = specialtyRegionKey) => {
    const slotMeta = EXTENDED_MEAL_SLOTS.find((s) => s.id === slotId);
    const activeRegionKey = plan?.id === 'general' ? (regionKey || 'south') : null;
    const pricedPlan = activeRegionKey
      ? resolveSpecialtyPlanForRegion(plan, activeRegionKey)
      : plan;
    return {
      id: getSpecialtySlotProductId(plan.id, slotId),
      name: `${plan.name} - ${slotMeta?.label || slotId}`,
      planId: plan.id,
      isOrganic: organic,
      ...(activeRegionKey ? { regionKey: activeRegionKey } : {}),
      price: resolveSpecialtyPerDayPrice(pricedPlan, [slotId], organic) || selectedPlan.price,
      category: 'Specialty plan',
      includedInPlan: false,
    };
  };

  const addFullSpecialtyPackage = (plan, slotIds, organic) => {
    if (plan?.id) {
      setSelectedSpecialtyPlanId(plan.id);
      setUseOrganicPricing(Boolean(organic));
      // Keep any user-entered title; never auto-fill from plan name.
    }
    const menuSlotIds = (slotIds?.length ? slotIds : getPlanMenuSlotIds(plan))
      .filter((id) => FULL_DAY_INTERNAL_SLOT_IDS.includes(id));
    const resolvedSlots = menuSlotIds.length ? menuSlotIds : [...FULL_DAY_INTERNAL_SLOT_IDS];
    const fullDayGroupId = makeFullDayGroupId(plan?.id, organic);
    const productsToAdd = resolvedSlots.map((slotId) => ({
      slotId,
      product: {
        ...buildSpecialtySlotDraftProduct(plan, slotId, organic, specialtyRegionKey),
        isFullDayPackage: true,
        fullDayGroupId,
      },
    }));

    if (builderOnly) {
      const slotProducts = productsToAdd.map(({ slotId, product }) => ({
        ...product,
        slotId,
        quantity: 1,
      }));
      const price = slotProducts.reduce((sum, product) => sum + Number(product.price || 0), 0);
      addToSubscriptionCart(
        {
          kind: SUBSCRIPTION_CART_KIND.fullDay,
          id: fullDayGroupId,
          fullDayGroupId,
          planId: plan?.id,
          name: `${plan?.name || 'Specialty'} Full Day`,
          price,
          isOrganic: Boolean(organic),
          regionKey: plan?.id === 'general' ? specialtyRegionKey : null,
          category: 'Full Day',
          slotProducts,
        },
        { quantity: 1, showToast: false, mode: 'add' },
      );
      return;
    }

    setSlotDraftProducts((prev) => {
      const next = { ...prev };
      productsToAdd.forEach(({ slotId, product }) => {
        const current = next[slotId] || [];
        const existing = current.find((item) => item.id === product.id && item.fullDayGroupId === fullDayGroupId);
        if (existing) {
          next[slotId] = current.map((item) => (
            item.id === product.id && item.fullDayGroupId === fullDayGroupId
              ? { ...item, ...product, slotId, quantity: item.quantity || 1 }
              : item
          ));
          return;
        }
        // Same specialty already on slot as a standalone line stays; Full Day is a separate package group.
        next[slotId] = [...current, { ...product, slotId, quantity: 1 }];
      });
      return next;
    });

    setItemSchedules((prev) => {
      const next = { ...prev };
      productsToAdd.forEach(({ slotId, product }) => {
        const key = getItemScheduleKeyForItem(slotId, product);
        if (!next[key]) next[key] = [...daysOfWeek];
      });
      return next;
    });
  };

  const removeFullDayPackageGroup = (groupId) => {
    if (!groupId) return;
    if (builderOnly) {
      setExpandedFullDayGroupIds((prev) => {
        if (!prev.has(groupId)) return prev;
        const next = new Set(prev);
        next.delete(groupId);
        return next;
      });
      removeFromSubscriptionCart(groupId);
      return;
    }
    setExpandedFullDayGroupIds((prev) => {
      if (!prev.has(groupId)) return prev;
      const next = new Set(prev);
      next.delete(groupId);
      return next;
    });
    setSlotDraftProducts((prev) => {
      const next = { ...prev };
      const scheduleKeysToClear = [];
      FULL_DAY_INTERNAL_SLOT_IDS.forEach((slotId) => {
        const before = next[slotId] || [];
        const removed = before.filter((item) => item?.fullDayGroupId === groupId);
        next[slotId] = before.filter((item) => item?.fullDayGroupId !== groupId);
        removed.forEach((item) => {
          const stillHasProduct = next[slotId].some((row) => (
            row.id === item.id && getItemScheduleScope(row) === getItemScheduleScope(item)
          ));
          if (!stillHasProduct) {
            scheduleKeysToClear.push(getItemScheduleKeyForItem(slotId, item));
          }
        });
      });
      if (scheduleKeysToClear.length) {
        setItemSchedules((schedules) => {
          let changed = false;
          const nextSchedules = { ...schedules };
          scheduleKeysToClear.forEach((key) => {
            if (!nextSchedules[key]) return;
            delete nextSchedules[key];
            changed = true;
          });
          return changed ? nextSchedules : schedules;
        });
      }
      return next;
    });
  };

  const changeFullDayPackageQty = (groupId, quantity) => {
    if (!groupId) return;
    if (builderOnly) {
      updateSubscriptionCartQty(groupId, null, quantity);
      return;
    }
    if (quantity < 1) {
      removeFullDayPackageGroup(groupId);
      return;
    }
    setSlotDraftProducts((prev) => {
      const next = { ...prev };
      FULL_DAY_INTERNAL_SLOT_IDS.forEach((slotId) => {
        next[slotId] = (next[slotId] || []).map((item) => (
          item?.fullDayGroupId === groupId ? { ...item, quantity } : item
        ));
      });
      return next;
    });
  };

  const toggleFullDayPackageDay = (groupId, day) => {
    if (!groupId) return;
    const group = collectFullDayPackageGroups(slotDraftProducts).find((g) => g.groupId === groupId);
    if (!group) return;
    const sampleSlotId = FULL_DAY_INTERNAL_SLOT_IDS.find((id) => group.itemsBySlot[id]);
    const sampleItem = sampleSlotId ? group.itemsBySlot[sampleSlotId] : null;
    if (!sampleItem) return;
    const key = getItemScheduleKeyForItem(sampleSlotId, sampleItem);
    const currentDays = getItemScheduleDays(itemSchedules, sampleSlotId, sampleItem);
    const nextDays = currentDays.includes(day)
      ? currentDays.filter((d) => d !== day)
      : [...currentDays, day];
    setItemSchedules((prev) => {
      const next = { ...prev };
      FULL_DAY_INTERNAL_SLOT_IDS.forEach((slotId) => {
        const item = group.itemsBySlot[slotId];
        if (!item) return;
        next[getItemScheduleKeyForItem(slotId, item)] = [...nextDays];
      });
      return next;
    });
  };

  const toggleFullDaySlotsExpanded = (groupId) => {
    if (!groupId) return;
    setExpandedFullDayGroupIds((prev) => {
      const next = new Set(prev);
      if (next.has(groupId)) next.delete(groupId);
      else next.add(groupId);
      return next;
    });
  };

  const removeFullSpecialtyPackage = (planId) => {
    EXTENDED_MEAL_SLOTS.forEach((slot) => {
      (slotDraftProducts[slot.id] || []).forEach((item) => {
        const ref = parseSpecialtySlotProductId(item.id);
        if (ref?.planId === planId) {
          removeSlotDraftProduct(slot.id, item.id);
        }
      });
    });
  };

  const handleCustomerDetailChange = (e) => {
    const { name, value } = e.target;
    setCustomerFieldErrors((prev) => {
      if (!prev[name]) return prev;
      const next = { ...prev };
      delete next[name];
      return next;
    });
    if (name === 'pincode') {
      const nextValue = value.replace(/\D/g, '').slice(0, 6);
      setCustomerDetails((prev) => ({ ...prev, pincode: nextValue }));
      return;
    }
    if (name === 'phone') {
      setCustomerDetails((prev) => ({
        ...prev,
        phone: sanitizePhoneDigitsInput(value, 15),
      }));
      return;
    }
    setCustomerDetails((prev) => ({ ...prev, [name]: value }));
  };

  const focusCustomerField = (fieldName) => {
    window.requestAnimationFrame(() => {
      const root = document.querySelector('.mp-customer-modal');
      if (!root) return;
      const el = root.querySelector(`[name="${fieldName}"]`)
        || root.querySelector(`[data-field="${fieldName}"]`);
      if (!el) return;
      if (typeof el.focus === 'function') {
        el.focus({ preventScroll: true });
      }
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  };

  const setCustomerFieldError = (fieldName, message) => {
    setSubError('');
    setCustomerFieldErrors({ [fieldName]: message });
    // Allow address fields to mount if we just switched to manual entry.
    window.setTimeout(() => focusCustomerField(fieldName), 50);
  };

  const openDatePicker = (field) => {
    const targetRef = field === 'start' ? startDateInputRef : endDateInputRef;
    setActiveDateField(field);

    if (targetRef.current && document.activeElement !== targetRef.current) {
      targetRef.current.focus();
    }
  };

  const closeDatePicker = (field) => {
    setActiveDateField((prev) => (prev === field ? '' : prev));
  };

  const openDetailsModal = () => {
    if (!startDate) {
      setSubError('Please choose a start date before creating a subscription.');
      return;
    }

    if (!isSubscriptionStartDateAllowed(startDate, { allowPast: Boolean(editingSubscriptionId) })) {
      setSubError('Start date must be from tomorrow onwards.');
      return;
    }

    if (!endDate) {
      setSubError('Please choose an end date for your plan before creating a subscription.');
      return;
    }

    if (deliveryDayCount < SUBSCRIPTION_MIN_DAYS) {
      setSubError(`Subscriptions require at least ${SUBSCRIPTION_MIN_DAYS} delivery days.`);
      return;
    }

    if (!builderOnly && selectedSchedule === 'specific_days' && selectedDays.length === 0) {
      setSubError('Please pick at least one day for specific days schedule before creating a subscription.');
      return;
    }

    if (builderOnly && hasEmptySlotSpecificSchedule) {
      setSubError('Please pick at least one day for each slot set to specific days.');
      return;
    }

    if (activeDraftProducts.length === 0) {
      setSubError('Please add at least one product to this subscription before creating it.');
      return;
    }

    if (!subscriptionTitle.trim()) {
      setSubError('Please enter a subscription title.');
      setCustomerFieldErrors({ subscriptionTitle: 'Please enter a subscription title.' });
      builderTitleRef.current?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
      const titleInput = document.getElementById('mp-subscription-title');
      if (titleInput) {
        window.setTimeout(() => titleInput.focus(), 50);
      }
      return;
    }

    setSubError('');
    setCustomerFieldErrors({});
    setApiMessage('');
    openPersonalDetailsModal();
  };

  const applySavedAddressToCustomer = (address, list = savedAddresses) => {
    if (!address) return;
    const numericId = address.id != null ? Number(address.id) : null;
    if (numericId != null && Number.isFinite(numericId)) {
      setSelectedAddressId(numericId);
      storeSelectedAddressId(numericId);
      setShowManualAddress(false);
    }
    setCustomerDetails((prev) => ({
      ...prev,
      ...customerDetailsFromSavedAddress(address),
    }));
    void list;
  };

  const handleSubscriptionAddressSelect = (id) => {
    // Prefer deliverable (mapped) address; still apply selection if coords are missing
    // so the form updates and the user can see delivery needs a mapped pin.
    const row = findSelectedDeliveryAddress(savedAddresses, id)
      || findAddressById(savedAddresses, id);
    if (!row) return;
    applySavedAddressToCustomer(row);
    setCustomerFieldErrors((prev) => {
      if (!prev.deliveryAddress) return prev;
      const next = { ...prev };
      delete next.deliveryAddress;
      return next;
    });
  };

  const openAddressPicker = () => {
    setPendingAddressId(selectedAddressId);
    setAddressPickerOpen(true);
    void reloadSubscriptionAddresses();
  };

  const closeAddressPicker = () => {
    setAddressPickerOpen(false);
    setPendingAddressId(selectedAddressId);
  };

  const confirmAddressPicker = () => {
    if (pendingAddressId != null) {
      handleSubscriptionAddressSelect(pendingAddressId);
    }
    setAddressPickerOpen(false);
  };

  const selectedSummaryAddressLabel = useMemo(() => {
    if (selectedAddressId == null || showManualAddress) return '';
    const parts = [
      customerDetails.address,
      customerDetails.locationArea,
      customerDetails.city,
      customerDetails.pincode,
    ].filter(Boolean);
    if (!parts.length) return '';
    const distance = subscriptionDistanceKm != null
      ? ` · ${formatKitchenDistance(subscriptionDistanceKm)}`
      : '';
    return `${parts.join(', ')}${distance}`;
  }, [
    selectedAddressId,
    showManualAddress,
    customerDetails.address,
    customerDetails.locationArea,
    customerDetails.city,
    customerDetails.pincode,
    subscriptionDistanceKm,
  ]);

  const selectedReviewAddress = useMemo(() => {
    if (selectedAddressId == null || showManualAddress) return null;
    const row = findSelectedDeliveryAddress(savedAddresses, selectedAddressId)
      || findAddressById(savedAddresses, selectedAddressId);
    if (!row) return null;
    return {
      card: formatSavedAddressCard(row),
      typeMeta: builderAddressTypeMeta(row.type),
      km: distanceKmFromKitchen(row),
    };
  }, [selectedAddressId, showManualAddress, savedAddresses]);

  const ReviewAddressIcon = selectedReviewAddress?.typeMeta?.icon || FaMapMarkerAlt;

  const weekdaySlotOverview = useMemo(() => {
    const fullDayGroups = collectFullDayPackageGroups(slotDraftProducts);
    const fullDayTrips = countDeliveryWindowsForSlots(FULL_DAY_INTERNAL_SLOT_IDS);
    const visibleDays = weekdaysInSubscriptionRange(
      startDate,
      activeEndDate,
      daysOfWeek,
    );
    const overviewDays = visibleDays.length ? visibleDays : daysOfWeek;
    const daysInRange = (scheduleDays) => weekdaysInSubscriptionRange(
      startDate,
      activeEndDate,
      scheduleDays,
      scheduleDays,
    );

    return overviewDays.map((day) => {
      const slots = [];

      fullDayGroups.forEach((group) => {
        const sampleSlotId = FULL_DAY_INTERNAL_SLOT_IDS.find((id) => group.itemsBySlot[id]);
        const sampleItem = sampleSlotId ? group.itemsBySlot[sampleSlotId] : null;
        if (!sampleItem) return;
        const scheduledDays = daysInRange(getItemScheduleDays(itemSchedules, sampleSlotId, sampleItem));
        if (!scheduledDays.includes(day)) return;
        const quantity = Math.max(1, Number(group.quantity) || 1);
        const plan = group.planId ? getCatalogSpecialtyPlanById(group.planId) : null;
        const specialtyName = plan?.name || resolveBuilderSpecialtyTheme(group.planId).name;
        const cuisine = resolveGeneralCuisineLabel(sampleItem, group.planId, specialtyRegionKey);
        slots.push({
          id: `full_day:${group.groupId}`,
          label: 'Full Day',
          detail: cuisine ? `${specialtyName} · ${cuisine}` : specialtyName,
          quantity,
          trips: fullDayTrips,
          isFullDay: true,
        });
      });

      ['breakfast', 'lunch', 'dinner'].forEach((slotId) => {
        const slotMeta = EXTENDED_MEAL_SLOTS.find((slot) => slot.id === slotId);
        (slotDraftProducts[slotId] || [])
          .filter((product) => !product.isFullDayPackage)
          .forEach((product) => {
            const scheduledDays = daysInRange(getItemScheduleDays(itemSchedules, slotId, product));
            if (!scheduledDays.includes(day)) return;
            const quantity = Math.max(1, Number(product.quantity) || 1);
            const specialtyRef = parseSpecialtySlotProductId(product.id);
            const planId = product.planId || specialtyRef?.planId;
            const plan = planId ? getCatalogSpecialtyPlanById(planId) : null;
            const specialtyName = plan?.name || resolveBuilderSpecialtyTheme(planId).name;
            const cuisine = resolveGeneralCuisineLabel(product, planId, specialtyRegionKey);
            slots.push({
              id: `${slotId}:${product.id}`,
              slotId,
              label: BUILDER_SLOT_SHORT_NAME[slotId] || slotMeta?.label || slotId,
              detail: cuisine ? `${specialtyName} · ${cuisine}` : specialtyName,
              quantity,
              trips: countDeliveryWindowsForSlots([slotId]),
              isFullDay: false,
            });
          });
      });

      const tripSlotIds = [];
      if (slots.some((row) => row.isFullDay)) {
        tripSlotIds.push(...FULL_DAY_INTERNAL_SLOT_IDS);
      }
      slots.forEach((row) => {
        if (!row.isFullDay && row.slotId) tripSlotIds.push(row.slotId);
      });
      const dayTrips = countDeliveryWindowsForSlots([...new Set(tripSlotIds)]);

      return {
        day,
        short: day.slice(0, 3),
        slots,
        dayTrips,
      };
    }).filter((entry) => entry.slots.length);
  }, [
    itemSchedules,
    slotDraftProducts,
    getCatalogSpecialtyPlanById,
    specialtyRegionKey,
    startDate,
    activeEndDate,
  ]);

  useEffect(() => {
    if (titleEditing) titleChipInputRef.current?.focus();
  }, [titleEditing]);

  useEffect(() => {
    if (editingSubscriptionId) return;
    const minStart = getMinSubscriptionStartDateIso();
    setStartDate((prev) => (!prev || prev < minStart ? minStart : prev));
  }, [builderStep, editingSubscriptionId]);

  useEffect(() => {
    if (!startDate) return;
    const minEnd = resolveBandEndDate(startDate, SUBSCRIPTION_MIN_DAYS);
    setEndDate((prev) => (!prev || prev < minEnd ? minEnd : prev));
  }, [startDate, resolveBandEndDate]);

  useEffect(() => {
    if (!startDate || !deliveryScheduleRows.length) return;
    const bandEnd = resolveBandEndDate(startDate, selectedDayBand.minDays);
    setEndDate((prev) => {
      if (!prev || prev < bandEnd) return bandEnd;
      const currentDeliveryDays = countDeliveryDaysForRange(startDate, prev);
      if (currentDeliveryDays < selectedDayBand.minDays) return bandEnd;
      return prev;
    });
  }, [startDate, deliveryScheduleRows, selectedDayBand.minDays, resolveBandEndDate, countDeliveryDaysForRange]);

  const canContinueBuilder = (step) => {
    if (step === 1) return builderSlotItemCount > 0;
    if (step === 2) {
      return Boolean(
        startDate
        && activeEndDate
        && isSubscriptionStartDateAllowed(startDate, { allowPast: Boolean(editingSubscriptionId) })
        && deliveryDayCount >= SUBSCRIPTION_MIN_DAYS,
      );
    }
    if (step === 3) return Boolean(selectedSummaryAddressLabel);
    return false;
  };

  const scrollToBuilderStep = useCallback((step) => {
    window.requestAnimationFrame(() => {
      window.setTimeout(() => {
        const panel = document.getElementById(`mp-builder-step-${step}`);
        const target = panel || builderNavRef.current || builderTitleRef.current;
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 40);
    });
  }, []);

  const jumpToBuilderStep = (step) => {
    if (step < 1 || step > highestBuilderStep) return;
    setBuilderStep(step);
    scrollToBuilderStep(step);
  };

  const goToNextBuilderStep = () => {
    if (builderStep >= 4 || !canContinueBuilder(builderStep)) return;
    const next = builderStep + 1;
    setHighestBuilderStep((current) => Math.max(current, next));
    setBuilderStep(next);
    scrollToBuilderStep(next);
  };

  const reloadSubscriptionAddresses = async () => {
    const { token } = readStoredAuth();
    if (!token) {
      setSavedAddresses([]);
      return [];
    }
    setAddressesLoading(true);
    try {
      const list = await fetchUserAddresses(token);
      setSavedAddresses(list);
      return list;
    } catch {
      setSavedAddresses([]);
      return [];
    } finally {
      setAddressesLoading(false);
    }
  };

  useEffect(() => {
    const { token } = readStoredAuth();
    if (!token) {
      setSavedAddresses([]);
      return undefined;
    }
    let cancelled = false;
    (async () => {
      const list = await reloadSubscriptionAddresses();
      if (cancelled) return;
      void list;
    })();
    const onAuth = () => {
      const next = readStoredAuth().token;
      if (!next) {
        setSavedAddresses([]);
        setSelectedAddressId(null);
        setShowManualAddress(true);
        return;
      }
      void reloadSubscriptionAddresses();
    };
    window.addEventListener(DIGIRASA_AUTH_UPDATED_EVENT, onAuth);
    return () => {
      cancelled = true;
      window.removeEventListener(DIGIRASA_AUTH_UPDATED_EVENT, onAuth);
    };
  }, []);

  const handleSubscriptionAddressSaved = async (address) => {
    const list = await reloadSubscriptionAddresses();
    const id = address?.id != null ? Number(address.id) : null;
    if (id == null) return;
    const mergedList =
      list.some((a) => Number(a.id) === id) || !address
        ? list
        : [...list, address];
    if (mergedList !== list) {
      setSavedAddresses(mergedList);
    }
    const row = findSelectedDeliveryAddress(mergedList, id) || address;
    applySavedAddressToCustomer(row, mergedList);
  };

  const openPersonalDetailsModal = async () => {
    setAcceptSubscriptionTerms(false);
    setDetailsModalOpen(true);
    setDetailsPrefillBusy(true);
    const { token, user: storedUser } = readStoredAuth();
    const isEditing = Boolean(editingSubscriptionId);

    try {
      let profileData = null;
      if (token) {
        try {
          const { res, data } = await apiGetProfile(token);
          if (res.ok) profileData = data;
        } catch {
          /* keep stored-user fallback */
        }
      }

      const fromProfile = customerDetailsFromProfileSources({ storedUser, profileData });
      const mapped = profileData ? profilePayloadToForm(profileData) : null;
      const accountId = mapped?.id ?? storedUser?.id ?? storedUser?.userId ?? null;
      if (accountId != null && String(accountId).trim() !== '') {
        setPreviewUserId(String(accountId));
      } else {
        setPreviewUserId(resolvePreviewUserId(userId));
      }

      // Prefill identity from profile; leave address blank until the user selects one.
      setCustomerDetails((prev) => {
        if (isEditing) {
          return mergeProfileIntoCustomerDetails(prev, fromProfile);
        }
        return {
          ...buildEmptyCustomerDetails(),
          ...fromProfile,
        };
      });

      if (!token) {
        setSavedAddresses([]);
        setSelectedAddressId(null);
        setShowManualAddress(true);
        return;
      }

      const list = await reloadSubscriptionAddresses();
      if (selectedAddressId != null) {
        const row = findSelectedDeliveryAddress(list, selectedAddressId)
          || findAddressById(list, selectedAddressId);
        if (row) {
          applySavedAddressToCustomer(row, list);
          return;
        }
      }
      // Keep any summary-selected address; only default to manual when none saved.
      if (list.length === 0) {
        setSelectedAddressId(null);
        setShowManualAddress(true);
      } else if (selectedAddressId == null) {
        setShowManualAddress(false);
      }
    } finally {
      setDetailsPrefillBusy(false);
    }
  };

  /** Selecting a duration band always sets end date to that band’s minimum length. */
  const handlePlanSelection = (planId, options = {}) => {
    const { resetExtras = false } = options;
    const band = getDayBandById(planId);
    setSelectedPlanId(planId);
    if (startDate) {
      setEndDate(resolveBandEndDate(startDate, band.minDays));
    }
    // Keep the user-entered subscription title; planId/planLabel are stored separately.

    setDraftProducts((prev) => {
      const defaultProduct = getDefaultPlanProduct(planId);
      const hadBaseProduct = prev.some((item) => isBasePlanProductId(item.id));
      const currentDefault = prev.find((item) => isBasePlanProductId(item.id));
      const extraItems = resetExtras ? [] : prev.filter((item) => !isBasePlanProductId(item.id));

      if (!defaultProduct) return extraItems;
      if (!resetExtras && !hadBaseProduct) return extraItems;

      return [{
        ...defaultProduct,
        quantity: currentDefault?.quantity || 1,
      }, ...extraItems];
    });
  };

  const handleStartDateChange = (next) => {
    if (next && next < getMinSubscriptionStartDateIso() && !editingSubscriptionId) return;
    const previousDeliveryDays = Math.max(
      SUBSCRIPTION_MIN_DAYS,
      countDeliveryDaysForRange(startDate, endDate || activeEndDate) || selectedDayBand.minDays,
    );
    setStartDate(next);
    if (!next) return;
    const nextEnd = deliveryScheduleRows.length
      ? endDateForMinDeliveryDays(next, previousDeliveryDays, deliveryScheduleRows)
      : endDateForMinDays(next, previousDeliveryDays);
    setEndDate(nextEnd);
    const matching = resolveDayBandForDays(countDeliveryDaysForRange(next, nextEnd));
    if (matching) setSelectedPlanId(matching.id);
  };

  /** End date is editable; band follows the applied delivery day count (min 3 days). */
  const handleEndDateChange = (next) => {
    if (!startDate) {
      setEndDate(next || '');
      return;
    }
    const minEnd = resolveBandEndDate(startDate, SUBSCRIPTION_MIN_DAYS);
    const resolvedEnd = !next || next < minEnd ? minEnd : next;
    setEndDate(resolvedEnd);
    const deliveryDays = countDeliveryDaysForRange(startDate, resolvedEnd);
    const matching = resolveDayBandForDays(deliveryDays);
    setSelectedPlanId(matching?.id || DEFAULT_DAY_BAND_ID);
  };

  const createSubscription = async () => {
    if (!subscriptionTitle.trim()) {
      setCustomerFieldError('subscriptionTitle', 'Please enter a subscription title.');
      builderTitleRef.current?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
      const titleInput = document.getElementById('mp-subscription-title');
      if (titleInput) {
        window.setTimeout(() => titleInput.focus(), 50);
      }
      return;
    }

    const requiredCustomerFields = [
      ['firstName', 'First Name'],
      ['phone', 'Phone'],
      ['email', 'Email'],
      ['locationArea', 'Location / Area'],
      ['city', 'City'],
      ['country', 'Country'],
      ['pincode', 'PIN Code'],
      ['address', 'Street Address'],
    ];

    const missingField = requiredCustomerFields.find(([field]) => !String(customerDetails[field] || '').trim());
    if (missingField) {
      const [field, label] = missingField;
      // Address block may be hidden when a saved address is selected — switch to manual if needed.
      if (['locationArea', 'pincode', 'city', 'country', 'address'].includes(field) && !showManualAddress) {
        setShowManualAddress(true);
      }
      setCustomerFieldError(field, `Please enter ${label}.`);
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailPattern.test(customerDetails.email.trim())) {
      setCustomerFieldError('email', 'Please enter a valid email address.');
      return;
    }

    const phoneCheck = validatePhoneDigitsValue(customerDetails.phone);
    if (!phoneCheck.ok) {
      setCustomerFieldError('phone', phoneCheck.message);
      return;
    }

    if (!/^\d{6}$/.test(customerDetails.pincode.trim())) {
      if (!showManualAddress) setShowManualAddress(true);
      setCustomerFieldError('pincode', 'Please enter a valid 6-digit PIN code.');
      return;
    }

    if ((customerDetails.city || '').trim().toLowerCase() !== 'hyderabad') {
      if (!showManualAddress) setShowManualAddress(true);
      setCustomerFieldError('city', 'Currently subscriptions are available only in Hyderabad.');
      return;
    }

    if ((customerDetails.country || '').trim().toLowerCase() !== 'india') {
      if (!showManualAddress) setShowManualAddress(true);
      setCustomerFieldError('country', 'Currently subscriptions are available only in India.');
      return;
    }

    if (!acceptSubscriptionTerms) {
      setCustomerFieldError('acceptTerms', 'Please accept the Terms and Conditions to continue.');
      return;
    }

    const { token: authToken } = readStoredAuth();
    if (authToken && savedAddresses.length > 0 && selectedAddressId == null && !showManualAddress) {
      setCustomerFieldError('deliveryAddress', 'Please select a delivery address.');
      return;
    }

    setCustomerFieldErrors({});
    setSubError('');

    if (!startDate) {
      setSubError('Please choose a start date.');
      return;
    }

    if (!isSubscriptionStartDateAllowed(startDate, { allowPast: Boolean(editingSubscriptionId) })) {
      setSubError('Start date must be from tomorrow onwards.');
      return;
    }

    if (!endDate) {
      setSubError('Please choose an end date for your plan.');
      return;
    }

    if (deliveryDayCount < SUBSCRIPTION_MIN_DAYS) {
      setSubError(`Subscriptions require at least ${SUBSCRIPTION_MIN_DAYS} delivery days.`);
      return;
    }

    if (!builderOnly && selectedSchedule === 'specific_days' && selectedDays.length === 0) {
      setSubError('Please pick at least one day for specific days schedule.');
      return;
    }

    if (builderOnly && hasEmptySlotSpecificSchedule) {
      setSubError('Please pick at least one day for each slot set to specific days.');
      return;
    }

    if (activeDraftProducts.length === 0) {
      setSubError('Please add at least one product to this subscription.');
      return;
    }

    // Our-menu-only carts have no specialty selection by design; the payload
    // still sends catalog code `general` for the API.
    if (!effectiveSpecialtyPlanId && !isOurMenuOnlyProductList(activeDraftProducts)) {
      setSubError('Please select a specialty plan.');
      return;
    }

    setApiBusy(true);
    setSubError('');
    setApiMessage('');

    try {
      const payload = toSubscriptionPayload();
      const isEditing = Boolean(editingSubscriptionId);

      if (USE_API_MEAL_PLANS) {
        if (isEditing) {
          throw new Error('Editing saved meal plans is managed under Account → Subscriptions.');
        }
        const { token } = readStoredAuth();
        if (!token) {
          throw new Error('Please sign in to create a meal plan subscription.');
        }
        const body = buildWebSubscriptionBodyFromPayload(payload);
        const data = await createWebMealPlanSubscription(body);
        if (!data?.emailDelivered) {
          console.warn('Subscription created but DigiRasa API email notify was incomplete:', {
            opsEmailDelivered: data?.opsEmailDelivered,
            customerEmailDelivered: data?.customerEmailDelivered,
          });
        }
        const invoice = buildInvoice({ payload, responseData: data, isEditing: false });
        const firstName = (customerDetails.firstName || '').trim();
        const email = (customerDetails.email || '').trim();
        setInvoiceData(invoice);
        setSubscriptionSuccess({
          subscriptionNumber: data.subscriptionNumber || invoice.referenceId || '',
          lookupCode: data.lookupCode || invoice.lookupCode || '',
          firstName,
          email,
          emailDelivered: Boolean(data?.emailDelivered),
          customerEmailDelivered: Boolean(data?.customerEmailDelivered),
          opsEmailDelivered: Boolean(data?.opsEmailDelivered),
        });
        setApiMessage(
          `Subscription ${data.subscriptionNumber || ''} created and is currently pending for approval. `
          + 'You will be notified once the payment link is enabled. Track it under Account → Subscriptions.',
        );
        resetBuilder();
        clearSubscriptionCart();
        return;
      }

      throw new Error('Meal plan API is required. Set REACT_APP_USE_API_MEAL_PLANS=true.');
    } catch (err) {
      setSubError(err.message || 'Unable to save subscription.');
    } finally {
      setApiBusy(false);
    }
  };

  const startEditingSubscription = (subscription) => {
    setEditingSubscriptionId(subscription.id);
    setSubscriptionTitle(subscription.title || '');
    setCustomerDetails({
      firstName: subscription.customer?.firstName || '',
      lastName: subscription.customer?.lastName || '',
      phone: subscription.customer?.phone || '',
      email: subscription.customer?.email || '',
      locationArea: subscription.customer?.locationArea || '',
      city: subscription.customer?.city || 'Hyderabad',
      country: subscription.customer?.country || 'India',
      pincode: subscription.customer?.pincode || '',
      address: subscription.customer?.address || '',
      latitude: subscription.customer?.latitude ?? null,
      longitude: subscription.customer?.longitude ?? null,
      state: subscription.customer?.state || 'Telangana',
    });
    setSelectedPlanId(subscription.planId || 2);
    setSelectedMealType(subscription.mealType || 'lunch');
    setSelectedSchedule(subscription.scheduleId || 'daily');
    setSelectedDays(Array.isArray(subscription.days) ? subscription.days : []);
    if (Array.isArray(subscription.itemSchedules)) {
      const nextItemSchedules = {};
      subscription.itemSchedules.forEach((row) => {
        if (!row?.slotId || row.productId == null) return;
        const scheduleScope = row.scheduleScope || 'solo';
        nextItemSchedules[getItemScheduleKey(row.slotId, row.productId, scheduleScope)] = Array.isArray(row.days) ? row.days : [...daysOfWeek];
      });
      setItemSchedules(nextItemSchedules);
    } else {
      setItemSchedules({});
    }
    if (Array.isArray(subscription.slotSchedules)) {
      setSlotSchedules(() => {
        const next = createDefaultSlotSchedules();
        subscription.slotSchedules.forEach((row) => {
          if (!row?.slotId) return;
          next[row.slotId] = {
            scheduleId: row.scheduleId || 'daily',
            days: Array.isArray(row.days) ? row.days : [],
          };
        });
        return next;
      });
    } else {
      setSlotSchedules(createDefaultSlotSchedules());
    }
    setStartDate(subscription.startDate || '');
    setEndDate(subscription.endDate || '');
    const savedProducts = Array.isArray(subscription.products)
      ? subscription.products.map((product) => {
          const catalogProduct = subscriptionProducts.find((item) => item.id === product.id);
          return {
            ...catalogProduct,
            ...product,
            image: product.image || catalogProduct?.image || southThaliMenuImg,
          };
        })
      : [];
    const hasDefaultMeal = savedProducts.some((item) => isBasePlanProductId(item.id));
    const defaultProduct = getDefaultPlanProduct(subscription.planId || 2);
    setDraftProducts(
      !hasDefaultMeal && defaultProduct
        ? [defaultProduct, ...savedProducts]
        : savedProducts
    );
    setSubError('');
    setApiMessage('Editing selected subscription.');
  };

  const removeSubscription = async () => {
    setApiMessage('Manage or cancel subscriptions under Account → Subscriptions.');
  };

  const toggleSubscriptionStatus = async () => {
    setApiMessage('Pause or resume subscriptions under Account → Subscriptions.');
  };

  /* ── Slot helpers ─────────────────────────────────────────── */
  const getPausedSet = (subId) => pausedSlots[subId] || new Set();

  const toggleSlot = (subId, date) => {
    setPausedSlots(prev => {
      const existing = new Set(prev[subId] || []);
      existing.has(date) ? existing.delete(date) : existing.add(date);
      return { ...prev, [subId]: existing };
    });
  };

  const pauseSlotsRange = (subId, days) => {
    const sub = subscriptions.find(s => s.id === subId);
    if (!sub) return;
    const slots = computeSlots(sub);
    const now = new Date();
    const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    const until = new Date(today); until.setUTCDate(until.getUTCDate() + days - 1);
    setPausedSlots(prev => {
      const existing = new Set(prev[subId] || []);
      slots.forEach(({ date }) => {
        const parts = date.split('-');
        const d = new Date(Date.UTC(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2])));
        if (d >= today && d <= until) existing.add(date);
      });
      return { ...prev, [subId]: existing };
    });
  };

  const resumeAllSlots = (subId) => {
    setPausedSlots(prev => ({ ...prev, [subId]: new Set() }));
  };

  const pauseByDow = (subId, dayName) => {
    const sub = subscriptions.find(s => s.id === subId);
    if (!sub || !dayName) return;
    const slots = computeSlots(sub);
    const now = new Date();
    const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    setPausedSlots(prev => {
      const existing = new Set(prev[subId] || []);
      slots.forEach(({ date, dayName: dn }) => {
        if (dn === dayName) {
          const parts = date.split('-');
          const d = new Date(Date.UTC(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2])));
          if (d >= today) existing.add(date);
        }
      });
      return { ...prev, [subId]: existing };
    });
  };

  const isSignedIn = Boolean(readStoredAuth().token);

  return (
    <div className={`meal-plans-page${builderOnly ? ' meal-plans-page--builder-only' : ''}`}>
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <div className="container">
            <h1>MEAL PLANS</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Meal Plans</span>
            </div>
          </div>
        </div>
      </div>

      {!builderOnly ? (
        <SpecialtyPlansSection
          selectedPlanId={selectedSpecialtyPlanId}
          onSelectPlan={handleSelectSpecialtyPlan}
          hideSelectButton
        />
      ) : null}

      {/* Subscription Builder */}
      <section className="mp-builder" id="subscription-builder" ref={builderSectionRef}>
        <div className="container">
          {subscriptionSuccess ? (
            <section
              ref={successSectionRef}
              className="mp-success"
              tabIndex={-1}
              aria-live="polite"
            >
              <div className="mp-success__icon" aria-hidden>
                <FaCheckCircle />
              </div>
              <h2>Request Received!</h2>
              <p>
                Thank you{subscriptionSuccess.firstName ? (
                  <>
                    , <strong>{subscriptionSuccess.firstName}</strong>
                  </>
                ) : null}
                ! Your meal plan subscription has been submitted successfully and is currently
                pending for approval. You will be notified once the payment link is enabled.
              </p>
              <div className="mp-success__ref">
                <span>Your Subscription ID</span>
                <strong>{subscriptionSuccess.subscriptionNumber || 'Assigned'}</strong>
                {subscriptionSuccess.lookupCode ? (
                  <small>
                    Lookup code: <strong>{subscriptionSuccess.lookupCode}</strong>
                  </small>
                ) : null}
                <small>
                  Track this anytime under{' '}
                  <Link to="/account/subscriptions">My Profile → Subscriptions</Link>.
                </small>
              </div>
              {!subscriptionSuccess.customerEmailDelivered ? (
                <p className="mp-success__notice mp-success__notice--warn" role="status">
                  {subscriptionSuccess.opsEmailDelivered
                    ? 'Your request was saved and our team was notified, but the confirmation email to you could not be sent. Please check spam or contact customercare@digirasa.com with your subscription ID.'
                    : 'Your request was saved, but confirmation emails could not be sent right now. Please keep your subscription ID and contact customercare@digirasa.com if needed.'}
                </p>
              ) : subscriptionSuccess.email ? (
                <p className="mp-success__notice" role="status">
                  A confirmation email was sent to <strong>{subscriptionSuccess.email}</strong>.
                </p>
              ) : null}
              <div className="mp-success__actions">
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => setInvoiceModalOpen(true)}
                  disabled={!invoiceData}
                >
                  View receipt
                </button>
                <button
                  type="button"
                  className="mp-cancel-edit"
                  onClick={() => {
                    resetBuilder();
                    setSubscriptionSuccess(null);
                    setInvoiceData(null);
                    setInvoiceModalOpen(false);
                    setApiMessage('');
                    scrollToBuilderStep(1);
                  }}
                >
                  Create another plan
                </button>
              </div>
            </section>
          ) : (
            <>
          {!builderOnly ? (
          <div className="section-header">
            <span className="section-tag">Build Your Subscription</span>
            <h2 className="section-title">CREATE <span>YOUR PLAN</span></h2>
            <p className="section-desc">
              Explore specialty meal plans above, then create your subscription by adding meals to delivery slots, setting delivery days, and choosing your plan and dates.
            </p>
          </div>
          ) : null}

          {builderOnly ? (
            <div className="sbp-page mp-builder-wizard">
            <div className="mp-add-subscription-layout">
              <nav ref={builderNavRef} className="sbp-stepnav" aria-label="Subscription builder steps">
                <p className="sbp-stepnav__progress" aria-live="polite">
                  <span>Step {builderStep} of 4</span>
                  <strong>{BUILDER_STEP_LABELS[builderStep - 1][0]}</strong>
                </p>
                <div className="sbp-stepnav__steps" role="tablist">
                  {BUILDER_STEP_LABELS.map(([label, note], index) => {
                    const step = index + 1;
                    const locked = step > highestBuilderStep;
                    return (
                      <button
                        key={label}
                        type="button"
                        role="tab"
                        id={`mp-builder-tab-${step}`}
                        aria-selected={builderStep === step}
                        aria-controls={`mp-builder-step-${step}`}
                        className={`${builderStep === step ? 'is-active' : ''}${step < builderStep ? ' is-done' : ''}${locked ? ' is-locked' : ''}`}
                        disabled={locked}
                        title={locked ? 'Complete the current step to continue' : undefined}
                        onClick={() => jumpToBuilderStep(step)}
                      >
                        <span className="sbp-stepnav__num">{step < builderStep ? <FaCheck /> : step}</span>
                        <span>{label}<small>{note}</small></span>
                      </button>
                    );
                  })}
                </div>
                <div className={`sbp-stepnav__summary${titleEditing ? ' is-editing' : ''}`}>
                  {titleEditing ? (
                    <input
                      ref={titleChipInputRef}
                      className="sbp-stepnav__summary-name"
                      value={subscriptionTitle}
                      onChange={(event) => setSubscriptionTitle(event.target.value)}
                      onBlur={() => setTitleEditing(false)}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === 'Escape') event.currentTarget.blur();
                      }}
                      placeholder="Name this subscription"
                      aria-label="Subscription title"
                    />
                  ) : (
                    <button
                      type="button"
                      className="sbp-stepnav__summary-name"
                      onClick={() => setTitleEditing(true)}
                      title="Click to edit title"
                    >
                      {subscriptionTitle.trim() || 'Enter subscription title'}
                    </button>
                  )}
                  <button
                    type="button"
                    className="sbp-stepnav__summary-total"
                    onClick={() => setPlanOverviewOpen(true)}
                  >
                    {formatCurrency(liveCharges.totalPrice)}
                  </button>
                  <button
                    type="button"
                    className="sbp-stepnav__summary-meta"
                    onClick={() => setPlanOverviewOpen(true)}
                  >
                    {[
                      `${builderUiSlotCodes.length}/${SELECTABLE_BUILDER_SLOTS.length} options`,
                      builderSlotItemCount && builderUiSlotCodes.length
                        ? `${builderSlotItemCount} meals`
                        : null,
                      builderSlotItemCount > 0 ? summaryDeliveryDaysLabel : null,
                      builderSlotItemCount > 0 && summaryDiscountPercent > 0
                        ? `${summaryDiscountPercent}% off`
                        : null,
                      selectedSummaryAddressLabel ? 'Address set' : null,
                    ].filter(Boolean).join(' · ')}
                  </button>
                </div>
              </nav>

              <label
                id="mp-subscription-title-row"
                ref={builderTitleRef}
                className={`sbp-title-field sbp-title-field--page${customerFieldErrors.subscriptionTitle ? ' is-error' : ''}`}
                htmlFor="mp-subscription-title"
              >
                <span>Subscription title *</span>
                <input
                  id="mp-subscription-title"
                  type="text"
                  value={subscriptionTitle}
                  onChange={(e) => {
                    setSubscriptionTitle(e.target.value);
                    setCustomerFieldErrors((prev) => {
                      if (!prev.subscriptionTitle) return prev;
                      const next = { ...prev };
                      delete next.subscriptionTitle;
                      return next;
                    });
                    if (subError) setSubError('');
                  }}
                  placeholder="Name this subscription"
                  required
                  aria-required="true"
                  aria-invalid={Boolean(customerFieldErrors.subscriptionTitle)}
                />
                {customerFieldErrors.subscriptionTitle ? (
                  <p className="mp-field-error">{customerFieldErrors.subscriptionTitle}</p>
                ) : null}
              </label>

              <section
                id="mp-builder-step-1"
                className="sbp-step sbp-step--comparison"
                role="tabpanel"
                aria-labelledby="mp-builder-tab-1"
                hidden={builderStep !== 1}
              >
                <header className="sbp-step__head">
                  <div>
                    <span className="sbp-step__kicker">Step 1</span>
                    <h2 id="mp-subscription-delivery-title">Choose your meals</h2>
                    <p>Pick Breakfast, Lunch, Dinner, or Full Day. You can mix Full Day with extra single meals.</p>
                  </div>
                </header>
                <div className="sbp-compact-slots">
                  <div className="sbp-compact-slots__head">
                    <div>
                      <h3>Selected slots</h3>
                      <p>Add meals per slot, or choose Full Day for all five kitchen windows.</p>
                    </div>
                    <div className="sbp-compact-slots__actions">
                      <button
                        type="button"
                        className="mp-add-subscription-clear-all"
                        onClick={() => setClearAllConfirmOpen(true)}
                        disabled={builderSlotItemCount === 0}
                      >
                        Clear all meals
                      </button>
                    </div>
                  </div>
                  {inRangeWeekdays ? (
                    <p className="mp-add-subscription-range-hint">
                      Dashed grey days are outside your selected date range — they stay selected unless you turn them off.
                    </p>
                  ) : null}
                  <div className="sbp-board">
                    <div className="sbp-board__head">
                      <span>Meal slot</span>
                      <span>Meals</span>
                      <span>Delivery days</span>
                    </div>
                    <div className="sbp-board__body">
                      {SELECTABLE_BUILDER_SLOTS.map((slot, index) => {
                        const isFullDayRow = slot.id === FULL_DAY_UI_SLOT_ID;
                        const slotItems = isFullDayRow
                          ? []
                          : (slotDraftProducts[slot.id] || []).filter((item) => !item.isFullDayPackage);
                        const SlotIcon = slot.icon;
                        const slotMealCount = isFullDayRow
                          ? fullDayPackageGroups.reduce(
                            (sum, group) => sum + Math.max(1, Number(group.quantity) || 1),
                            0,
                          )
                          : slotItems.reduce(
                            (sum, item) => sum + Math.max(1, Number(item.quantity) || 1),
                            0,
                          );
                        return (
                          <article
                            key={slot.id}
                            className={`sbp-board-row${index % 2 === 0 ? ' is-shaded' : ''}${isFullDayRow ? ' sbp-board-row--full-day' : ' sbp-board-row--single'}`}
                          >
                            <div className={`sbp-board-slot${slotMealCount ? ' is-filled' : ''}${isFullDayRow ? ' sbp-board-slot--full-day' : ''}`}>
                              <span className="sbp-board-slot__icon" aria-hidden="true">
                                {SlotIcon ? <SlotIcon /> : null}
                              </span>
                              <span>
                                <strong>
                                  {BUILDER_SLOT_SHORT_NAME[slot.id] || slot.label}
                                  {isFullDayRow ? <em className="sbp-board-slot__tag">Package</em> : null}
                                </strong>
                                <small>{isFullDayRow ? 'Breakfast → Dinner · 5 slots' : slot.time}</small>
                              </span>
                              <button
                                type="button"
                                className="sbp-board-slot__add"
                                onClick={() => openAddItemsPickerForSlot(slot.id)}
                                aria-label={isFullDayRow ? 'Add Full Day package' : `Add meal to ${slot.label}`}
                                title={isFullDayRow ? 'Add Full Day' : 'Add Meal'}
                              >
                                <FaPlus aria-hidden />
                              </button>
                              {slotMealCount ? (
                                <em className="sbp-board-slot__badge" aria-label={`${slotMealCount} meal${slotMealCount === 1 ? '' : 's'}`}>
                                  {slotMealCount}
                                </em>
                              ) : null}
                            </div>
                            <div className="sbp-board-meals">
                              {isFullDayRow
                                ? fullDayPackageGroups.map((group) => {
                                  const plan = group.planId ? getCatalogSpecialtyPlanById(group.planId) : null;
                                  const theme = resolveBuilderSpecialtyTheme(group.planId);
                                  const specialtyName = plan?.name || theme.name;
                                  const sampleSlotId = FULL_DAY_INTERNAL_SLOT_IDS.find((id) => group.itemsBySlot[id]);
                                  const sampleItem = sampleSlotId ? group.itemsBySlot[sampleSlotId] : null;
                                  const cuisine = resolveGeneralCuisineLabel(sampleItem, group.planId, specialtyRegionKey);
                                  const quantity = Math.max(1, Number(group.quantity) || 1);
                                  const menuSlotIds = plan
                                    ? (getPlanMenuSlotIds(plan).length
                                      ? getPlanMenuSlotIds(plan)
                                      : [...FULL_DAY_INTERNAL_SLOT_IDS])
                                    : [...FULL_DAY_INTERNAL_SLOT_IDS];
                                  const pricedPlan = group.regionKey && plan
                                    ? resolveSpecialtyPlanForRegion(plan, group.regionKey)
                                    : plan;
                                  const packagePricing = pricedPlan
                                    ? resolveFullPackageDayPricing(pricedPlan, menuSlotIds, group.organic)
                                    : null;
                                  const packagePerDay = packagePricing?.chargePerDay != null
                                    ? Number(packagePricing.chargePerDay)
                                    : FULL_DAY_INTERNAL_SLOT_IDS.reduce((sum, slotId) => {
                                      const item = group.itemsBySlot[slotId];
                                      return sum + Number(item?.price || 0);
                                    }, 0);
                                  const lineTotal = packagePerDay * quantity;
                                  const itemDays = sampleItem
                                    ? getItemScheduleDays(itemSchedules, sampleSlotId, sampleItem)
                                    : [...daysOfWeek];
                                  const slotsExpanded = expandedFullDayGroupIds.has(group.groupId);
                                  const includedSlots = EXTENDED_MEAL_SLOTS.filter(
                                    (inner) => group.itemsBySlot[inner.id],
                                  );
                                  return (
                                    <div key={group.groupId} className="sbp-board-meal sbp-board-meal--full-day">
                                      <div className="sbp-board-meal__row">
                                        <div
                                          className="sbp-board-product sbp-board-product--full-day"
                                          style={{
                                            '--sbp-specialty': theme.color,
                                            '--sbp-specialty-soft': theme.soft,
                                          }}
                                        >
                                          <button
                                            type="button"
                                            className="sbp-board-product__info"
                                            onClick={() => {
                                              if (group.planId) setBuilderPickerPlanId(group.planId);
                                              setUseOrganicPricing(Boolean(group.organic));
                                              const regionKey = getProductRegionKey(sampleItem) || group.regionKey;
                                              if (regionKey) setSpecialtyRegionKey(regionKey);
                                              openAddItemsPicker();
                                            }}
                                            title="Add another Full Day package"
                                          >
                                            <strong>
                                              {specialtyName}
                                              <em className="sbp-board-product__pkg">Full Day</em>
                                            </strong>
                                            <small>
                                              {group.organic ? 'Organic' : 'Regular'}
                                              {cuisine ? ` · ${cuisine}` : ''}
                                              {` · ${includedSlots.length || 5} slots · `}
                                              {formatCurrency(lineTotal)}
                                            </small>
                                          </button>
                                          <div className="sbp-board-product__actions">
                                            <div className="sbp-qty sbp-qty--compact" aria-label={`Quantity for ${specialtyName} Full Day`}>
                                              <button
                                                type="button"
                                                aria-label={`Decrease quantity for ${specialtyName} Full Day`}
                                                onClick={() => changeFullDayPackageQty(group.groupId, quantity - 1)}
                                              >
                                                <FaMinus />
                                              </button>
                                              <strong>{quantity}</strong>
                                              <button
                                                type="button"
                                                aria-label={`Increase quantity for ${specialtyName} Full Day`}
                                                onClick={() => changeFullDayPackageQty(group.groupId, quantity + 1)}
                                              >
                                                <FaPlus />
                                              </button>
                                            </div>
                                            <button
                                              type="button"
                                              className="sbp-board-product__remove"
                                              aria-label={`Remove ${specialtyName} Full Day`}
                                              onClick={() => {
                                                const firstSlot = sampleSlotId || 'breakfast';
                                                const firstItem = sampleItem || group.itemsBySlot[firstSlot];
                                                if (firstItem) {
                                                  requestRemoveSlotDraftProduct(firstSlot, firstItem.id, group.groupId);
                                                } else {
                                                  removeFullDayPackageGroup(group.groupId);
                                                }
                                              }}
                                            >
                                              <FaTrash />
                                            </button>
                                          </div>
                                        </div>
                                        <div className="sbp-board-meal__full-day-tools">
                                          <div className="sbp-days sbp-days--compact" aria-label={`Full Day ${specialtyName} days`}>
                                            {daysOfWeek.map((day) => {
                                              const isActive = itemDays.includes(day);
                                              const isOutOfRange = Boolean(inRangeWeekdays) && !inRangeWeekdays.has(day);
                                              return (
                                                <button
                                                  key={day}
                                                  type="button"
                                                  className={`${isActive ? 'is-on' : ''}${isOutOfRange ? ' is-out' : ''}`}
                                                  onClick={() => toggleFullDayPackageDay(group.groupId, day)}
                                                  title={isOutOfRange
                                                    ? `${day} is outside your selected date range`
                                                    : day}
                                                  aria-pressed={isActive}
                                                >
                                                  {day.slice(0, 3)}
                                                </button>
                                              );
                                            })}
                                          </div>
                                          <button
                                            type="button"
                                            className={`sbp-board-meal__slots-toggle${slotsExpanded ? ' is-open' : ''}`}
                                            aria-expanded={slotsExpanded}
                                            onClick={() => toggleFullDaySlotsExpanded(group.groupId)}
                                          >
                                            <FaListUl aria-hidden />
                                            <span>{slotsExpanded ? 'Hide' : 'View'} slots</span>
                                            <FaChevronDown aria-hidden />
                                          </button>
                                        </div>
                                      </div>
                                      {slotsExpanded ? (
                                        <ul className="sbp-board-meal__slot-list" aria-label={`${specialtyName} Full Day included slots`}>
                                          {(includedSlots.length ? includedSlots : EXTENDED_MEAL_SLOTS).map((inner) => {
                                            const InnerIcon = inner.icon;
                                            const innerItem = group.itemsBySlot[inner.id];
                                            return (
                                              <li key={`${group.groupId}-${inner.id}`}>
                                                <span className="sbp-board-meal__slot-list-icon" aria-hidden="true">
                                                  {InnerIcon ? <InnerIcon /> : null}
                                                </span>
                                                <span>
                                                  <strong>{BUILDER_SLOT_SHORT_NAME[inner.id] || inner.label}</strong>
                                                  <small>{inner.time}</small>
                                                </span>
                                                {innerItem?.price != null ? (
                                                  <em>{formatCurrency(Number(innerItem.price) || 0)}</em>
                                                ) : null}
                                              </li>
                                            );
                                          })}
                                        </ul>
                                      ) : null}
                                    </div>
                                  );
                                })
                                : slotItems.map((item) => {
                                  const itemDays = getItemScheduleDays(itemSchedules, slot.id, item);
                                  const { name, isOrganic } = getSubscriptionItemDisplay(item);
                                  const specialtyRef = parseSpecialtySlotProductId(item.id);
                                  const planId = item.planId || specialtyRef?.planId;
                                  const theme = resolveBuilderSpecialtyTheme(planId);
                                  const plan = planId ? getCatalogSpecialtyPlanById(planId) : null;
                                  const specialtyName = plan?.name || (planId ? theme.name : name);
                                  const cuisine = resolveGeneralCuisineLabel(item, planId, specialtyRegionKey);
                                  const quantity = Math.max(1, Number(item.quantity) || 1);
                                  const lineTotal = Number(item.price || 0) * quantity;
                                  const isAlacarteItem = !planId;
                                  return (
                                    <div key={`${slot.id}-${item.id}`} className="sbp-board-meal sbp-board-meal--single">
                                      <div
                                        className="sbp-board-product"
                                        style={{
                                          '--sbp-specialty': isAlacarteItem ? '#5c534c' : theme.color,
                                          '--sbp-specialty-soft': isAlacarteItem ? '#f4f1ec' : theme.soft,
                                        }}
                                      >
                                        <button
                                          type="button"
                                          className="sbp-board-product__info"
                                          onClick={() => {
                                            if (planId) setBuilderPickerPlanId(planId);
                                            if (isOrganic != null) setUseOrganicPricing(isOrganic);
                                            const regionKey = getProductRegionKey(item);
                                            if (regionKey) setSpecialtyRegionKey(regionKey);
                                            openAddItemsPickerForSlot(slot.id, item.id);
                                          }}
                                          title={isAlacarteItem ? 'Change menu item' : 'Change specialty or cuisine'}
                                        >
                                          <strong>{specialtyName}</strong>
                                          <small>
                                            {isAlacarteItem
                                              ? 'Our menu · Regular'
                                              : `${isOrganic != null ? (isOrganic ? 'Organic' : 'Regular') : name}${cuisine ? ` · ${cuisine}` : ''}`}
                                            {' · '}
                                            {formatCurrency(lineTotal)}
                                          </small>
                                        </button>
                                        <div className="sbp-board-product__actions">
                                          <div className="sbp-qty sbp-qty--compact" aria-label={`Quantity for ${name}`}>
                                            <button
                                              type="button"
                                              aria-label={`Decrease quantity for ${name}`}
                                              onClick={() => changeSlotDraftQty(slot.id, item.id, quantity - 1)}
                                            >
                                              <FaMinus />
                                            </button>
                                            <strong>{quantity}</strong>
                                            <button
                                              type="button"
                                              aria-label={`Increase quantity for ${name}`}
                                              onClick={() => changeSlotDraftQty(slot.id, item.id, quantity + 1)}
                                            >
                                              <FaPlus />
                                            </button>
                                          </div>
                                          <button
                                            type="button"
                                            className="sbp-board-product__remove"
                                            aria-label={`Remove ${name} from ${slot.label}`}
                                            onClick={() => requestRemoveSlotDraftProduct(slot.id, item.id)}
                                          >
                                            <FaTrash />
                                          </button>
                                        </div>
                                      </div>
                                      <div className="sbp-days sbp-days--compact" aria-label={`${slot.label} ${name} days`}>
                                        {daysOfWeek.map((day) => {
                                          const isActive = itemDays.includes(day);
                                          const isOutOfRange = Boolean(inRangeWeekdays) && !inRangeWeekdays.has(day);
                                          return (
                                            <button
                                              key={day}
                                              type="button"
                                              className={`${isActive ? 'is-on' : ''}${isOutOfRange ? ' is-out' : ''}`}
                                              onClick={() => toggleItemScheduleDay(slot.id, item, day)}
                                              title={isOutOfRange
                                                ? `${day} is outside your selected date range`
                                                : day}
                                              aria-pressed={isActive}
                                            >
                                              {day.slice(0, 3)}
                                            </button>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </article>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <BuilderStepFooter
                  continueLabel={BUILDER_CONTINUE_LABELS[1]}
                  continueDisabled={!canContinueBuilder(1)}
                  onContinue={goToNextBuilderStep}
                />
              </section>

              <section
                id="mp-builder-step-2"
                className="sbp-step"
                role="tabpanel"
                aria-labelledby="mp-builder-tab-2"
                hidden={builderStep !== 2}
              >
                <header className="sbp-step__head">
                  <div>
                    <span className="sbp-step__kicker">Step 2</span>
                    <h2 id="mp-subscription-setup-title">Set schedule</h2>
                    <p>
                      Choose a duration band or edit the end date — bands and discounts are based on{' '}
                      <strong>delivery days</strong> from your Step 1 schedule, not calendar days.
                      Minimum {SUBSCRIPTION_MIN_DAYS} delivery days.
                    </p>
                  </div>
                </header>

                <aside
                  className={`sbp-schedule-discount-note${hasFullDaySelection ? ' sbp-schedule-discount-note--full-day' : ' sbp-schedule-discount-note--band'}`}
                  role="note"
                >
                  <FaCheck aria-hidden />
                  <div>
                    {hasFullDaySelection ? (
                      <>
                        <strong>Full Day Meal selected — {fullDayPlanDiscountPercent}% off</strong>
                        <p>
                          Full Day applies a fixed {fullDayPlanDiscountPercent}% meal package discount for any plan length.
                          Day-band % cards below do not change that. Minimum subscription length is still {SUBSCRIPTION_MIN_DAYS} delivery days.
                        </p>
                      </>
                    ) : (
                      <>
                        <strong>
                          {appliedDayDiscount.discountPercent > 0
                            ? `${Number(appliedDayDiscount.discountPercent)}% off from ${selectedDayBand.title}`
                            : `${selectedDayBand.title} selected`}
                        </strong>
                        <p>
                          {appliedDayDiscount.discountPercent > 0
                            ? `This discount applies to all meal slots for your selected plan length. Duration bands set how long you subscribe (minimum ${SUBSCRIPTION_MIN_DAYS} delivery days).`
                            : `Choose dates with at least ${SUBSCRIPTION_MIN_DAYS} delivery days from your Step 1 schedule to continue.`}
                        </p>
                      </>
                    )}
                  </div>
                </aside>

                <div className="sbp-plan-grid" id="mp-subscription-plan-group" role="group" aria-label="Select duration band">
                  {allBuilderPlans.map((plan) => {
                    const copy = BUILDER_PLAN_CARD_COPY[plan.id] || { title: plan.name, note: plan.duration };
                    const discount = dayBandCardDiscountPercent(plan.band || getDayBandById(plan.id), visibleDayDiscounts);
                    const qualifies = deliveryDayCount >= Number(plan.minDays || 0);
                    return (
                      <button
                        key={plan.id}
                        type="button"
                        className={`${selectedPlanId === plan.id ? 'is-active' : ''}${qualifies && selectedPlanId !== plan.id ? ' is-qualified' : ''}`}
                        onClick={() => handlePlanSelection(plan.id)}
                      >
                        {hasFullDaySelection
                          ? <em className="is-banded">{fullDayPlanDiscountPercent}% Full Day</em>
                          : (discount ? <em>{discount}% off</em> : null)}
                        <strong>{copy.title}</strong>
                        <span>{copy.note}</span>
                      </button>
                    );
                  })}
                </div>

                <div className="sbp-schedule-split">
                  <div className="sbp-schedule-split__dates">
                    <div className="sbp-date-grid">
                      <label htmlFor="mp-subscription-start-date">
                        <span>Start date</span>
                        <input
                          id="mp-subscription-start-date"
                          ref={startDateInputRef}
                          type={activeDateField === 'start' ? 'date' : 'text'}
                          value={activeDateField === 'start' ? startDate : formatDateForDisplay(startDate)}
                          min={getMinSubscriptionStartDateIso()}
                          placeholder="dd-mmm-yyyy"
                          readOnly={activeDateField !== 'start'}
                          onPointerDown={() => setActiveDateField('start')}
                          onFocus={() => openDatePicker('start')}
                          onBlur={() => closeDatePicker('start')}
                          onChange={(e) => handleStartDateChange(e.target.value)}
                        />
                      </label>
                      <label htmlFor="mp-subscription-end-date">
                        <span>
                          End date
                          {selectedDayBand ? ` · ${selectedDayBand.title}` : ''}
                        </span>
                        <input
                          id="mp-subscription-end-date"
                          ref={endDateInputRef}
                          type={activeDateField === 'end' ? 'date' : 'text'}
                          value={activeDateField === 'end' ? endDate : formatDateForDisplay(endDate)}
                          min={startDate
                            ? resolveBandEndDate(startDate, SUBSCRIPTION_MIN_DAYS)
                            : getMinSubscriptionStartDateIso()}
                          placeholder="dd-mmm-yyyy"
                          readOnly={activeDateField !== 'end'}
                          onPointerDown={() => setActiveDateField('end')}
                          onFocus={() => openDatePicker('end')}
                          onBlur={() => closeDatePicker('end')}
                          onChange={(e) => handleEndDateChange(e.target.value)}
                        />
                      </label>
                    </div>

                    <div
                      className={`sbp-date-grid__delivery-days${deliveryDayCount >= SUBSCRIPTION_MIN_DAYS ? ' is-ready' : ''}`}
                      role="status"
                      aria-live="polite"
                    >
                      <span className="sbp-date-grid__delivery-days-label">Delivery days in this plan</span>
                      <strong className="sbp-date-grid__delivery-days-value">
                        {deliveryDayCount > 0 ? deliveryDayCount : '—'}
                      </strong>
                      <small className="sbp-date-grid__delivery-days-hint">
                        {deliveryDayCount > 0
                          ? `From ${formatDateForDisplay(startDate)} – ${formatDateForDisplay(activeEndDate)} · Step 1 schedule`
                          : 'Set start and end dates to calculate delivery days'}
                      </small>
                    </div>

                    {deliveryDayCount < SUBSCRIPTION_MIN_DAYS ? (
                      <div className="sbp-discount-note sbp-discount-note--warn">
                        <FaCheck />
                        {`Choose at least ${SUBSCRIPTION_MIN_DAYS} delivery days to continue.`}
                      </div>
                    ) : null}
                  </div>

                  <aside
                    className={`sbp-discount-panel sbp-discount-panel--bands${hasFullDaySelection ? ' sbp-discount-panel--full-day' : ''}`}
                    role="region"
                    aria-label="Plan discount"
                  >
                    <header className="sbp-discount-panel__head">
                      <span><FaPercent aria-hidden="true" /> Plan discount</span>
                      <em>{hasFullDaySelection ? 'Full Day' : 'Day bands'}</em>
                    </header>

                    {hasFullDaySelection ? (
                      <>
                        <h3 className="sbp-discount-panel__title">
                          {fullDayPlanDiscountPercent}% Full Day Meal package
                        </h3>
                        <p className="sbp-discount-panel__hint">
                          Locked while Full Day is in your meals. Duration bands still set how long you subscribe (min {SUBSCRIPTION_MIN_DAYS} delivery days), but not this discount.
                        </p>
                      </>
                    ) : visibleDayDiscounts.length > 0 ? (
                      <>
                        <h3 className="sbp-discount-panel__title">Discount bands by delivery days</h3>
                        <div className="sbp-discount-panel__tiers">
                          {visibleDayDiscounts.map((tier) => {
                            const isActive = USE_MAX_PLAN_UNIFORM_DISCOUNT
                              ? Number(tier.minDays) === Number(selectedDayBand.minDays)
                              : (
                                appliedDayDiscount.minDays != null
                                && Number(tier.minDays) === Number(appliedDayDiscount.minDays)
                                && Number(tier.discountPercent) === Number(appliedDayDiscount.discountPercent)
                              );
                            return (
                              <span
                                key={tier.id || `${tier.minDays}-${tier.discountPercent}`}
                                className={isActive ? 'is-active' : ''}
                              >
                                <small>{Number(tier.minDays)}+ delivery days</small>
                                <strong>{Number(tier.discountPercent)}% off</strong>
                                {isActive ? <b>Applied</b> : null}
                              </span>
                            );
                          })}
                        </div>
                      </>
                    ) : (
                      <h3 className="sbp-discount-panel__title">
                        {selectedBandDiscountPercent > 0
                          ? `${selectedBandDiscountPercent}% off from ${selectedDayBand.title}`
                          : 'Day-band discounts load with your plan'}
                      </h3>
                    )}
                  </aside>
                </div>
                <BuilderStepFooter
                  showBack
                  onBack={() => jumpToBuilderStep(1)}
                  continueLabel={BUILDER_CONTINUE_LABELS[2]}
                  continueDisabled={!canContinueBuilder(2)}
                  onContinue={goToNextBuilderStep}
                />
              </section>

              <section
                id="mp-builder-step-3"
                className="sbp-step"
                role="tabpanel"
                aria-labelledby="mp-builder-tab-3"
                hidden={builderStep !== 3}
              >
                <header className="sbp-step__head">
                  <div>
                    <span className="sbp-step__kicker">Step 3</span>
                    <h2>Delivery address</h2>
                    <p>Choose where your meals should be delivered before reviewing the final charges.</p>
                  </div>
                  {isSignedIn ? (
                    <button
                      type="button"
                      className="sbp-btn sbp-btn--outline"
                      onClick={openAddressPicker}
                      disabled={apiBusy || addressesLoading}
                    >
                      <FaMapMarkerAlt /> {savedAddresses.length ? 'Add / manage' : 'Add address'}
                    </button>
                  ) : null}
                </header>

                {!isSignedIn ? (
                  <Link
                    className="sbp-address-note"
                    to={buildAuthRequiredRedirectUrl(location.pathname || '/add-subscription')}
                  >
                    <FaMapMarkerAlt />
                    Sign in to select a delivery address.
                  </Link>
                ) : addressesLoading ? (
                  <div className="sbp-address-note">Loading saved addresses…</div>
                ) : savedAddresses.length ? (
                  <div className="sbp-address-list" role="radiogroup" aria-label="Delivery addresses">
                    {savedAddresses.map((address) => {
                      const selected = Number(selectedAddressId) === Number(address.id) && !showManualAddress;
                      const card = formatSavedAddressCard(address);
                      const TypeIcon = builderAddressTypeMeta(address.type).icon;
                      const km = distanceKmFromKitchen(address);
                      const freeRadius = getSubscriptionFreeDeliveryRadiusKm({
                        planId: selectedPlanId,
                        deliveryDays: Math.max(1, deliveryDayCount || 1),
                      });
                      const perTrip = deliveryChargePerTrip(km, freeRadius);
                      return (
                        <button
                          key={address.id}
                          type="button"
                          role="radio"
                          aria-checked={selected}
                          className={selected ? 'sbp-address-card is-active' : 'sbp-address-card'}
                          onClick={() => handleSubscriptionAddressSelect(address.id)}
                        >
                          <span className="sbp-address-card__check" aria-hidden="true">
                            <TypeIcon />
                          </span>
                          <span className="sbp-address-card__body">
                            <strong>
                              {card.label}
                              {selected ? (
                                <span className="sbp-address-card__selected-tag">Selected</span>
                              ) : null}
                            </strong>
                            <small>{card.line}</small>
                            <em>{[card.city, card.pincode].filter(Boolean).join(' · ')}</em>
                            <em className="sbp-address-card__distance">
                              {km != null ? formatKitchenDistance(km) : 'Map the pin to see kitchen distance'}
                            </em>
                          </span>
                          <span className="sbp-address-card__meta">
                            Delivery
                            <b>
                              {perTrip == null
                                ? '—'
                                : perTrip === 0
                                  ? 'Free'
                                  : formatCurrency(perTrip)}
                            </b>
                          </span>
                        </button>
                      );
                    })}
                  </div>
                ) : (
                  <div className="sbp-address-note">
                    <FaMapMarkerAlt />
                    No saved addresses yet. Add one to continue.
                  </div>
                )}

                {!selectedSummaryAddressLabel ? (
                  <div className="sbp-address-note">
                    <FaMapMarkerAlt />
                    Select an address to continue to review.
                  </div>
                ) : null}

                <BuilderStepFooter
                  showBack
                  onBack={() => jumpToBuilderStep(2)}
                  continueLabel={BUILDER_CONTINUE_LABELS[3]}
                  continueDisabled={!canContinueBuilder(3)}
                  onContinue={goToNextBuilderStep}
                />
              </section>

              <section
                id="mp-builder-step-4"
                className="sbp-step sbp-step--review"
                role="tabpanel"
                aria-labelledby="mp-builder-tab-4"
                hidden={builderStep !== 4}
              >
                <header className="sbp-step__head">
                  <div>
                    <span className="sbp-step__kicker">Step 4</span>
                    <h2 id="mp-subscription-summary-title">Review &amp; confirm</h2>
                    <p>Week overview, delivery address, and estimated charges.</p>
                  </div>
                  <button
                    type="button"
                    className="sbp-btn sbp-btn--outline"
                    onClick={() => setReviewCalendarOpen(true)}
                    disabled={!selectedBuilderSlotIds.length || !startDate || !activeEndDate}
                  >
                    <FaCalendarAlt /> View full plan calendar
                  </button>
                </header>
                <div className="sbp-week-overview">
                  <div className="sbp-week-overview__head">
                    <h3>Meals by weekday</h3>
                    <p>Only weekdays in your selected plan dates. Full Day shows as one package with 3 delivery trips.</p>
                  </div>
                  <div className="sbp-week-strip">
                    {weekdaySlotOverview.length ? weekdaySlotOverview.map((entry) => (
                      <div
                        key={entry.day}
                        className={`sbp-week-strip__day${entry.slots.length ? '' : ' is-empty'}`}
                      >
                        <strong>{entry.short}</strong>
                        {entry.slots.length ? (
                          <ul className="sbp-week-strip__slots">
                            {entry.slots.map((row) => (
                              <li
                                key={row.id}
                                className={[
                                  row.isFullDay ? 'is-full-day' : '',
                                  row.detail ? 'has-detail' : '',
                                ].filter(Boolean).join(' ') || undefined}
                              >
                                <span>
                                  {row.label}
                                  {row.quantity > 1 ? ` ×${row.quantity}` : ''}
                                </span>
                                {row.detail ? (
                                  <small className="sbp-week-strip__detail">{row.detail}</small>
                                ) : null}
                                {row.isFullDay ? (
                                  <small className="sbp-week-strip__trips">
                                    {row.trips} delivery trip{row.trips === 1 ? '' : 's'}
                                  </small>
                                ) : null}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <em>No meals</em>
                        )}
                      </div>
                    )) : (
                      <p className="sbp-week-strip__empty">No delivery days in the selected dates.</p>
                    )}
                  </div>
                </div>
                <div className={`sbp-address${selectedReviewAddress ? ' sbp-address--selected' : ''}`}>
                  <span>
                    <ReviewAddressIcon aria-hidden />
                    <span className="sbp-address__copy">
                      <em>Delivery address</em>
                      {selectedReviewAddress ? (
                        <>
                          <strong>{selectedReviewAddress.card.label}</strong>
                          {selectedReviewAddress.card.line ? (
                            <small>{selectedReviewAddress.card.line}</small>
                          ) : null}
                          <small>
                            {[
                              selectedReviewAddress.card.city,
                              selectedReviewAddress.card.pincode,
                              selectedReviewAddress.km != null
                                ? formatKitchenDistance(selectedReviewAddress.km)
                                : null,
                            ].filter(Boolean).join(' · ')}
                          </small>
                        </>
                      ) : (
                        <strong>{selectedSummaryAddressLabel || 'No delivery address selected'}</strong>
                      )}
                    </span>
                  </span>
                  <button type="button" onClick={() => jumpToBuilderStep(3)}>
                    {selectedSummaryAddressLabel ? 'Change' : 'Select address'}
                  </button>
                </div>

                <div className="sbp-price-lines">
                  <p>
                    <span>Sub total</span>
                    <strong>{formatCurrency(builderSubscriptionTotals.actual)}</strong>
                  </p>
                  <p className={builderSubscriptionTotals.discountSaving > 0 ? 'is-saving' : ''}>
                    <span>
                      Discount
                      {Number(builderSubscriptionTotals.discountPercent) > 0
                        ? ` (${Number(builderSubscriptionTotals.discountPercent)}%)`
                        : (Number(appliedDayDiscount.discountPercent) > 0
                          ? ` (${Number(appliedDayDiscount.discountPercent)}%)`
                          : '')}
                    </span>
                    <strong>
                      {formatCurrency(builderSubscriptionTotals.discountSaving || 0)}
                    </strong>
                  </p>
                  <p>
                    <span>Packaging</span>
                    <strong>{formatCurrency(liveCharges.totalPackagingCharge)}</strong>
                  </p>
                  <p>
                    <span>GST ({liveCharges.gstPercent}%)</span>
                    <strong>{formatCurrency(liveCharges.totalTax)}</strong>
                  </p>
                  <p>
                    <span>
                      Delivery
                      {!selectedSummaryAddressLabel
                        ? <em>select address in step 3</em>
                        : (liveCharges.isFreeDeliveryPlan
                          ? ` (${liveCharges.deliveryTripCount} trips · free within ${liveCharges.freeDeliveryRadiusKm} km)`
                          : liveCharges.distanceKm != null
                            ? ` (${liveCharges.deliveryTripCount} trips · ${formatKitchenDistance(liveCharges.distanceKm)})`
                            : ' · select a mapped address for exact charge')}
                    </span>
                    <strong>
                      {selectedSummaryAddressLabel ? formatCurrency(liveCharges.totalDeliveryCharge) : '—'}
                    </strong>
                  </p>
                  <p className="sbp-price-lines__total">
                    <span>Estimated total</span>
                    <strong>{formatCurrency(liveCharges.totalPrice)}</strong>
                  </p>
                </div>

                {subError ? <p className="mp-error">{subError}</p> : null}
                {apiMessage ? <p className="mp-info">{apiMessage}</p> : null}
                <div className="sbp-step__footer">
                  <button type="button" className="sbp-btn sbp-btn--outline" onClick={() => jumpToBuilderStep(3)}>
                    Back
                  </button>
                  <button
                    type="button"
                    className="sbp-create"
                    onClick={openDetailsModal}
                    disabled={apiBusy}
                  >
                    {editingSubscriptionId ? 'Continue to update' : 'Continue to details'} <FaArrowRight />
                  </button>
                </div>
              </section>
            </div>

            <div className="sbp-mobile-bar">
              {builderStep > 1 ? (
                <button
                  type="button"
                  className="sbp-mobile-bar__back"
                  onClick={() => jumpToBuilderStep(builderStep - 1)}
                >
                  <FaChevronLeft aria-hidden />
                  Back
                </button>
              ) : null}
              <button
                type="button"
                className="sbp-mobile-bar__summary"
                onClick={() => setPlanOverviewOpen(true)}
              >
                <span>Estimated total</span>
                <strong>{formatCurrency(liveCharges.totalPrice)}</strong>
              </button>
              <button
                type="button"
                className="sbp-mobile-bar__continue"
                onClick={() => (builderStep < 4 ? goToNextBuilderStep() : openDetailsModal())}
                disabled={builderStep < 4 ? !canContinueBuilder(builderStep) : apiBusy}
              >
                {builderStep < 4
                  ? 'Continue'
                  : (editingSubscriptionId ? 'Update plan' : 'Continue')}
                {' '}
                <FaArrowRight />
              </button>
            </div>

            {planOverviewOpen ? (
              <div
                className="sbp-summary-overlay"
                role="presentation"
                onMouseDown={(event) => {
                  if (event.target === event.currentTarget) setPlanOverviewOpen(false);
                }}
              >
                <aside
                  className="sbp-rail sbp-rail--panel"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="mp-builder-overview-title"
                >
                  <div className="sbp-rail__card">
                    <header className="sbp-rail__panel-head">
                      <div>
                        <span>Plan overview</span>
                        <h2 id="mp-builder-overview-title">Summary</h2>
                      </div>
                      <button
                        type="button"
                        className="sbp-icon-btn"
                        aria-label="Close plan overview"
                        onClick={() => setPlanOverviewOpen(false)}
                      >
                        <FaTimes />
                      </button>
                    </header>
                    <BuilderThaliProgress filledSlotIds={selectedBuilderSlotIds} />
                    <p className="sbp-rail__caption">
                      <strong>{builderUiSlotCodes.length}</strong> of {SELECTABLE_BUILDER_SLOTS.length} meal options
                      {builderUiSlotCodes.includes(FULL_DAY_UI_SLOT_ID) ? ' · includes Full Day' : ''}
                    </p>
                    <div className="sbp-rail__stats">
                      <p><span>Plan title</span><strong>{subscriptionTitle || 'Untitled plan'}</strong></p>
                      <p>
                        <span>Plan length</span>
                        <strong>
                          {builderSlotItemCount > 0
                            ? `${Math.max(1, deliveryDayCount || 0)} delivery days`
                            : '—'}
                        </strong>
                      </p>
                      <p>
                        <span>Best discount</span>
                        <strong>
                          {builderSlotItemCount > 0 && summaryDiscountPercent > 0
                            ? `${summaryDiscountPercent}%`
                            : '—'}
                        </strong>
                      </p>
                      <p><span>Address</span><strong>{selectedSummaryAddressLabel || 'Not selected'}</strong></p>
                    </div>
                    <div className="sbp-rail__total">
                      <span>
                        Estimated total
                        <small>{dateRangeLabel}</small>
                      </span>
                      <strong>{formatCurrency(liveCharges.totalPrice)}</strong>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        setPlanOverviewOpen(false);
                        if (builderStep < 4) goToNextBuilderStep();
                      }}
                      disabled={builderStep < 4 ? !canContinueBuilder(builderStep) : true}
                    >
                      {BUILDER_CONTINUE_LABELS[builderStep]} <FaArrowRight />
                    </button>
                  </div>
                </aside>
              </div>
            ) : null}

            {reviewCalendarOpen ? (
              <div
                className={`sbp-drawer-overlay sbp-drawer-overlay--center${detailsModalOpen ? ' sbp-drawer-overlay--elevated' : ''}`}
                role="presentation"
                onMouseDown={(event) => {
                  if (event.target === event.currentTarget) setReviewCalendarOpen(false);
                }}
              >
                <div
                  className="sbp-calendar-modal"
                  role="dialog"
                  aria-modal="true"
                  aria-labelledby="mp-builder-calendar-title"
                >
                  <header className="sbp-calendar-modal__head">
                    <div className="sbp-calendar-modal__title">
                      <h2 id="mp-builder-calendar-title">Full plan calendar</h2>
                      <p>{dateRangeLabel}</p>
                    </div>
                    <div className="sbp-calendar-modal__month-nav" role="group" aria-label="Calendar month">
                      <button
                        type="button"
                        className="sbp-calendar-modal__nav-btn"
                        onClick={() => setSummaryMonthIndex((prev) => Math.max(0, prev - 1))}
                        disabled={summaryMonthIndex <= 0 || summaryMonths.length <= 1}
                        aria-label="Previous month"
                      >
                        <FaChevronLeft aria-hidden />
                      </button>
                      <div className="sbp-calendar-modal__month">
                        {summaryMonths.length > 1 ? (
                          <select
                            value={Math.min(summaryMonthIndex, Math.max(0, summaryMonths.length - 1))}
                            onChange={(event) => setSummaryMonthIndex(Number(event.target.value))}
                            aria-label="Select month"
                          >
                            {summaryMonths.map((month, index) => (
                              <option key={month.key} value={index}>{month.label}</option>
                            ))}
                          </select>
                        ) : (
                          <strong>{activeSummaryMonth?.label || 'Select dates'}</strong>
                        )}
                      </div>
                      <button
                        type="button"
                        className="sbp-calendar-modal__nav-btn"
                        onClick={() => setSummaryMonthIndex((prev) => Math.min(summaryMonths.length - 1, prev + 1))}
                        disabled={summaryMonthIndex >= summaryMonths.length - 1 || summaryMonths.length <= 1}
                        aria-label="Next month"
                      >
                        <FaChevronRight aria-hidden />
                      </button>
                    </div>
                    <button
                      type="button"
                      className="sbp-calendar-modal__close"
                      aria-label="Close calendar"
                      onClick={() => setReviewCalendarOpen(false)}
                    >
                      <FaTimes />
                    </button>
                  </header>

                  <div className="sbp-calendar-modal__body">
                    {summaryDays.length > 0 ? (
                      <div className="sbp-calendar-scroll">
                        <table className="sbp-calendar-table">
                          <thead>
                            <tr>
                              <th className="sbp-calendar-table__slot">Slot</th>
                              {summaryDays.map((day) => (
                                <th key={day.iso}>
                                  <span>{day.dayShort}</span>
                                  <strong>{day.dateShort || day.dateLabel}</strong>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {calendarSlotRows.map((slot) => (
                              <tr key={slot.id}>
                                <th className="sbp-calendar-table__slot">
                                  {slot.label}
                                </th>
                                {summaryDays.map((day) => {
                                  const cellItems = slot.products.filter((product) => {
                                    const scheduleSlotId = product.slotId || slot.id;
                                    const productDays = getItemScheduleDays(
                                      itemSchedules,
                                      scheduleSlotId,
                                      product,
                                    );
                                    return productDays.includes(day.dayName);
                                  });
                                  if (!cellItems.length) {
                                    return (
                                      <td key={`${slot.id}-${day.iso}`}>
                                        <span className="sbp-calendar-empty">—</span>
                                      </td>
                                    );
                                  }
                                  return (
                                    <td key={`${slot.id}-${day.iso}`}>
                                      {cellItems.map((item) => {
                                        const { name, isOrganic } = getSubscriptionItemDisplay(item);
                                        const quantity = Math.max(1, Number(item.quantity) || 1);
                                        const lineTotal = Number(item.price || 0) * quantity;
                                        const specialtyRef = parseSpecialtySlotProductId(item.id);
                                        const planId = item.planId || specialtyRef?.planId;
                                        const theme = resolveBuilderSpecialtyTheme(planId);
                                        const plan = planId ? getCatalogSpecialtyPlanById(planId) : null;
                                        const specialtyName = plan?.name || theme.name;
                                        const cuisine = resolveGeneralCuisineLabel(item, planId, specialtyRegionKey);
                                        const itemSlotId = item.slotId || specialtyRef?.slotId || slot.id;
                                        const showTripSlotTag = (slot.slotIds?.length || 0) > 1;
                                        const tripSlotTag = showTripSlotTag
                                          ? `${BUILDER_SLOT_SHORT_NAME[itemSlotId] || itemSlotId}: `
                                          : '';
                                        const tooltipLines = getCalendarItemTooltipLines(item, {
                                          slotId: itemSlotId,
                                          dayName: day.dayName,
                                          regionKey: getProductRegionKey(item) || specialtyRegionKey,
                                          getPlanById: getCatalogSpecialtyPlanById,
                                        });
                                        const label = planId ? specialtyName : name;
                                        return (
                                          <div
                                            key={`${itemSlotId}-${item.id}-${day.iso}`}
                                            className={`sbp-calendar-item${showTripSlotTag ? ' sbp-calendar-item--trip-slot' : ''}`}
                                            style={{
                                              '--sbp-specialty': theme.color,
                                              '--sbp-specialty-soft': theme.soft,
                                            }}
                                            title={tooltipLines.join(' · ')}
                                          >
                                            <strong>
                                              {tripSlotTag}
                                              {quantity > 1 ? `${quantity}× ` : ''}
                                              {label}
                                              {isOrganic ? ' · Org' : ''}
                                              {cuisine ? ` · ${cuisine.replace(/ Indian$/i, '')}` : ''}
                                            </strong>
                                            <small>{formatCurrency(lineTotal)}</small>
                                          </div>
                                        );
                                      })}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr>
                              <th className="sbp-calendar-table__slot">
                                <div className="sbp-calendar-day-total is-labels">
                                  <strong>Day total</strong>
                                  <span>Actual</span>
                                  <span>
                                    {`Discount${summaryDiscountLabel ? ` (${summaryDiscountLabel})` : ''}`}
                                  </span>
                                  <span>Final</span>
                                </div>
                              </th>
                              {summaryDayTotals.map((day) => (
                                <td key={`${day.iso}-total`}>
                                  <div className="sbp-calendar-day-total" aria-label={`Day total for ${day.iso}`}>
                                    <strong aria-hidden="true" />
                                    <span>{formatCurrency(day.actual)}</span>
                                    <span className="is-discount">
                                      {formatCurrency(day.discountSaving || 0)}
                                      {!summaryDiscountLabel && day.discountLabel ? (
                                        <em>{` (${day.discountLabel})`}</em>
                                      ) : null}
                                    </span>
                                    <span className="is-final">{formatCurrency(day.final)}</span>
                                  </div>
                                </td>
                              ))}
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    ) : (
                      <p className="sbp-calendar-placeholder">
                        Select start and end dates to see the day-wise subscription summary.
                      </p>
                    )}
                  </div>

                  <footer className="sbp-calendar-modal__foot">
                    <div className="sbp-calendar-totals">
                      <div className="sbp-calendar-totals__main">
                        <div className="sbp-calendar-totals__row">
                          <p>
                            <span>
                              Subscription actual
                              {subscriptionPeriodTotals.dayCount
                                ? ` (${subscriptionPeriodTotals.dayCount} day${subscriptionPeriodTotals.dayCount === 1 ? '' : 's'})`
                                : ''}
                            </span>
                            <strong>{formatCurrency(subscriptionPeriodTotals.actual)}</strong>
                          </p>
                          <p>
                            <span>
                              Discount
                              {subscriptionPeriodTotals.discountLabel
                                ? ` (${Number(subscriptionPeriodTotals.discountPercent) > 0
                                  ? `${Number(subscriptionPeriodTotals.discountPercent)}% · `
                                  : ''}${subscriptionPeriodTotals.discountLabel})`
                                : ''}
                            </span>
                            <strong>{formatCurrency(subscriptionPeriodTotals.discountSaving || 0)}</strong>
                          </p>
                          <p>
                            <span>Subscription final</span>
                            <strong>{formatCurrency(subscriptionPeriodTotals.final)}</strong>
                          </p>
                        </div>
                        <div className="sbp-calendar-totals__row">
                          <p>
                            <span>Packaging</span>
                            <strong>{formatCurrency(liveCharges.totalPackagingCharge)}</strong>
                          </p>
                          <p>
                            <span>GST ({liveCharges.gstPercent}%)</span>
                            <strong>{formatCurrency(liveCharges.totalTax)}</strong>
                          </p>
                          <p>
                            <span>Delivery charges</span>
                            <strong title={selectedSummaryAddressLabel ? undefined : 'Calculated after address'}>
                              {selectedSummaryAddressLabel
                                ? formatCurrency(liveCharges.totalDeliveryCharge)
                                : '—'}
                            </strong>
                          </p>
                        </div>
                      </div>
                      <p className="is-grand">
                        <span>Est. total</span>
                        <strong>{formatCurrency(liveCharges.totalPrice)}</strong>
                      </p>
                    </div>
                  </footer>
                </div>
              </div>
            ) : null}
            </div>
          ) : (
            <div className="mp-builder__cta">
              <Link to="/add-subscription" className="btn-primary mp-builder__create-btn">
                CREATE YOUR PLAN
              </Link>
            </div>
          )}
            </>
          )}

        </div>
      </section>

      {addressPickerOpen && (
        <div
          className="mp-product-modal-overlay mp-product-modal-overlay--elevated"
          onClick={(e) => {
            if (e.target === e.currentTarget) closeAddressPicker();
          }}
        >
          <div
            className="mp-customer-modal mp-customer-modal--with-addresses mp-address-picker-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="mp-address-picker-title"
          >
            <div className="mp-product-modal__header">
              <div>
                <h3 id="mp-address-picker-title">Select delivery address</h3>
                <p>Choose an address, then click OK to update delivery charges.</p>
              </div>
              <button
                className="mp-product-modal__close"
                onClick={closeAddressPicker}
                aria-label="Close"
                type="button"
              >
                <FaTimes />
              </button>
            </div>
            <div className="mp-customer-modal__body">
              <CheckoutAddressSection
                isSignedIn={isSignedIn}
                loading={addressesLoading}
                addresses={savedAddresses}
                selectedId={pendingAddressId}
                onSelect={(id) => setPendingAddressId(id)}
                onAddressSaved={async (address) => {
                  const list = await reloadSubscriptionAddresses();
                  const id = address?.id != null ? Number(address.id) : null;
                  if (id == null) return;
                  const mergedList =
                    list.some((a) => Number(a.id) === id) || !address
                      ? list
                      : [...list, address];
                  if (mergedList !== list) setSavedAddresses(mergedList);
                  setPendingAddressId(id);
                }}
                signInRedirectPath={location.pathname || '/add-subscription'}
              />
            </div>
            <div className="mp-customer-modal__footer">
              <button type="button" className="mp-cancel-edit" onClick={closeAddressPicker}>
                Cancel
              </button>
              <button
                type="button"
                className="btn-primary"
                onClick={confirmAddressPicker}
                disabled={pendingAddressId == null}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {detailsModalOpen && (
        <div className="mp-product-modal-overlay">
          <div className="mp-customer-modal">
            <div className="mp-product-modal__header">
              <div>
                <h3>Personal Details</h3>
                <p>
                  {isSignedIn
                    ? (selectedAddressId != null && !showManualAddress
                      ? 'Confirm your profile details. Delivery uses the address you already selected.'
                      : 'Confirm your profile details.')
                    : 'Enter your delivery details to complete the subscription.'}
                </p>
              </div>
              <button className="mp-product-modal__close" onClick={() => setDetailsModalOpen(false)} aria-label="Close" disabled={apiBusy}>
                <FaTimes />
              </button>
            </div>

            <div className="mp-customer-modal__body">
              {detailsPrefillBusy ? (
                <p className="mp-info">Loading your profile and addresses…</p>
              ) : null}

              <div className="mp-form-grid">
                <div className={`mp-form-group${customerFieldErrors.firstName ? ' mp-form-group--error' : ''}`}>
                  <label htmlFor="mp-customer-firstName">First Name *</label>
                  <input
                    id="mp-customer-firstName"
                    type="text"
                    name="firstName"
                    placeholder="Your first name"
                    value={customerDetails.firstName}
                    onChange={handleCustomerDetailChange}
                    aria-invalid={Boolean(customerFieldErrors.firstName)}
                  />
                  {customerFieldErrors.firstName ? <p className="mp-field-error">{customerFieldErrors.firstName}</p> : null}
                </div>
                <div className={`mp-form-group${customerFieldErrors.lastName ? ' mp-form-group--error' : ''}`}>
                  <label htmlFor="mp-customer-lastName">Last Name</label>
                  <input
                    id="mp-customer-lastName"
                    type="text"
                    name="lastName"
                    placeholder="Optional"
                    value={customerDetails.lastName}
                    onChange={handleCustomerDetailChange}
                    aria-invalid={Boolean(customerFieldErrors.lastName)}
                  />
                  {customerFieldErrors.lastName ? <p className="mp-field-error">{customerFieldErrors.lastName}</p> : null}
                </div>
              </div>

              <div className="mp-form-grid">
                <div className={`mp-form-group${customerFieldErrors.phone ? ' mp-form-group--error' : ''}`}>
                  <label htmlFor="mp-customer-phone">Phone *</label>
                  <input
                    id="mp-customer-phone"
                    type="tel"
                    name="phone"
                    inputMode="numeric"
                    maxLength={15}
                    placeholder="10-digit or with country code"
                    value={customerDetails.phone}
                    onChange={handleCustomerDetailChange}
                    aria-invalid={Boolean(customerFieldErrors.phone)}
                  />
                  {customerFieldErrors.phone ? <p className="mp-field-error">{customerFieldErrors.phone}</p> : null}
                </div>
                <div className={`mp-form-group${customerFieldErrors.email ? ' mp-form-group--error' : ''}`}>
                  <label htmlFor="mp-customer-email">Email *</label>
                  <input
                    id="mp-customer-email"
                    type="email"
                    name="email"
                    placeholder="you@example.com"
                    value={customerDetails.email}
                    onChange={handleCustomerDetailChange}
                    aria-invalid={Boolean(customerFieldErrors.email)}
                  />
                  {customerFieldErrors.email ? <p className="mp-field-error">{customerFieldErrors.email}</p> : null}
                </div>
              </div>

              <div
                className={`mp-customer-modal__address-block${customerFieldErrors.deliveryAddress ? ' mp-form-group--error' : ''}`}
                data-field="deliveryAddress"
                tabIndex={-1}
              >
                {isSignedIn && savedAddresses.length > 0 && !showManualAddress ? (
                  <div className="mp-customer-modal__selected-address">
                    <div className="mp-customer-modal__selected-address-copy">
                      <h4>Delivery address</h4>
                      {selectedAddressId != null ? (
                        <p>
                          {[customerDetails.address, customerDetails.locationArea, customerDetails.city, customerDetails.pincode]
                            .filter(Boolean)
                            .join(', ')}
                          {subscriptionDistanceKm != null
                            ? ` · ${formatKitchenDistance(subscriptionDistanceKm)}`
                            : ''}
                        </p>
                      ) : (
                        <p>No delivery address selected yet.</p>
                      )}
                    </div>
                    <button
                      type="button"
                      className="mp-customer-modal__change-address-link"
                      onClick={openAddressPicker}
                    >
                      {selectedAddressId != null ? 'Change address' : 'Select address'}
                    </button>
                  </div>
                ) : isSignedIn && savedAddresses.length > 0 ? (
                  <button
                    type="button"
                    className="mp-customer-modal__change-address-link"
                    onClick={openAddressPicker}
                  >
                    Use a saved address
                  </button>
                ) : null}
                {customerFieldErrors.deliveryAddress ? (
                  <p className="mp-field-error">{customerFieldErrors.deliveryAddress}</p>
                ) : null}
              </div>

              {(showManualAddress || !isSignedIn || savedAddresses.length === 0) && (
                <>
                  <div className="mp-form-grid">
                    <div className={`mp-form-group${customerFieldErrors.locationArea ? ' mp-form-group--error' : ''}`}>
                      <label htmlFor="mp-customer-locationArea">Location / Area *</label>
                      <input
                        id="mp-customer-locationArea"
                        type="text"
                        name="locationArea"
                        placeholder="e.g. Madhapur, Kukatpally"
                        value={customerDetails.locationArea}
                        onChange={handleCustomerDetailChange}
                        aria-invalid={Boolean(customerFieldErrors.locationArea)}
                      />
                      {customerFieldErrors.locationArea ? <p className="mp-field-error">{customerFieldErrors.locationArea}</p> : null}
                    </div>
                    <div className={`mp-form-group${customerFieldErrors.pincode ? ' mp-form-group--error' : ''}`}>
                      <label htmlFor="mp-customer-pincode">PIN Code *</label>
                      <input
                        id="mp-customer-pincode"
                        type="text"
                        name="pincode"
                        inputMode="numeric"
                        maxLength="6"
                        placeholder="6-digit PIN code"
                        value={customerDetails.pincode}
                        onChange={handleCustomerDetailChange}
                        aria-invalid={Boolean(customerFieldErrors.pincode)}
                      />
                      {customerFieldErrors.pincode ? <p className="mp-field-error">{customerFieldErrors.pincode}</p> : null}
                    </div>
                  </div>

                  <div className="mp-form-grid">
                    <div className={`mp-form-group${customerFieldErrors.city ? ' mp-form-group--error' : ''}`}>
                      <label htmlFor="mp-customer-city">City *</label>
                      <input id="mp-customer-city" type="text" name="city" value={customerDetails.city} readOnly />
                      {customerFieldErrors.city ? <p className="mp-field-error">{customerFieldErrors.city}</p> : null}
                    </div>
                    <div className={`mp-form-group${customerFieldErrors.country ? ' mp-form-group--error' : ''}`}>
                      <label htmlFor="mp-customer-country">Country *</label>
                      <input id="mp-customer-country" type="text" name="country" value={customerDetails.country} readOnly />
                      {customerFieldErrors.country ? <p className="mp-field-error">{customerFieldErrors.country}</p> : null}
                    </div>
                  </div>

                  <div className={`mp-form-group mp-form-group--full${customerFieldErrors.address ? ' mp-form-group--error' : ''}`} style={{ marginBottom: 0 }}>
                    <label htmlFor="mp-customer-address">Street Address *</label>
                    <textarea
                      id="mp-customer-address"
                      name="address"
                      rows="3"
                      placeholder="House no, street, landmark"
                      value={customerDetails.address}
                      onChange={handleCustomerDetailChange}
                      aria-invalid={Boolean(customerFieldErrors.address)}
                    />
                    {customerFieldErrors.address ? <p className="mp-field-error">{customerFieldErrors.address}</p> : null}
                  </div>
                </>
              )}

              <div className="mp-customer-modal__charges" aria-live="polite">
                <h4>Charges for this subscription</h4>
                <p>
                  <span>Sub total</span>
                  <strong>{formatCurrency(builderSubscriptionTotals.actual)}</strong>
                </p>
                <p className={builderSubscriptionTotals.discountSaving > 0 ? 'is-saving' : ''}>
                  <span>
                    Discount
                    {Number(builderSubscriptionTotals.discountPercent) > 0
                      ? ` (${Number(builderSubscriptionTotals.discountPercent)}%)`
                      : ''}
                  </span>
                  <strong>
                    {formatCurrency(builderSubscriptionTotals.discountSaving || 0)}
                  </strong>
                </p>
                <p><span>Packaging</span><strong>{formatCurrency(liveCharges.totalPackagingCharge)}</strong></p>
                <p><span>GST ({liveCharges.gstPercent}%)</span><strong>{formatCurrency(liveCharges.totalTax)}</strong></p>
                <p>
                  <span>
                    Delivery
                    {liveCharges.isFreeDeliveryPlan
                      ? ` (${liveCharges.deliveryTripCount} trips · free within ${liveCharges.freeDeliveryRadiusKm} km)`
                      : liveCharges.distanceKm != null
                        ? ` (${liveCharges.deliveryTripCount} trips · ${formatKitchenDistance(liveCharges.distanceKm)})`
                        : ' · select a mapped address for exact charge'}
                  </span>
                  <strong>{formatCurrency(liveCharges.totalDeliveryCharge)}</strong>
                </p>
                <p className="mp-customer-modal__charges-grand">
                  <span>Total amount</span>
                  <strong>{formatCurrency(liveCharges.totalPrice)}</strong>
                </p>
              </div>

            </div>

            <div className="mp-customer-modal__sticky-consent">
              <div
                className={`mp-customer-modal__terms${customerFieldErrors.acceptTerms ? ' mp-form-group--error' : ''}`}
                data-field="acceptTerms"
              >
                <label htmlFor="mp-accept-subscription-terms" className="mp-customer-modal__terms-label">
                  <input
                    id="mp-accept-subscription-terms"
                    type="checkbox"
                    checked={acceptSubscriptionTerms}
                    onChange={(event) => {
                      setAcceptSubscriptionTerms(event.target.checked);
                      setCustomerFieldErrors((prev) => {
                        if (!prev.acceptTerms) return prev;
                        const next = { ...prev };
                        delete next.acceptTerms;
                        return next;
                      });
                    }}
                    aria-invalid={Boolean(customerFieldErrors.acceptTerms)}
                  />
                  <span>
                    I have read and agree to DigiRasa&apos;s{' '}
                    <Link to="/terms-and-conditions" target="_blank" rel="noopener noreferrer">
                      Terms and Conditions
                    </Link>
                    {' '}and{' '}
                    <Link to="/refund_returns" target="_blank" rel="noopener noreferrer">
                      Refund &amp; Cancellation Policy
                    </Link>
                    {' '}*
                  </span>
                </label>
                {customerFieldErrors.acceptTerms ? (
                  <p className="mp-field-error">{customerFieldErrors.acceptTerms}</p>
                ) : null}
              </div>
            </div>

            <div className="mp-customer-modal__footer">
              {subError ? <p className="mp-error mp-customer-modal__footer-error">{subError}</p> : null}
              <button
                type="button"
                className="mp-customer-modal__overview-btn"
                onClick={() => setSummaryPreviewOpen(true)}
                disabled={detailsPrefillBusy}
              >
                View subscription summary
              </button>
              <button type="button" className="mp-cancel-edit" onClick={() => setDetailsModalOpen(false)} disabled={apiBusy}>
                Cancel
              </button>
              <button type="button" className="btn-primary" onClick={createSubscription} disabled={apiBusy || detailsPrefillBusy}>
                {apiBusy ? 'Saving...' : (editingSubscriptionId ? 'UPDATE SUBSCRIPTION' : 'CREATE SUBSCRIPTION')}
              </button>
            </div>
          </div>
        </div>
      )}

      <SubscriptionReceiptModal
        open={invoiceModalOpen && Boolean(invoiceData)}
        invoiceData={invoiceData}
        onClose={() => setInvoiceModalOpen(false)}
        title="Request Received!"
      />

      {builderOnly ? (
        <SubscriptionSummaryPreviewModal
          open={summaryPreviewOpen}
          onClose={() => setSummaryPreviewOpen(false)}
          payload={summaryPreviewOpen ? toSubscriptionPayload() : null}
          slotLabelById={slotLabelById}
        />
      ) : null}

      {builderOnly ? (
        <AddItemsPickerModal
          open={productModalOpen}
          onClose={() => {
            setProductModalOpen(false);
            setBuilderPickerEntryId(null);
          }}
          specialtyPlans={specialtyCatalogPlans}
          pickerIntent={builderPickerIntent}
          editingProductId={builderPickerEntryId}
          builderPickerPlanId={builderPickerPlanId}
          builderPickerSlotId={builderPickerSlotId}
          setBuilderPickerPlanId={setBuilderPickerPlanId}
          builderPickerMode={builderPickerMode}
          setBuilderPickerMode={setBuilderPickerMode}
          setBuilderPickerSlotId={setBuilderPickerSlotId}
          slotDraftProducts={slotDraftProducts}
          subscriptionProducts={subscriptionProducts}
          ourMenuProductsLoading={ourMenuProductsLoading}
          otherSlotProductMap={OTHER_SLOT_PRODUCT_MAP}
          onAddOtherProduct={addAlacarteProductToSlot}
          onRemoveOtherProduct={removeSlotDraftProduct}
          useOrganicPricing={useOrganicPricing}
          setUseOrganicPricing={setUseOrganicPricing}
          specialtyRegionKey={specialtyRegionKey}
          setSpecialtyRegionKey={setSpecialtyRegionKey}
          selectedPlanPrice={selectedPlan.price}
          onMealClick={setBuilderItemDetail}
          onAddFullPackage={addFullSpecialtyPackage}
          onApplySpecialtySlot={applySpecialtySlotToDraft}
          buildSpecialtySlotDraftProduct={buildSpecialtySlotDraftProduct}
        />
      ) : null}

      {builderItemDetail ? (
        <div className="mp-item-detail-popover" role="dialog" aria-modal="true" onClick={(e) => { if (e.target === e.currentTarget) setBuilderItemDetail(null); }}>
          <div className="mp-item-detail-popover__card">
            <button type="button" className="mp-item-detail-popover__close" onClick={() => setBuilderItemDetail(null)} aria-label="Close">
              <FaTimes />
            </button>
            <div className="mp-item-detail-popover__head">
              {builderItemDetail.image ? <img src={builderItemDetail.image} alt={builderItemDetail.name} /> : <span><FaInfoCircle /></span>}
              <div>
                <h3>{builderItemDetail.name}</h3>
                <p>{builderItemDetail.category || 'Menu item'}</p>
              </div>
            </div>
            <div className="mp-item-detail-popover__body">
              <p><span>Slot</span><strong>{builderItemDetail.slotLabel || '-'}</strong></p>
              {builderItemDetail.isOrganic != null ? (
                <p><span>Meal type</span><strong>{builderItemDetail.isOrganic ? 'Organic' : 'Regular'}</strong></p>
              ) : null}
              <p><span>Price</span><strong>Rs. {builderItemDetail.price || 0}</strong></p>
              <p><span>Available</span><strong>{builderItemDetail.availability || 'All days'}</strong></p>
              {builderItemDetail.portion ? <p><span>Portion</span><strong>{builderItemDetail.portion}</strong></p> : null}
              {builderItemDetail.calories ? <p><span>Calories</span><strong>{builderItemDetail.calories}</strong></p> : null}
              {builderItemDetail.description ? <p className="mp-item-detail-popover__desc">{builderItemDetail.description}</p> : null}
            </div>
          </div>
        </div>
      ) : null}

      {deleteConfirmItem ? (
        <div className="mp-confirm-modal" role="dialog" aria-modal="true" onClick={(e) => { if (e.target === e.currentTarget) setDeleteConfirmItem(null); }}>
          <div className="mp-confirm-modal__card">
            <h3>Remove item?</h3>
            <p>
              Remove <strong>{deleteConfirmItem.itemName}</strong> from {deleteConfirmItem.slotLabel}?
            </p>
            <div className="mp-confirm-modal__actions">
              <button type="button" className="mp-cancel-edit" onClick={() => setDeleteConfirmItem(null)}>
                Cancel
              </button>
              <button type="button" className="mp-confirm-modal__danger" onClick={confirmRemoveSlotDraftProduct}>
                Remove
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {clearAllConfirmOpen ? (
        <div className="mp-confirm-modal" role="dialog" aria-modal="true" onClick={(e) => { if (e.target === e.currentTarget) setClearAllConfirmOpen(false); }}>
          <div className="mp-confirm-modal__card">
            <h3>Clear all items?</h3>
            <p>
              This will remove all {builderSlotItemCount} item{builderSlotItemCount === 1 ? '' : 's'} from every delivery slot so you can start fresh. Your plan and dates will stay unchanged.
            </p>
            <div className="mp-confirm-modal__actions">
              <button type="button" className="mp-cancel-edit" onClick={() => setClearAllConfirmOpen(false)}>
                Cancel
              </button>
              <button type="button" className="mp-confirm-modal__danger" onClick={clearAllSlotDraftItems}>
                Clear all
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {/* Product Selection Modal */}
      {productModalOpen && !builderOnly && (
        <div className="mp-product-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) setProductModalOpen(false); }}>
          <div className="mp-product-modal">

            {/* Modal Header */}
            <div className="mp-product-modal__header">
              <div>
                <h3>Add Products</h3>
                <p>Select items to include in your subscription</p>
              </div>
              <button className="mp-product-modal__close" onClick={() => setProductModalOpen(false)} aria-label="Close">✕</button>
            </div>

            {/* Modal Body: sidebar + grid */}
            <div className="mp-product-modal__body">

              {/* Category Sidebar */}
              <div className="mp-product-modal__sidebar">
                <p className="mp-modal-sidebar__label">Categories</p>
                {productCategories.map((cat) => {
                  const count = cat === 'All' ? productCatalog.length : productCatalog.filter((p) => p.category === cat).length;
                  return (
                    <button
                      key={cat}
                      type="button"
                      className={`mp-modal-cat-btn${productFilter === cat ? ' mp-modal-cat-btn--active' : ''}`}
                      onClick={() => setProductFilter(cat)}
                    >
                      <span>{cat}</span>
                      <span className="mp-modal-cat-count">{count}</span>
                    </button>
                  );
                })}
              </div>

              {/* Scrollable Product Grid */}
              <div className="mp-product-modal__scroll">
                <div className="mp-product-modal__grid">
                  {productCatalog
                    .filter((p) => productFilter === 'All' || p.category === productFilter)
                    .map((product) => {
                      const inDraft = draftProducts.find((item) => item.id === product.id);
                      const displayPrice = product.isSpecialtyBundle && useOrganicPricing
                        ? product.priceOrganic
                        : product.price;
                      return (
                        <div key={product.id} className={`mp-modal-product-card${inDraft ? ' mp-modal-product-card--selected' : ''}${product.isSpecialtyBundle ? ' mp-modal-product-card--specialty' : ''}`}>
                          {product.image ? (
                            <img src={product.image} alt={product.name} />
                          ) : (
                            <div className="mp-modal-product-card__placeholder">Plan</div>
                          )}
                          <div className="mp-modal-product-card__info">
                            <p className="mp-modal-product-card__name">{product.name}</p>
                            <p className="mp-modal-product-card__cat">{product.category}</p>
                            {product.description ? (
                              <p className="mp-modal-product-card__desc">{product.description}</p>
                            ) : null}
                            <div className="mp-modal-product-card__footer">
                              <strong>Rs. {displayPrice}{product.isSpecialtyBundle ? '/day' : ''}</strong>
                              {inDraft ? (
                                <div className="mp-product-qty-row">
                                  <button type="button" onClick={() => changeDraftQty(product.id, inDraft.quantity - 1)}><FaMinus /></button>
                                  <span>{inDraft.quantity}</span>
                                  <button type="button" onClick={() => changeDraftQty(product.id, inDraft.quantity + 1)}><FaPlus /></button>
                                </div>
                              ) : (
                                <button type="button" className="mp-modal-add-btn" onClick={() => addProductToDraft(product)}>
                                  <FaPlus /> Add
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="mp-product-modal__footer">
              <span>{draftProducts.length} product{draftProducts.length !== 1 ? 's' : ''} selected
                {draftProducts.length > 0 && (
                  <span className="mp-modal-footer__total"> · Rs. {draftProducts.reduce((s, i) => s + i.price * i.quantity, 0)} / delivery</span>
                )}
              </span>
              <button type="button" className="btn-primary" onClick={() => setProductModalOpen(false)}>
                Done
              </button>
            </div>

          </div>
        </div>
      )}

      {/* ── Slot Manager Modal ────────────────────────────────── */}
      {slotModalSub && (() => {
        const sub        = slotModalSub;
        const allSlots   = computeSlots(sub);
        const now = new Date();
        const today      = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
        const pausedSet  = getPausedSet(sub.id);
        const delivered  = allSlots.filter(s => {
          const parts = s.date.split('-');
          const d = new Date(Date.UTC(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2])));
          return d < today;
        }).length;
        const upcoming   = allSlots.filter(s => {
          const parts = s.date.split('-');
          const d = new Date(Date.UTC(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2])));
          return d >= today;
        });
        const pausedCnt  = upcoming.filter(s => pausedSet.has(s.date)).length;
        const pending    = upcoming.length - pausedCnt;
        const dows       = [...new Set(allSlots.map(s => s.dayName))];

        const filtered = allSlots.filter(s => {
          const parts = s.date.split('-');
          const d = new Date(Date.UTC(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2])));
          if (slotFilter === 'upcoming')  return d >= today;
          if (slotFilter === 'delivered') return d < today;
          if (slotFilter === 'paused')    return pausedSet.has(s.date);
          return true; // 'all'
        });

        return (
          <div className="mp-slot-modal-overlay" onClick={e => { if (e.target === e.currentTarget) setSlotModalSub(null); }}>
            <div className="mp-slot-modal">

              {/* Header */}
              <div className="mp-slot-modal__header">
                <div>
                  <h3>{sub.title}</h3>
                  <p>{sub.planLabel}{sub.scheduleLabel && !isBuilderSubscriptionPayload(sub) ? ` — ${sub.scheduleLabel}` : ''}</p>
                </div>
                <button className="mp-slot-modal__close" onClick={() => setSlotModalSub(null)}><FaTimes /></button>
              </div>

              {/* Stats bar */}
              <div className="mp-slot-modal__stats">
                <div className="mp-sm-stat mp-sm-stat--total"><span>{allSlots.length}</span>Total</div>
                <div className="mp-sm-stat mp-sm-stat--delivered"><span>{delivered}</span>Delivered</div>
                <div className="mp-sm-stat mp-sm-stat--pending"><span>{pending}</span>Pending</div>
                <div className="mp-sm-stat mp-sm-stat--paused"><span>{pausedCnt}</span>Paused</div>
              </div>

              {/* Quick Actions */}
              <div className="mp-slot-modal__quick">
                <p className="mp-slot-modal__quick-title">Quick Actions</p>
                <div className="mp-slot-modal__quick-row">
                  <button onClick={() => pauseSlotsRange(sub.id, 1)}>Pause Tomorrow</button>
                  <button onClick={() => pauseSlotsRange(sub.id, 7)}>Pause Next 7 Days</button>
                  <button onClick={() => pauseSlotsRange(sub.id, 30)}>Pause Next 30 Days</button>
                  <button onClick={() => resumeAllSlots(sub.id)} className="mp-slot-quick--resume">
                    <FaPlay /> Resume All
                  </button>
                </div>
                <div className="mp-slot-modal__dow-row">
                  <label>Pause by day:</label>
                  <select value={pauseDowPick} onChange={e => setPauseDowPick(e.target.value)}>
                    <option value="">— Select Day —</option>
                    {dows.map(d => <option key={d} value={d}>{d}</option>)}
                  </select>
                  <button
                    disabled={!pauseDowPick}
                    onClick={() => { pauseByDow(sub.id, pauseDowPick); setPauseDowPick(''); }}
                  >
                    Apply
                  </button>
                </div>
              </div>

              {/* Filter tabs */}
              <div className="mp-slot-modal__filters">
                {['upcoming','delivered','paused','all'].map(f => (
                  <button
                    key={f}
                    className={slotFilter === f ? 'mp-sf-tab mp-sf-tab--active' : 'mp-sf-tab'}
                    onClick={() => setSlotFilter(f)}
                  >
                    {f.charAt(0).toUpperCase() + f.slice(1)}
                    {f === 'paused' && pausedCnt > 0 && <span className="mp-sf-badge">{pausedCnt}</span>}
                  </button>
                ))}
              </div>

              {/* Slot list */}
              <div className="mp-slot-list">
                {filtered.length === 0 && (
                  <p className="mp-muted mp-slot-empty">No slots in this view.</p>
                )}
                {filtered.map(s => {
                  const isPaused    = pausedSet.has(s.date);
                  const parts = s.date.split('-');
                  const d = new Date(Date.UTC(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2])));
                  const isDelivered = d < today;
                  return (
                    <div
                      key={s.date}
                      className={`mp-slot-item${isPaused ? ' mp-slot-item--paused' : ''}${isDelivered ? ' mp-slot-item--delivered' : ''}`}
                    >
                      <div className="mp-slot-item__date">
                        <strong>{s.label}</strong>
                        <span className="mp-slot-item__day">{s.dayName}</span>
                      </div>
                      <div className="mp-slot-item__badge">
                        {isDelivered
                          ? <span className="mp-slot-badge mp-slot-badge--done"><FaCheckCircle /> Delivered</span>
                          : isPaused
                            ? <span className="mp-slot-badge mp-slot-badge--paused"><FaBan /> Paused</span>
                            : <span className="mp-slot-badge mp-slot-badge--pending">Scheduled</span>
                        }
                      </div>
                      {!isDelivered && (
                        <button
                          className={`mp-slot-toggle${isPaused ? ' mp-slot-toggle--resume' : ''}`}
                          onClick={() => toggleSlot(sub.id, s.date)}
                        >
                          {isPaused ? <><FaPlay /> Resume</> : <><FaBan /> Pause</>}
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>

            </div>
          </div>
        );
      })()}

      {!builderOnly ? (
        <>
      {/* Why Subscribe */}
      <section className="mp-why">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Benefits</span>
            <h2 className="section-title">WHY <span>SUBSCRIBE?</span></h2>
          </div>
          <div className="mp-why__grid">
            <div className="mp-why-card">
              <div className="mp-why-card__icon"><FaWallet /></div>
              <h4>Save Money</h4>
              <p>Save up to RS. 50 per meal compared to one-time orders with our long-term plans.</p>
            </div>
            <div className="mp-why-card">
              <div className="mp-why-card__icon"><FaLeaf /></div>
              <h4>Fresh &amp; Healthy</h4>
              <p>Every meal is freshly prepared with quality ingredients and no preservatives.</p>
            </div>
            <div className="mp-why-card">
              <div className="mp-why-card__icon"><FaMotorcycle /></div>
              <h4>Free Delivery</h4>
              <p>
                Free delivery within 2 km under 30 days, and within 5 km on 30+ day plans.
                Charges apply beyond the applicable radius.
              </p>
            </div>
            <div className="mp-why-card">
              <div className="mp-why-card__icon"><FaCalendarAlt /></div>
              <h4>52 Dishes / Month</h4>
              <p>A rotating menu of 52 curated dishes so you never eat the same meal twice.</p>
            </div>
            <div className="mp-why-card">
              <div className="mp-why-card__icon"><FaPauseCircle /></div>
              <h4>Pause Anytime</h4>
              <p>Traveling or taking a break? Pause or cancel your plan easily from the app.</p>
            </div>
            <div className="mp-why-card">
              <div className="mp-why-card__icon"><FaUserTie /></div>
              <h4>Expert Chefs</h4>
              <p>Prepared by professional chefs using traditional recipes and fresh produce.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="mp-faq">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Questions</span>
            <h2 className="section-title">FREQUENTLY ASKED <span>QUESTIONS</span></h2>
          </div>
          <div className="mp-faq__list">
            {faqs.map((item, i) => (
              <div
                key={i}
                className={`mp-faq__item${openFaq === i ? ' mp-faq__item--open' : ''}`}
              >
                <button
                  className="mp-faq__question"
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                >
                  {item.q}
                  <span className="mp-faq__icon">{openFaq === i ? '−' : '+'}</span>
                </button>
                {openFaq === i && (
                  <div className="mp-faq__answer">{item.a}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

        </>
      ) : null}

      {specialtyDetailPlan ? (
        <SpecialtyPlanDetailModal
          plan={specialtyDetailPlan}
          onClose={() => setSpecialtyDetailPlan(null)}
        />
      ) : null}

      {slotSampleModal && activeSpecialtyPlan ? (
        <div className="sp-modal-overlay" role="presentation" onClick={(e) => { if (e.target === e.currentTarget) setSlotSampleModal(null); }}>
          <div className="sp-modal sp-modal--wide sp-modal--table mp-slot-sample-modal" role="dialog">
            <header className="sp-modal__header">
              <div>
                <MealSlotBadge slotId={slotSampleModal.slotId} slot={slotSampleModal.slotLabel} />
                <h2 style={{ marginTop: 10 }}>{activeSpecialtyPlan.name}</h2>
                <p>Weekly menu by day</p>
              </div>
              <button type="button" className="sp-modal__close" onClick={() => setSlotSampleModal(null)} aria-label="Close">
                <FaTimes />
              </button>
            </header>
            <div className="sp-modal__body sp-modal__body--flush">
              <WeeklyMenuTable
                plan={activeSpecialtyPlan}
                singleSlotId={slotSampleModal.slotId}
              />
            </div>
            <footer className="sp-modal__footer">
              <button type="button" className="btn-primary" onClick={() => setSlotSampleModal(null)}>Close</button>
            </footer>
          </div>
        </div>
      ) : null}

      {!builderOnly ? (
        <>
          {/* App Download */}
          <AppDownloadSection />
        </>
      ) : null}
    </div>
  );
};

export default MealPlans;
